{
  "el-GR": {
    "grid": {
      "EmptyRecord": "Δεν υπάρχουν εγγραφές για εμφάνιση",
      "True": "πιστός",
      "False": "ψεύτικος",
      "InvalidFilterMessage": "Μη έγκυρα δεδομένα φίλτρου",
      "GroupDropArea": "Σύρετε μια κεφαλίδα στήλης εδώ για να ομαδοποιήσετε τη στήλη της",
      "UnGroup": "Κάντε κλικ εδώ για να καταργήσετε την ομαδοποίηση",
      "GroupDisable": "Η ομαδοποίηση είναι απενεργοποιημένη για αυτήν τη στήλη",
      "FilterbarTitle": "\"s κελί γραμμής φίλτρου",
      "EmptyDataSourceError": "Το DataSource δεν πρέπει να είναι κενό κατά την αρχική φόρτωση, καθώς οι στήλες δημιουργούνται από το dataSource στο πλέγμα στηλών AutoGenerate",
      "Add": "Προσθέτω",
      "Edit": "Επεξεργασία",
      "Cancel": "Ακυρώνω",
      "Update": "Ενημερώνω",
      "Delete": "Διαγράφω",
      "Print": "Τυπώνω",
      "Pdfexport": "Εξαγωγή PDF",
      "Excelexport": "Εξαγωγή Excel",
      "Wordexport": "Εξαγωγή Word",
      "Csvexport": "Εξαγωγή CSV",
      "Search": "Αναζήτηση",
      "Columnchooser": "Στήλες",
      "Save": "Σώζω",
      "Item": "είδος",
      "Items": "Στοιχεία",
      "EditOperationAlert": "Δεν έχουν επιλεγεί εγγραφές για λειτουργία επεξεργασίας",
      "DeleteOperationAlert": "Δεν έχουν επιλεγεί εγγραφές για λειτουργία διαγραφής",
      "SaveButton": "Σώζω",
      "OKButton": "OK",
      "CancelButton": "Ακυρώνω",
      "EditFormTitle": "Λεπτομέρειες σχετικά με ",
      "AddFormTitle": "Προσθήκη νέας εγγραφής",
      "BatchSaveConfirm": "Είστε βέβαιοι ότι θέλετε να αποθηκεύσετε τις αλλαγές;",
      "BatchSaveLostChanges": "Οι μη αποθηκευμένες αλλαγές θα χαθούν. Είστε σίγουροι ότι θέλετε να συνεχίσετε;",
      "ConfirmDelete": "Είστε βέβαιοι ότι θέλετε να διαγράψετε την εγγραφή;",
      "CancelEdit": "Είστε βέβαιοι ότι θέλετε να ακυρώσετε τις αλλαγές;",
      "ChooseColumns": "Επιλέξτε Στήλη",
      "SearchColumns": "Στήλες αναζήτησης",
      "Matchs": "Δεν βρέθηκαν αντιστοιχίες",
      "FilterButton": "Φίλτρο",
      "ClearButton": "Σαφής",
      "StartsWith": "Ξεκινά με",
      "EndsWith": "τελειώνει με",
      "Contains": "Περιέχει",
      "Equal": "Ίσος",
      "NotEqual": "Δεν είναι ίσος",
      "LessThan": "Λιγότερο από",
      "LessThanOrEqual": "Μικρότερο ή ίσο",
      "GreaterThan": "Μεγαλύτερο από",
      "GreaterThanOrEqual": "Μεγαλύτερο από ή ίσο",
      "ChooseDate": "Επιλέξτε ημερομηνία",
      "EnterValue": "Εισαγάγετε την τιμή",
      "Copy": "Αντίγραφο",
      "Group": "Ομαδοποίηση κατά αυτήν τη στήλη",
      "Ungroup": "Κατάργηση ομαδοποίησης κατά αυτήν τη στήλη",
      "autoFitAll": "Αυτόματη προσαρμογή σε όλες τις στήλες",
      "autoFit": "Αυτόματη προσαρμογή αυτής της στήλης",
      "Export": "Εξαγωγή",
      "FirstPage": "Αρχική Σελίδα",
      "LastPage": "Τελευταία Σελίδα",
      "PreviousPage": "Προηγούμενη σελίδα",
      "NextPage": "Επόμενη Σελίδα",
      "SortAscending": "Αύξουσα ταξινόμηση",
      "SortDescending": "Φθίνουσα ταξινόμηση",
      "EditRecord": "Επεξεργασία εγγραφής",
      "DeleteRecord": "Διαγραφή εγγραφής",
      "FilterMenu": "Φίλτρο",
      "SelectAll": "Επιλογή όλων",
      "Blanks": "Κενά",
      "FilterTrue": "Πιστός",
      "FilterFalse": "Ψεύτικος",
      "NoResult": "Δεν βρέθηκαν αντιστοιχίες",
      "ClearFilter": "Απαλοιφή φίλτρου",
      "NumberFilter": "Φίλτρα αριθμών",
      "TextFilter": "Φίλτρα κειμένου",
      "DateFilter": "Φίλτρα ημερομηνίας",
      "DateTimeFilter": "Φίλτρα ημερομηνίας/ώρας",
      "MatchCase": "Υπόθεση αγώνα",
      "Between": "Ανάμεσα",
      "CustomFilter": "Προσαρμοσμένο φίλτρο",
      "CustomFilterPlaceHolder": "Εισαγάγετε την τιμή",
      "CustomFilterDatePlaceHolder": "Επιλέξτε ημερομηνία",
      "AND": "ΚΑΙ",
      "OR": "Ή",
      "ShowRowsWhere": "Εμφάνιση σειρών όπου:",
      "AddCurrentSelection": "Προσθήκη τρέχουσας επιλογής στο φιλτράρισμα",
      "UnGroupButton": "Κάντε κλικ εδώ για να καταργήσετε την ομαδοποίηση",
      "AutoFitAll": "Αυτόματη προσαρμογή όλων των στηλών",
      "AutoFit": "Αυτόματη προσαρμογή αυτής της στήλης",
      "Clear": "Σαφής",
      "FilterMenuDialogARIA": "Παράθυρο διαλόγου μενού φίλτρου",
      "ExcelFilterDialogARIA": "Παράθυρο διαλόγου φίλτρου Excel",
      "DialogEditARIA": "Παράθυρο διαλόγου \"Επεξεργασία\"",
      "ColumnChooserDialogARIA": "Παράθυρο διαλόγου επιλογής στηλών",
      "ColumnMenuDialogARIA": "Παράθυρο διαλόγου μενού στήλης",
      "CustomFilterDialogARIA": "Παράθυρο διαλόγου προσαρμοσμένου φίλτρου",
      "SortAtoZ": "Ταξινόμηση από το Α έως το Ω",
      "SortZtoA": "Ταξινόμηση από το Ω στο Α",
      "SortByOldest": "Ταξινόμηση κατά παλαιότερο",
      "SortByNewest": "Ταξινόμηση κατά Νεότερο",
      "SortSmallestToLargest": "Ταξινόμηση από το μικρότερο στο μεγαλύτερο",
      "SortLargestToSmallest": "Ταξινόμηση από το μεγαλύτερο στο μικρότερο",
      "Sort": "Είδος",
      "FilterDescription": "Πατήστε Alt Down για να ανοίξετε το φίλτρο Menu",
      "SortDescription": "Πατήστε Enter για ταξινόμηση",
      "ColumnMenuDescription": "Πατήστε Alt Down για να ανοίξετε το μενού στηλών",
      "GroupDescription": "Πατήστε το πλήκτρο Ctrl για ομαδοποίηση",
      "ColumnHeader": " Κεφαλίδα στήλης ",
      "TemplateCell": " είναι κελί προτύπου",
      "CommandColumnAria": "είναι Κεφαλίδα στήλης στήλης εντολών ",
      "DialogEdit": "Επεξεργασία παραθύρου διαλόγου",
      "ClipBoard": "πρόχειρο",
      "GroupButton": "Κουμπί ομαδοποίησης",
      "UnGroupAria": "Κουμπί κατάργησης ομαδοποίησης",
      "GroupSeperator": "Διαχωριστικό για τις ομαδοποιημένες στήλες",
      "UnGroupIcon": "Κατάργηση ομαδοποίησης της ομαδοποιημένης στήλης ",
      "GroupedSortIcon": "Ταξινόμηση της ομαδοποιημένης στήλης ",
      "GroupedDrag": "Σύρετε την ομαδοποιημένη στήλη",
      "GroupCaption": " είναι κελί GroupCaption",
      "CheckBoxLabel": "πλαίσιο ελέγχου"
    },
    "pager": {
      "currentPageInfo": "{0} {1} σελίδων",
      "totalItemsInfo": "({0} αντικείμενα)",
      "firstPageTooltip": "Μετάβαση στην πρώτη σελίδα",
      "lastPageTooltip": "Μετάβαση στην τελευταία σελίδα",
      "nextPageTooltip": "Μετάβαση στην επόμενη σελίδα",
      "previousPageTooltip": "Μετάβαση στην προηγούμενη σελίδα",
      "nextPagerTooltip": "Μετάβαση στα επόμενα στοιχεία τηλεειδοποίησης",
      "previousPagerTooltip": "Μετάβαση σε προηγούμενα στοιχεία τηλεειδοποίησης",
      "pagerDropDown": "Προϊόντα ανά σελίδα",
      "pagerAllDropDown": "Στοιχεία",
      "All": "Όλοι",
      "totalItemInfo": "({0} στοιχείο)",
      "Container": "Δοχείο σελιδοποίησης",
      "Information": "Πληροφορίες Pager",
      "ExternalMsg": "Εξωτερικό μήνυμα σελιδοποίησης",
      "Page": "Σελίδα ",
      "Of": " από ",
      "Pages": " Σελίδες"
    },
    "kanban": {
      "items": "Στοιχεία",
      "min": "Λεπτά",
      "max": "Μέγιστο",
      "cardsSelected": "Επιλεγμένες κάρτες",
      "addTitle": "Προσθήκη νέας κάρτας",
      "editTitle": "Επεξεργασία στοιχείων κάρτας",
      "deleteTitle": "Διαγραφή κάρτας",
      "deleteContent": "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την κάρτα;",
      "save": "Σώζω",
      "delete": "Διαγράφω",
      "cancel": "Ακυρώνω",
      "yes": "Ναι",
      "no": "Όχι",
      "close": "Κλείνω",
      "noCard": "Δεν υπάρχουν κάρτες για εμφάνιση",
      "unassigned": "Μη εκχωρημένο"
    },
    "dropdowns": {
      "noRecordsTemplate": "Δεν βρέθηκαν εγγραφές",
      "actionFailureTemplate": "Η αίτηση απέτυχε",
      "overflowCountTemplate": "+${count} περισσότερα..",
      "selectAllText": "Επιλογή όλων",
      "unSelectAllText": "Κατάργηση επιλογής όλων",
      "totalCountTemplate": "${count} επιλεγμένο"
    },
    "drop-down-list": {
      "noRecordsTemplate": "Δεν βρέθηκαν εγγραφές",
      "actionFailureTemplate": "Η αίτηση απέτυχε"
    },
    "combo-box": {
      "noRecordsTemplate": "Δεν βρέθηκαν εγγραφές",
      "actionFailureTemplate": "Η αίτηση απέτυχε"
    },
    "auto-complete": {
      "noRecordsTemplate": "Δεν βρέθηκαν εγγραφές",
      "actionFailureTemplate": "Η αίτηση απέτυχε"
    },
    "multi-select": {
      "noRecordsTemplate": "Δεν βρέθηκαν εγγραφές",
      "actionFailureTemplate": "Η αίτηση απέτυχε",
      "overflowCountTemplate": "+${count} περισσότερα..",
      "selectAllText": "Επιλογή όλων",
      "unSelectAllText": "Κατάργηση επιλογής όλων",
      "totalCountTemplate": "${count} επιλεγμένο"
    },
    "listbox": {
      "noRecordsTemplate": "Δεν βρέθηκαν εγγραφές",
      "actionFailureTemplate": "Η αίτηση απέτυχε",
      "selectAllText": "Επιλογή όλων",
      "unSelectAllText": "Κατάργηση επιλογής όλων",
      "moveUp": "Μετακίνηση προς τα επάνω",
      "moveDown": "Μετακίνηση προς τα κάτω",
      "moveTo": "Μετακίνηση σε",
      "moveFrom": "Μετακίνηση από",
      "moveAllTo": "Μετακίνηση όλων σε",
      "moveAllFrom": "Μετακίνηση όλων από"
    },
    "spreadsheet": {
      "InsertingEmptyValue": "Η τιμή αναφοράς δεν είναι έγκυρη.",
      "FindValue": "Εύρεση αξίας",
      "ReplaceValue": "Αντικατάσταση τιμής",
      "FindReplaceTooltip": "Εύρεση &; Αντικατάσταση",
      "ByRow": "Κατά σειρές",
      "ByColumn": "Ανά στήλες",
      "MatchExactCellElements": "Ταίριασμα ολόκληρων περιεχομένων κελιού",
      "EnterCellAddress": "Εισαγάγετε τη διεύθυνση κελιού",
      "FindAndReplace": "Εύρεση και αντικατάσταση",
      "ReplaceAllEnd": " αγώνες που αντικαταστάθηκαν με ",
      "FindNextBtn": "Εύρεση επόμενου",
      "FindPreviousBtn": "Εύρεση προηγούμενου",
      "ReplaceBtn": "Αντικαθιστώ",
      "ReplaceAllBtn": "Αντικατάσταση όλων",
      "GotoHeader": "Πήγαινε στο",
      "Sheet": "Φύλλο",
      "SearchWithin": "Αναζήτηση εντός",
      "SearchBy": "Αναζήτηση με βάση",
      "Reference": "Αναφορά",
      "Workbook": "Βιβλίο εργασίας",
      "NoElements": "Δεν μπορέσαμε να βρούμε αυτό που ψάχνατε.",
      "FindWhat": "Βρείτε τι",
      "ReplaceWith": "Αντικαταστήστε με",
      "FileName": "Όνομα αρχείου",
      "ExtendValidation": "Η επιλογή περιέχει ορισμένα κελιά χωρίς επικύρωση δεδομένων. Θέλετε να επεκτείνετε την επικύρωση σε αυτά τα κελιά;",
      "Yes": "Ναι",
      "No": "Όχι",
      "PROPER": "Μετατρέπει ένα κείμενο σε κεφαλαία. πρώτο γράμμα σε κεφαλαία και άλλα γράμματα σε πεζά.",
      "Cut": "Κόβω",
      "Copy": "Αντίγραφο",
      "Paste": "Πάστα",
      "PasteSpecial": "Ειδική επικόλληση",
      "All": "Όλοι",
      "Values": "Αξιεσ",
      "Formats": "Μορφές",
      "Font": "Κολυμβήθρα",
      "FontSize": "Μέγεθος γραμματοσειράς",
      "Bold": "Τολμηρός",
      "Italic": "Πλάγια γραφή",
      "Underline": "Υπογραμμίζω",
      "Strikethrough": "Διακριτή διαγραφή",
      "TextColor": "Χρώμα κειμένου",
      "FillColor": "Χρώμα γεμίσματος",
      "HorizontalAlignment": "Οριζόντια στοίχιση",
      "AlignLeft": "Στοίχιση αριστερά",
      "AlignCenter": "Κέντρο",
      "AlignRight": "Στοίχιση δεξιά",
      "VerticalAlignment": "Κατακόρυφη ευθυγράμμιση",
      "AlignTop": "Στοίχιση επάνω",
      "AlignMiddle": "Στοίχιση μέσης",
      "AlignBottom": "Στοίχιση κάτω μέρους",
      "MergeCells": "Συγχώνευση κελιών",
      "MergeAll": "Συγχώνευση όλων",
      "MergeHorizontally": "Οριζόντια συγχώνευση",
      "MergeVertically": "Συγχώνευση κάθετα",
      "Unmerge": "Κατάργηση συγχώνευσης",
      "UnmergeCells": "Κατάργηση συγχώνευσης κελιών",
      "SelectMergeType": "Επιλέξτε Τύπος συγχώνευσης",
      "MergeCellsAlert": "Η συγχώνευση κελιών θα διατηρήσει μόνο την ανώτερη αριστερή (Ανώτατη) τιμή. Συγχώνευση ούτως ή άλλως;",
      "PasteMergeAlert": "Δεν μπορούμε να το κάνουμε αυτό σε ένα κελί συγχώνευσης.",
      "Borders": "Σύνορο",
      "TopBorders": "Επάνω περιγράμματα",
      "LeftBorders": "Αριστερά σύνορα",
      "RightBorders": "Δεξιά σύνορα",
      "BottomBorders": "Κάτω περιγράμματα",
      "AllBorders": "Όλα τα σύνορα",
      "HorizontalBorders": "Οριζόντια περιγράμματα",
      "VerticalBorders": "Κάθετα περιγράμματα",
      "OutsideBorders": "Εκτός συνόρων",
      "InsideBorders": "Εντός συνόρων",
      "NoBorders": "Χωρίς σύνορα",
      "BorderColor": "Χρώμα περιγράμματος",
      "BorderStyle": "Στυλ περιγράμματος",
      "InsertFunction": "Λειτουργία εισαγωγής",
      "Insert": "Ενθέτω",
      "Delete": "Διαγράφω",
      "DuplicateSheet": "Αντίγραφο",
      "MoveRight": "Μετακίνηση δεξιά",
      "MoveLeft": "Μετακίνηση προς τα αριστερά",
      "Rename": "Μετονομάζω",
      "Hide": "Κρύβω",
      "NameBox": "Πλαίσιο ονόματος",
      "ShowHeaders": "Εμφάνιση κεφαλίδων",
      "HideHeaders": "Απόκρυψη κεφαλίδων",
      "ShowGridLines": "Εμφάνιση γραμμών πλέγματος",
      "HideGridLines": "Απόκρυψη γραμμών πλέγματος",
      "FreezePanes": "Πάγωμα υαλοπινάκων",
      "FreezeRows": "Σταθεροποίηση γραμμών",
      "FreezeColumns": "Σταθεροποίηση στηλών",
      "UnfreezePanes": "Ξεπάγωμα υαλοπινάκων",
      "UnfreezeRows": "Αποσταθεροποίηση γραμμών",
      "UnfreezeColumns": "Αποσταθεροποίηση στηλών",
      "AddSheet": "Προσθήκη φύλλου",
      "ListAllSheets": "Λίστα όλων των φύλλων",
      "CollapseToolbar": "Σύμπτυξη γραμμής εργαλείων",
      "ExpandToolbar": "Ανάπτυξη γραμμής εργαλείων",
      "CollapseFormulaBar": "Σύμπτυξη γραμμής τύπων",
      "ExpandFormulaBar": "Ανάπτυξη γραμμής τύπων",
      "File": "Αρχείο",
      "Home": "Σπίτι",
      "Formulas": "Τύπους",
      "View": "Άποψη",
      "New": "Νέος",
      "Open": "Ανοίγω",
      "SaveAs": "Αποθήκευση ως",
      "ExcelXlsx": "Microsoft Excel",
      "ExcelXls": "Το Microsoft Excel 97-2003",
      "CSV": "Τιμές διαχωρισμένες με κόμματα",
      "FormulaBar": "Γραμμή τύπων",
      "Sort": "Είδος",
      "SortAscending": "Αύξουσα",
      "SortDescending": "Φθίνουσα",
      "CustomSort": "Προσαρμοσμένη ταξινόμηση",
      "AddColumn": "Προσθήκη στήλης",
      "ContainsHeader": "Τα δεδομένα περιέχουν κεφαλίδα",
      "CaseSensitive": "Διάκριση πεζών-κεφαλαίων",
      "SortBy": "Ταξινόμηση κατά",
      "ThenBy": "Στη συνέχεια, από",
      "SelectAColumn": "Επιλογή στήλης",
      "SortEmptyFieldError": "Όλα τα κριτήρια ταξινόμησης πρέπει να έχουν καθορισμένη στήλη. Ελέγξτε τα επιλεγμένα κριτήρια ταξινόμησης και προσπαθήστε ξανά.",
      "SortDuplicateFieldError": " ταξινομείται κατά τιμές περισσότερες από μία φορές. Διαγράψτε τα κριτήρια διπλότυπης ταξινόμησης και προσπαθήστε ξανά.",
      "SortOutOfRangeError": "Επιλέξτε ένα κελί ή μια περιοχή μέσα στο χρησιμοποιούμενο εύρος και προσπαθήστε ξανά.",
      "MultiRangeSortError": "Αυτό δεν μπορεί να γίνει σε επιλογή πολλαπλών περιοχών. Επιλέξτε ένα μόνο εύρος και προσπαθήστε ξανά.",
      "HideRow": "Απόκρυψη γραμμής",
      "HideRows": "Απόκρυψη γραμμών",
      "UnhideRows": "Επανεμφάνιση γραμμών",
      "HideColumn": "Απόκρυψη στήλης",
      "HideColumns": "Απόκρυψη στηλών",
      "UnhideColumns": "Επανεμφάνιση στηλών",
      "InsertRow": "Εισαγωγή γραμμής",
      "InsertRows": "Εισαγωγή γραμμών",
      "Above": "Πάνω",
      "Below": "Κάτω",
      "InsertColumn": "Εισαγωγή στήλης",
      "InsertColumns": "Εισαγωγή στηλών",
      "Before": "Πριν",
      "After": "Μετά",
      "DeleteRow": "Διαγραφή γραμμής",
      "DeleteRows": "Διαγραφή γραμμών",
      "DeleteColumn": "Διαγραφή στήλης",
      "DeleteColumns": "Διαγραφή στηλών",
      "Ok": "OK",
      "Cancel": "Ακυρώνω",
      "Apply": "Εφαρμόζω",
      "MoreColors": "Περισσότερα χρώματα",
      "StandardColors": "Βασικά χρώματα",
      "General": "Γενικά",
      "Number": "Αριθμός",
      "Currency": "Νόμισμα",
      "Accounting": "Λογιστική",
      "ShortDate": "Σύντομη ημερομηνία",
      "LongDate": "Πλήρης ημερομηνία",
      "Time": "Ώρα",
      "Percentage": "Ποσοστό",
      "Fraction": "Κλάσμα",
      "Scientific": "Επιστημονικός",
      "Text": "Κείμενο",
      "NumberFormat": "Μορφή αριθμού",
      "MobileFormulaBarPlaceHolder": "Εισαγωγή τιμής ή τύπου",
      "PasteAlert": "Δεν μπορείτε να το επικολλήσετε εδώ, επειδή η περιοχή αντιγραφής και η περιοχή επικόλλησης δεν έχουν το ίδιο μέγεθος. Δοκιμάστε να επικολλήσετε σε διαφορετικό εύρος.",
      "DestroyAlert": "Είστε βέβαιοι ότι θέλετε να καταστρέψετε το τρέχον βιβλίο εργασίας χωρίς να αποθηκεύσετε και να δημιουργήσετε ένα νέο βιβλίο εργασίας;",
      "SheetRenameInvalidAlert": "Το όνομα φύλλου περιέχει μη έγκυρο χαρακτήρα.",
      "SheetRenameEmptyAlert": "Το όνομα φύλλου δεν μπορεί να είναι κενό.",
      "SheetRenameAlreadyExistsAlert": "Το όνομα φύλλου υπάρχει ήδη. Εισαγάγετε άλλο όνομα.",
      "DeleteSheetAlert": "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το φύλλο;",
      "DeleteSingleLastSheetAlert": "Ένα βιβλίο εργασίας πρέπει να περιέχει τουλάχιστον ένα ορατό φύλλο εργασίας.",
      "PickACategory": "Επιλέξτε κατηγορία",
      "Description": "Περιγραφή: __________",
      "UnsupportedFile": "Μη υποστηριζόμενο αρχείο",
      "DataLimitExceeded": "Τα δεδομένα αρχείων είναι πολύ μεγάλα και χρειάζεται περισσότερος χρόνος για επεξεργασία, θέλετε να συνεχίσετε;",
      "FileSizeLimitExceeded": "Το μέγεθος του αρχείου είναι πολύ μεγάλο και χρειάζεται περισσότερος χρόνος για την επεξεργασία, θέλετε να συνεχίσετε;",
      "InvalidUrl": "Μη έγκυρη διεύθυνση URL",
      "SUM": "Προσθέτει μια σειρά αριθμών ή/και κελιών.",
      "SUMIF": "Προσθέτει τα κελιά με βάση την καθορισμένη συνθήκη.",
      "SUMIFS": "Προσθέτει τα κελιά με βάση καθορισμένες συνθήκες.",
      "ABS": "Επιστρέφει την τιμή ενός αριθμού χωρίς το πρόσημό του.",
      "RAND": "Επιστρέφει έναν τυχαίο αριθμό μεταξύ 0 και 1.",
      "RANDBETWEEN": "Επιστρέφει έναν τυχαίο ακέραιο με βάση καθορισμένες τιμές.",
      "FLOOR": "Στρογγυλοποιεί έναν αριθμό προς τα κάτω στο πλησιέστερο πολλαπλάσιο ενός δεδομένου παράγοντα.",
      "CEILING": "Στρογγυλοποιεί έναν αριθμό προς τα επάνω στο πλησιέστερο πολλαπλάσιο ενός δεδομένου παράγοντα.",
      "PRODUCT": "Πολλαπλασιάζει μια σειρά αριθμών ή/και κελιών.",
      "AVERAGE": "Υπολογίζει τον μέσο όρο για τη σειρά αριθμών ή/και κελιών εκτός κειμένου.",
      "AVERAGEIF": "Υπολογίζει τον μέσο όρο για τα κελιά με βάση καθορισμένο κριτήριο.",
      "AVERAGEIFS": "Υπολογίζει τον μέσο όρο για τα κελιά με βάση καθορισμένες συνθήκες.",
      "AVERAGEA": "Υπολογίζει τον μέσο όρο για τα κελιά που αξιολογούν την τιμή TRUE ως 1, το κείμενο και τη συνάρτηση FALSE ως 0.",
      "COUNT": "Καταμετρά τα κελιά που περιέχουν αριθμητικές τιμές σε μια περιοχή.",
      "COUNTIF": "Καταμετρά τα κελιά με βάση την καθορισμένη συνθήκη.",
      "COUNTIFS": "Καταμετρά τα κελιά με βάση καθορισμένες συνθήκες.",
      "COUNTA": "Καταμετρά τα κελιά που περιέχουν τιμές σε μια περιοχή.",
      "MIN": "Επιστρέφει το μικρότερο αριθμό από τα συγκεκριμένα ορίσματα.",
      "MAX": "Επιστρέφει το μεγαλύτερο αριθμό των δεδομένων ορισμάτων.",
      "DATE": "Επιστρέφει την ημερομηνία με βάση το δεδομένο έτος, μήνα και ημέρα.",
      "DAY": "Επιστρέφει την ημέρα από τη δεδομένη ημερομηνία.",
      "DAYS": "Επιστρέφει τον αριθμό των ημερών μεταξύ δύο ημερομηνιών.",
      "IF": "Επιστρέφει τιμή με βάση τη δεδομένη παράσταση.",
      "IFS": "Επιστρέφει τιμή με βάση τις δεδομένες πολλαπλές εκφράσεις.",
      "CalculateAND": "Επιστρέφει την τιμή TRUE εάν όλα τα ορίσματα είναι TRUE, διαφορετικά επιστρέφει την τιμή FALSE.",
      "CalculateOR": "Επιστρέφει την τιμή TRUE εάν κάποιο από τα ορίσματα είναι TRUE, διαφορετικά επιστρέφει την τιμή FALSE.",
      "IFERROR": "Επιστρέφει τιμή εάν δεν βρεθεί σφάλμα, διαφορετικά θα επιστρέψει καθορισμένη τιμή.",
      "CHOOSE": "Επιστρέφει μια τιμή από τη λίστα τιμών, με βάση τον αριθμό ευρετηρίου.",
      "INDEX": "Επιστρέφει μια τιμή του κελιού σε μια δεδομένη περιοχή με βάση τον αριθμό γραμμής και στήλης.",
      "FIND": "Επιστρέφει τη θέση μιας συμβολοσειράς μέσα σε μια άλλη συμβολοσειρά, στην οποία γίνεται διάκριση πεζών-κεφαλαίων.",
      "CONCATENATE": "Συνδυάζει δύο ή περισσότερες συμβολοσειρές μαζί.",
      "CONCAT": "Συνενώνει μια λίστα ή μια περιοχή συμβολοσειρών κειμένου.",
      "SUBTOTAL": "Επιστρέφει μερικό άθροισμα για μια περιοχή χρησιμοποιώντας τον δεδομένο αριθμό συνάρτησης.",
      "RADIANS": "Μετατρέπει μοίρες σε ακτίνια.",
      "MATCH": "Επιστρέφει τη σχετική θέση μιας καθορισμένης τιμής σε δεδομένη περιοχή.",
      "SLOPE": "Επιστρέφει την κλίση της γραμμής από γραμμική παλινδρόμηση των σημείων δεδομένων.",
      "INTERCEPT": "Υπολογίζει το σημείο της γραμμής τομής Y μέσω γραμμικής παλινδρόμησης.",
      "UNIQUE": "Επιστρέφει μοναδικές τιμές από μια περιοχή ή έναν πίνακα",
      "TEXT": "Μετατρέπει μια τιμή σε κείμενο σε καθορισμένη μορφή αριθμού.",
      "DefineNameExists": "Αυτό το όνομα υπάρχει ήδη, δοκιμάστε διαφορετικό όνομα.",
      "CircularReference": "Όταν ένας τύπος αναφέρεται σε μία ή περισσότερες κυκλικές αναφορές, αυτό μπορεί να οδηγήσει σε εσφαλμένο υπολογισμό.",
      "SORT": "Ταξινομεί μια περιοχή ενός πίνακα",
      "T": "Ελέγχει εάν μια τιμή είναι κείμενο ή όχι και επιστρέφει το κείμενο.",
      "EXACT": "Ελέγχει εάν δύο συμβολοσειρές κειμένου είναι ακριβώς ίδιες και επιστρέφει TRUE ή FALSE.",
      "LEN": "Επιστρέφει έναν αριθμό χαρακτήρων σε μια δεδομένη συμβολοσειρά.",
      "MOD": "Επιστρέφει ένα υπόλοιπο μετά τη διαίρεση ενός αριθμού με διαιρέτη.",
      "ODD": "Στρογγυλοποιεί έναν θετικό αριθμό προς τα επάνω και έναν αρνητικό αριθμό προς τα κάτω στον πλησιέστερο περιττό ακέραιο.",
      "PI": "Επιστρέφει την τιμή του π.",
      "COUNTBLANK": "Επιστρέφει τον αριθμό των κενών κελιών σε μια καθορισμένη περιοχή κελιών.",
      "EVEN": "Στρογγυλοποιεί έναν θετικό αριθμό προς τα επάνω και έναν αρνητικό αριθμό προς τα κάτω στον πλησιέστερο άρτιο ακέραιο.",
      "DECIMAL": "Μετατρέπει μια αναπαράσταση κειμένου ενός αριθμού σε μια δεδομένη βάση σε δεκαδικό αριθμό.",
      "ADDRESS": "Επιστρέφει μια αναφορά κελιού ως κείμενο, δεδομένων των καθορισμένων αριθμών γραμμών και στηλών.",
      "CHAR": "Επιστρέφει το χαρακτήρα από τον καθορισμένο αριθμό.",
      "CODE": "Επιστρέφει τον αριθμητικό κωδικό για τον πρώτο χαρακτήρα μιας δεδομένης συμβολοσειράς.",
      "DOLLAR": "Μετατρέπει τον αριθμό σε κείμενο μορφοποιημένο με νομισματική μονάδα.",
      "SMALL": "Επιστρέφει την k-οστή μικρότερη τιμή σε έναν δεδομένο πίνακα.",
      "LARGE": "Επιστρέφει την k-οστή μεγαλύτερη τιμή σε έναν δεδομένο πίνακα.",
      "TIME": "Μετατρέπει ώρες, λεπτά, δευτερόλεπτα στο μορφοποιημένο κείμενο.",
      "DEGREES": "Μετατρέπει ακτίνια σε μοίρες.",
      "FACT": "Επιστρέφει το παραγοντικό ενός αριθμού.",
      "MEDIAN": "Επιστρέφει τη διάμεσο του δεδομένου συνόλου αριθμών.",
      "EDATE": "Επιστρέφει μια ημερομηνία με δεδομένο αριθμό μηνών πριν ή μετά την καθορισμένη ημερομηνία.",
      "DATEVALUE": "Μετατρέπει μια συμβολοσειρά ημερομηνίας σε τιμή ημερομηνίας.",
      "NOW": "Επιστρέφει την τρέχουσα ημερομηνία και ώρα.",
      "HOUR": "Επιστρέφει τον αριθμό των ωρών σε μια καθορισμένη χρονική συμβολοσειρά.",
      "MINUTE": "Επιστρέφει τον αριθμό των λεπτών σε μια καθορισμένη χρονική συμβολοσειρά.",
      "SECOND": "Επιστρέφει τον αριθμό των δευτερολέπτων σε μια καθορισμένη χρονική συμβολοσειρά.",
      "MONTH": "Επιστρέφει τον αριθμό των μηνών σε μια καθορισμένη συμβολοσειρά ημερομηνίας.",
      "OR": "Ή",
      "AND": "ΚΑΙ",
      "CustomFilterDatePlaceHolder": "Επιλέξτε ημερομηνία",
      "CustomFilterPlaceHolder": "Εισαγάγετε την τιμή",
      "CustomFilter": "Προσαρμοσμένο φίλτρο",
      "Between": "Ανάμεσα",
      "MatchCase": "Περίπτωση αγώνα",
      "DateTimeFilter": "Φίλτρα ημερομηνίας/ώρας",
      "Undo": "Καταστρέφω",
      "Redo": "Ξανακάνω",
      "ClearAllFilter": "Σαφής",
      "ReapplyFilter": "Εφαρμόστε ξανά",
      "DateFilter": "Φίλτρα ημερομηνίας",
      "TextFilter": "Φίλτρα κειμένου",
      "NumberFilter": "Φίλτρα αριθμών",
      "ClearFilter": "Απαλοιφή φίλτρου",
      "NoResult": "Δεν βρέθηκαν αντιστοιχίες",
      "FilterFalse": "Ψεύτικος",
      "FilterTrue": "Πιστός",
      "Blanks": "Κενά",
      "SelectAll": "Επιλογή όλων",
      "GreaterThanOrEqual": "Μεγαλύτερο από ή ίσο",
      "GreaterThan": "Μεγαλύτερο από",
      "LessThanOrEqual": "Μικρότερο ή ίσο",
      "LessThan": "Λιγότερο από",
      "NotEqual": "Δεν είναι ίσος",
      "Equal": "Ίσος",
      "Contains": "Περιέχει",
      "EndsWith": "τελειώνει με",
      "StartsWith": "Ξεκινά με",
      "ClearButton": "Σαφής",
      "FilterButton": "Φίλτρο",
      "CancelButton": "Ακυρώνω",
      "OKButton": "OK",
      "Search": "Αναζήτηση",
      "DataValidation": "Επικύρωση δεδομένων",
      "CellRange": "Περιοχή κελιών",
      "Allow": "Επιτρέπω",
      "Data": "Δεδομένα",
      "Minimum": "Ελάχιστος",
      "Maximum": "Μέγιστος",
      "IgnoreBlank": "Παράβλεψη κενού",
      "WholeNumber": "Ακέραιος αριθμός",
      "Decimal": "Δεκαδικός",
      "Date": "Ημερομηνία",
      "TextLength": "Μήκος κειμένου",
      "List": "Λίστα",
      "NotBetween": "Όχι μεταξύ",
      "EqualTo": "Ίσο με",
      "NotEqualTo": "Δεν είναι ίσο με",
      "GreaterThanOrEqualTo": "Μεγαλύτερο ή ίσο με",
      "LessThanOrEqualTo": "Μικρότερο ή ίσο με",
      "InCellDropDown": "Αναπτυσσόμενο μενού εντός κελιού",
      "Sources": "Πηγές",
      "Value": "Τιμή",
      "Retry": "Επανάληψη",
      "DialogError": "Η προέλευση λίστας πρέπει να είναι μια αναφορά σε μία γραμμή ή στήλη.",
      "MinMaxError": "Το μέγιστο πρέπει να είναι μεγαλύτερο ή ίσο με το ελάχιστο.",
      "Spreadsheet": "Λογιστικό φύλλο",
      "MoreValidation": "Αυτή η επιλογή περιέχει περισσότερες από μία επικυρώσεις. ",
      "FileNameError": "Ένα όνομα αρχείου δεν μπορεί να περιέχει χαρακτήρες όπως \\ / : * ? \" < > [ ] |",
      "ValidationError": "Αυτή η τιμή δεν ταιριάζει με τους περιορισμούς επικύρωσης δεδομένων που έχουν οριστεί για το κελί.",
      "ListLengthError": "Οι τιμές λίστας επιτρέπουν μόνο έως 256 χαρακτήρες",
      "ProtectSheet": "Προστασία φύλλου",
      "UnprotectSheet": "Κατάργηση προστασίας φύλλου",
      "SelectCells": "Επιλογή κλειδωμένων κελιών",
      "SelectUnlockedCells": "Επιλογή ξεκλείδωτων κελιών",
      "Save": "Σώζω",
      "EmptyFileName": "Το όνομα αρχείου δεν μπορεί να είναι κενό.",
      "LargeName": "Το όνομα είναι πολύ μεγάλο.",
      "FormatCells": "Μορφοποίηση κελιών",
      "FormatRows": "Μορφοποίηση γραμμών",
      "FormatColumns": "Μορφοποίηση στηλών",
      "InsertLinks": "Εισαγωγή συνδέσεων",
      "ProtectContent": "Προστατέψτε τα περιεχόμενα των κλειδωμένων κελιών",
      "ProtectAllowUser": " Επιτρέψτε σε όλους τους χρήστες αυτού του φύλλου εργασίας να:",
      "EditAlert": "Το κελί που προσπαθείτε να αλλάξετε προστατεύεται. Για να κάνετε αλλαγές, καταργήστε την προστασία του φύλλου.",
      "ClearValidation": "Εκκαθάριση επικύρωσης",
      "ISNUMBER": "Επιστρέφει true όταν η τιμή αναλύεται ως αριθμητική τιμή.",
      "ROUND": "Στρογγυλοποιεί έναν αριθμό σε έναν καθορισμένο αριθμό ψηφίων.",
      "GEOMEAN": "Επιστρέφει τον γεωμετρικό μέσο ενός πίνακα ή μιας περιοχής θετικών δεδομένων.",
      "POWER": "Επιστρέφει το αποτέλεσμα ενός αριθμού υψωμένου σε ισχύ",
      "LOG": "Επιστρέφει το λογάριθμο ενός αριθμού στη βάση που καθορίζετε.",
      "TRUNC": "Επιστρέφει την περικομμένη τιμή ενός αριθμού σε έναν καθορισμένο αριθμό δεκαδικών ψηφίων.",
      "EXP": "Επιστρέφει e υψωμένο στη δύναμη του δεδομένου αριθμού.",
      "HighlightCellsRules": "Κανόνες επισήμανσης κελιών",
      "CFEqualTo": "Ίσο με",
      "TextThatContains": "Κείμενο που περιέχει",
      "ADateOccuring": "Μια ημερομηνία που συμβαίνει",
      "DuplicateValues": "Διπλότυπες τιμές",
      "TopBottomRules": "Κανόνες επάνω/κάτω",
      "Top10Items": "Τα 10 κορυφαία αντικείμενα",
      "Top10": "Κορυφή 10",
      "Bottom10Items": "Κάτω 10 αντικείμενα",
      "Bottom10": "Κάτω 10",
      "AboveAverage": "Πάνω από το μέσο όρο",
      "BelowAverage": "Κάτω από το μέσο όρο",
      "FormatCellsGreaterThan": "Μορφοποίηση κελιών που είναι ΜΕΓΑΛΥΤΕΡΑ ΑΠΟ:",
      "FormatCellsLessThan": "Μορφοποίηση κελιών που είναι ΛΙΓΟΤΕΡΑ ΑΠΟ:",
      "FormatCellsBetween": "Μορφοποίηση κελιών που είναι ΜΕΤΑΞΥ:",
      "FormatCellsEqualTo": "Μορφοποίηση κελιών που είναι ίσα με:",
      "FormatCellsThatContainTheText": "Μορφοποίηση κελιών που περιέχουν το κείμενο:",
      "FormatCellsThatContainADateOccurring": "Μορφοποίηση κελιών που περιέχουν ημερομηνία:",
      "FormatCellsDuplicate": "Μορφοποίηση κελιών που περιέχουν:",
      "FormatCellsTop": "Μορφοποίηση κελιών που κατατάσσονται στην κορυφή της κορυφής:",
      "FormatCellsBottom": "Μορφοποίηση κελιών που κατατάσσονται στο ΚΑΤΩ:",
      "FormatCellsAbove": "Μορφοποίηση κελιών που είναι ΑΝΩ ΤΟΥ ΜΕΤΡΟΥ ΜΕΤΡΟΥ:",
      "FormatCellsBelow": "Μορφοποίηση κελιών που είναι ΚΑΤΩ ΑΠΟ ΤΟ ΜΕΤΡΙΟ:",
      "With": "με",
      "DataBars": "Γραμμές δεδομένων",
      "ColorScales": "Χρωματικές κλίμακες",
      "IconSets": "Σύνολα εικονιδίων",
      "ClearRules": "Σαφείς κανόνες",
      "SelectedCells": "Απαλοιφή κανόνων από επιλεγμένα κελιά",
      "EntireSheet": "Απαλοιφή κανόνων από ολόκληρο το φύλλο",
      "LightRedFillWithDarkRedText": "Ανοιχτό κόκκινο γέμισμα με σκούρο κόκκινο κείμενο",
      "YellowFillWithDarkYellowText": "Κίτρινο γέμισμα με σκούρο κίτρινο κείμενο",
      "GreenFillWithDarkGreenText": "Πράσινο γέμισμα με σκούρο πράσινο κείμενο",
      "RedFill": "Κόκκινο γέμισμα",
      "RedText": "Κόκκινο κείμενο",
      "Duplicate": "Αντίγραφο",
      "Unique": "Μοναδικός",
      "And": "και",
      "WebPage": "Ιστοσελίδα",
      "ThisDocument": "Αυτό το έγγραφο",
      "DisplayText": "Εμφάνιση κειμένου",
      "Url": "URL",
      "CellReference": "Αναφορά κελιού",
      "DefinedNames": "Καθορισμένα ονόματα",
      "EnterTheTextToDisplay": "Εισαγάγετε το κείμενο που θα εμφανίζεται",
      "EnterTheUrl": "Εισαγάγετε τη διεύθυνση URL",
      "INT": "Επιστρέφει έναν αριθμό στον πλησιέστερο ακέραιο.",
      "SUMPRODUCT": "Επιστρέφει το άθροισμα του γινομένου δεδομένων περιοχών πινάκων.",
      "TODAY": "Επιστρέφει την τρέχουσα ημερομηνία ως τιμή ημερομηνίας.",
      "ROUNDUP": "Στρογγυλοποιεί έναν αριθμό μακριά από το μηδέν.",
      "Link": "Σύνδεση",
      "Hyperlink": "Υπερ-σύνδεση",
      "EditHyperlink": "Επεξεργασία υπερ-σύνδεσης",
      "OpenHyperlink": "Άνοιγμα υπερ-σύνδεσης",
      "RemoveHyperlink": "Κατάργηση υπερ-σύνδεσης",
      "InvalidHyperlinkAlert": "Η διεύθυνση αυτού του ιστότοπου δεν είναι έγκυρη. Ελέγξτε τη διεύθυνση και προσπαθήστε ξανά.",
      "InsertLink": "Εισαγωγή συνδέσμου",
      "EditLink": "Επεξεργασία συνδέσμου",
      "WrapText": "Αναδίπλωση κειμένου",
      "Update": "Ενημερώνω",
      "SortAndFilter": "Ταξινόμηση &; Φιλτράρισμα",
      "Filter": "Φίλτρο",
      "FilterCellValue": "Φιλτράρισμα κατά τιμή επιλεγμένου κελιού",
      "FilterOutOfRangeError": "Επιλέξτε ένα κελί ή μια περιοχή μέσα στο χρησιμοποιούμενο εύρος και προσπαθήστε ξανά.",
      "ClearFilterFrom": "Απαλοιφή φίλτρου από ",
      "LN": "Επιστρέφει τον φυσικό λογάριθμο ενός αριθμού.",
      "DefineNameInValid": "Το όνομα που πληκτρολογήσατε δεν είναι έγκυρο.",
      "EmptyError": "Πρέπει να εισαγάγετε μια τιμή",
      "ClearHighlight": "Σαφής επισήμανση",
      "HighlightInvalidData": "Επισήμανση μη έγκυρων δεδομένων",
      "Clear": "Σαφής",
      "ClearContents": "Απαλοιφή περιεχομένων",
      "ClearAll": "Απαλοιφή όλων",
      "ClearFormats": "Απαλοιφή μορφών",
      "ClearHyperlinks": "Απαλοιφή υπερ-συνδέσεων",
      "Image": "Εικόνα",
      "ConditionalFormatting": "Μορφοποίηση",
      "BlueDataBar": "Μπλε γραμμή δεδομένων",
      "GreenDataBar": "Πράσινη γραμμή δεδομένων",
      "RedDataBar": "Κόκκινη γραμμή δεδομένων",
      "OrangeDataBar": "Πορτοκαλί γραμμή δεδομένων",
      "LightBlueDataBar": "Γαλάζια γραμμή δεδομένων",
      "PurpleDataBar": "Μωβ γραμμή δεδομένων",
      "GYRColorScale": "Κλίμακα Πράσινου - Κίτρινου - Κόκκινου Χρώματος",
      "RYGColorScale": "Κλίμακα χρώματος κόκκινου - κίτρινου - πράσινου",
      "GWRColorScale": "Κλίμακα Πράσινου - Λευκού - Κόκκινου",
      "RWGColorScale": "Κλίμακα χρώματος κόκκινου - λευκού - πράσινου",
      "BWRColorScale": "Μπλε - Λευκό - Κόκκινο Κλίμακα χρώματος",
      "RWBColorScale": "Κλίμακα χρώματος κόκκινου - λευκού - μπλε",
      "WRColorScale": "Κλίμακα λευκού - κόκκινου χρώματος",
      "RWColorScale": "Κλίμακα κόκκινου - λευκού χρώματος",
      "GWColorScale": "Κλίμακα Πράσινου - Λευκού Χρώματος",
      "WGColorScale": "Κλίμακα λευκού - πράσινου χρώματος",
      "GYColorScale": "Κλίμακα πράσινου - κίτρινου χρώματος",
      "YGColorScale": "Κλίμακα κίτρινου - πράσινου χρώματος",
      "ThreeArrowsColor": "3 βέλη (έγχρωμα)",
      "ThreeArrowsGray": "3 βέλη (γκρι)",
      "ThreeTriangles": "3 Τρίγωνα",
      "FourArrowsColor": "4 βέλη (γκρι)",
      "FourArrowsGray": "4 βέλη (έγχρωμα)",
      "FiveArrowsColor": "5 βέλη (γκρι)",
      "FiveArrowsGray": "5 βέλη (έγχρωμα)",
      "ThreeTrafficLights1": "3 Φανάρια (Unrimmed)",
      "ThreeTrafficLights2": "3 Φανάρια (Rimmed)",
      "ThreeSigns": "3 Σημάδια",
      "FourTrafficLights": "4 Φωτεινοί σηματοδότες",
      "RedToBlack": "Κόκκινο σε Μαύρο",
      "ThreeSymbols1": "3 σύμβολα (σε κύκλο)",
      "ThreeSymbols2": "3 Σύμβολα (χωρίς κύκλο)",
      "ThreeFlags": "3 Σημαίες",
      "ThreeStars": "3 αστέρων",
      "FourRatings": "4 Βαθμολογίες",
      "FiveQuarters": "5 Τέταρτα",
      "FiveRatings": "5 Βαθμολογίες",
      "FiveBoxes": "5 Κουτιά",
      "Chart": "Χάρτης",
      "Column": "Στήλη",
      "Bar": "Μπαρ",
      "Area": "Περιοχή",
      "Pie": "Πόδι",
      "Doughnut": "Λουκουμάς",
      "PieAndDoughnut": "Πίτα/Ντόνατ",
      "Line": "Γραμμή",
      "Radar": "Ραντάρ",
      "Scatter": "Διασποράς",
      "ChartDesign": "Σχεδιασμός γραφήματος",
      "ClusteredColumn": "Ομαδοποιημένη στήλη",
      "StackedColumn": "Σωρευμένη στήλη",
      "StackedColumn100": "100% σωρευμένη στήλη",
      "ClusteredBar": "Ομαδοποιημένη γραμμή",
      "StackedBar": "Στοιβαγμένη μπάρα",
      "StackedBar100": "100% στοιβαγμένη μπάρα",
      "StackedArea": "Σωρευμένη περιοχή",
      "StackedArea100": "100% σωρευμένη περιοχή",
      "StackedLine": "Σωρευμένη γραμμή",
      "StackedLine100": "100% στοιβαγμένη γραμμή",
      "AddChartElement": "Προσθήκη στοιχείου γραφήματος",
      "Axes": "Άξονες",
      "AxisTitle": "Τίτλος άξονα",
      "ChartTitle": "Τίτλος γραφήματος",
      "DataLabels": "Ετικέτες δεδομένων",
      "Gridlines": "Γραμμές πλέγματος",
      "Legends": "Θρύλους",
      "PrimaryHorizontal": "Πρωτογενής οριζόντια",
      "PrimaryVertical": "Κύρια κατακόρυφη",
      "None": "Κανένας",
      "AboveChart": "Παραπάνω γράφημα",
      "Center": "Κέντρο",
      "InsideEnd": "Εσωτερικό τέλος",
      "InsideBase": "Εσωτερική βάση",
      "OutsideEnd": "Εξωτερικό άκρο",
      "PrimaryMajorHorizontal": "Κύρια κύρια οριζόντια",
      "PrimaryMajorVertical": "Κύρια κύρια κατακόρυφη",
      "PrimaryMinorHorizontal": "Πρωτοβάθμια Δευτερεύουσα Οριζόντια",
      "PrimaryMinorVertical": "Κύρια δευτερεύουσα κάθετη",
      "Right": "Δεξιά",
      "Left": "Αριστερά",
      "Bottom": "Πυθμένας",
      "Top": "Κορυφή",
      "SwitchRowColumn": "Εναλλαγή γραμμής/στήλης",
      "ChartTheme": "Θέμα γραφήματος",
      "ChartType": "Τύπος γραφήματος",
      "Material": "Υλικός",
      "Fabric": "Ύφασμα",
      "Bootstrap": "Εκκίνησης",
      "HighContrastLight": "Φως υψηλής αντίθεσης",
      "MaterialDark": "Υλικό: Σκούρο",
      "FabricDark": "Ύφασμα Σκούρο",
      "HighContrast": "Υψηλή αντίθεση",
      "BootstrapDark": "Bootstrap Σκούρο",
      "Bootstrap4": "Bootstrap4",
      "Bootstrap5Dark": "Bootstrap5 Σκούρο",
      "Bootstrap5": "Bootstrap5",
      "Tailwind": "Ούριος άνεμος",
      "TailwindDark": "Ούριος άνεμος σκοτεινός",
      "VerticalAxisTitle": "Τίτλος κάθετου άξονα",
      "HorizontalAxisTitle": "Τίτλος οριζόντιου άξονα",
      "EnterTitle": "Εισαγωγή τίτλου",
      "UnprotectWorksheet": "Κατάργηση προστασίας φύλλου",
      "ReEnterPassword": "Εισαγάγετε ξανά τον κωδικό πρόσβασης για να συνεχίσετε",
      "SheetPassword": "Κωδικός πρόσβασης για την κατάργηση προστασίας φύλλου:",
      "ProtectWorkbook": "Προστασία βιβλίου εργασίας",
      "Password": "Κωδικός πρόσβασης (προαιρετικό):",
      "EnterThePassword": "Εισαγάγετε τον κωδικό πρόσβασης",
      "ConfirmPassword": "Επιβεβαίωση κωδικού πρόσβασης",
      "EnterTheConfirmPassword": "Εισαγάγετε ξανά τον κωδικό πρόσβασής σας",
      "PasswordAlert": "Ο κωδικός επιβεβαίωσης δεν είναι πανομοιότυπος",
      "UnprotectWorkbook": "Κατάργηση προστασίας βιβλίου εργασίας",
      "UnprotectPasswordAlert": "Ο κωδικός πρόσβασης που δώσατε δεν είναι σωστός.",
      "IncorrectPassword": "Δεν είναι δυνατό το άνοιγμα του αρχείου ή του φύλλου εργασίας με τον δεδομένο κωδικό πρόσβασης",
      "PasswordAlertMsg": "Παρακαλώ εισάγετε τον κωδικό πρόσβασης",
      "ConfirmPasswordAlertMsg": "Παρακαλώ εισάγετε τον κωδικό επιβεβαίωσης",
      "IsProtected": "προστατεύεται",
      "PDF": "Έγγραφο PDF",
      "AutoFillMergeAlertMsg": "Για να γίνει αυτό, όλα τα συγχωνευμένα κελιά πρέπει να έχουν το ίδιο μέγεθος.",
      "Fluent": "Ευχερής",
      "FluentDark": "Άπταιστα σκοτεινά",
      "Custom": "Συνήθεια",
      "WEEKDAY": "Επιστρέφει την ημέρα της εβδομάδας που αντιστοιχεί σε μια ημερομηνία.",
      "FillSeries": "Σειρά γεμίσματος",
      "CopyCells": "Αντιγραφή κελιών",
      "FillFormattingOnly": "Μόνο μορφοποίηση γεμίσματος",
      "FillWithoutFormatting": "Γέμισμα χωρίς μορφοποίηση",
      "CustomFormat": "Προσαρμοσμένες μορφές αριθμών",
      "CustomFormatPlaceholder": "Πληκτρολόγηση ή επιλογή προσαρμοσμένης μορφής",
      "CustomFormatTypeList": "Δακτυλογραφώ"
    },
    "filemanager": {
      "NewFolder": "Νέος φάκελος",
      "Upload": "Ανέβασμα",
      "Delete": "Διαγράφω",
      "Rename": "Μετονομάζω",
      "Download": "Καταφόρτωση",
      "Cut": "Κόβω",
      "Copy": "Αντίγραφο",
      "Paste": "Πάστα",
      "SortBy": "Ταξινόμηση κατά",
      "Refresh": "Δροσίζω",
      "Item-Selection": "Επιλεγμένο στοιχείο",
      "Items-Selection": "Επιλεγμένα στοιχεία",
      "View": "Άποψη",
      "Details": "Λεπτομέρειες",
      "SelectAll": "Επιλογή όλων",
      "Open": "Ανοίγω",
      "Tooltip-NewFolder": "Νέος φάκελος",
      "Tooltip-Upload": "Ανέβασμα",
      "Tooltip-Delete": "Διαγράφω",
      "Tooltip-Rename": "Μετονομάζω",
      "Tooltip-Download": "Καταφόρτωση",
      "Tooltip-Cut": "Κόβω",
      "Tooltip-Copy": "Αντίγραφο",
      "Tooltip-Paste": "Πάστα",
      "Tooltip-SortBy": "Ταξινόμηση κατά",
      "Tooltip-Refresh": "Δροσίζω",
      "Tooltip-Selection": "Απαλοιφή επιλογής",
      "Tooltip-View": "Άποψη",
      "Tooltip-Details": "Λεπτομέρειες",
      "Tooltip-SelectAll": "Επιλογή όλων",
      "Name": "Όνομα",
      "Size": "Μέγεθος",
      "DateModified": "Τροποποιηθεί",
      "DateCreated": "Ημερομηνία δημιουργίας",
      "Path": "Μονοπάτι",
      "Modified": "Τροποποιηθεί",
      "Created": "Δημιουργημένος",
      "Location": "Τοποθεσία",
      "Type": "Δακτυλογραφώ",
      "Permission": "Άδεια",
      "Ascending": "Αύξουσα",
      "Descending": "Φθίνουσα",
      "None": "Κανένας",
      "View-LargeIcons": "Μεγάλα εικονίδια",
      "View-Details": "Λεπτομέρειες",
      "Search": "Αναζήτηση",
      "Button-Ok": "OK",
      "Button-Cancel": "Ακυρώνω",
      "Button-Yes": "Ναι",
      "Button-No": "Όχι",
      "Button-Create": "Δημιουργώ",
      "Button-Save": "Σώζω",
      "Header-NewFolder": "Φάκελος",
      "Content-NewFolder": "Εισαγάγετε το όνομα του φακέλου σας",
      "Header-Rename": "Μετονομάζω",
      "Content-Rename": "Εισαγάγετε το νέο σας όνομα",
      "Header-Rename-Confirmation": "Επιβεβαίωση μετονομασίας",
      "Content-Rename-Confirmation": "Εάν αλλάξετε μια επέκταση ονόματος αρχείου, το αρχείο ενδέχεται να γίνει ασταθές. Είστε βέβαιοι ότι θέλετε να το αλλάξετε;",
      "Header-Delete": "Διαγραφή αρχείου",
      "Content-Delete": "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το αρχείο;",
      "Header-Folder-Delete": "Διαγραφή φακέλου",
      "Content-Folder-Delete": "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτόν τον φάκελο;",
      "Header-Multiple-Delete": "Διαγραφή πολλών αρχείων",
      "Content-Multiple-Delete": "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτά τα αρχεία {0};",
      "Header-Duplicate": "Υπάρχει αρχείο/φάκελος",
      "Content-Duplicate": "{0} υπάρχει ήδη. Θέλετε να μετονομάσετε και να επικολλήσετε;",
      "Header-Upload": "Μεταφόρτωση αρχείων",
      "Error": "Λάθος",
      "Validation-Empty": "Το όνομα αρχείου ή φακέλου δεν μπορεί να είναι κενό.",
      "Validation-Invalid": "Το όνομα αρχείου ή φακέλου {0} περιέχει μη έγκυρους χαρακτήρες. Χρησιμοποιήστε διαφορετικό όνομα. Τα έγκυρα ονόματα αρχείων ή φακέλων δεν μπορούν να τελειώνουν με τελεία ή κενό διάστημα και δεν μπορούν να περιέχουν κανέναν από τους ακόλουθους χαρακτήρες: \\/:*?\" <>|",
      "Validation-NewFolder-Exists": "Υπάρχει ήδη ένα αρχείο ή φάκελος με το όνομα {0}.",
      "Validation-Rename-Exists": "Δεν είναι δυνατή η μετονομασία {0} σε {1}: ο προορισμός υπάρχει ήδη.",
      "Folder-Empty": "Αυτός ο φάκελος είναι κενός",
      "File-Upload": "Σύρετε αρχεία εδώ για μεταφόρτωση",
      "Search-Empty": "Δεν βρέθηκαν αποτελέσματα",
      "Search-Key": "Δοκιμάστε με διαφορετικές λέξεις-κλειδιά",
      "Filter-Empty": "Δεν βρέθηκαν αποτελέσματα",
      "Filter-Key": "Δοκιμή με διαφορετικό φίλτρο",
      "Sub-Folder-Error": "Ο φάκελος προορισμού είναι ο υποφάκελος του φακέλου προέλευσης.",
      "Same-Folder-Error": "Ο φάκελος προορισμού είναι ο ίδιος με το φάκελο προέλευσης.",
      "Access-Denied": "Δεν επιτρέπεται η πρόσβαση",
      "Access-Details": "Δεν έχετε δικαίωμα πρόσβασης σε αυτόν το φάκελο.",
      "Header-Retry": "Το αρχείο υπάρχει ήδη",
      "Content-Retry": "Ένα αρχείο με αυτό το όνομα υπάρχει ήδη σε αυτόν το φάκελο. Τι θα θέλατε να κάνετε;",
      "Button-Keep-Both": "Κρατήστε και τα δύο",
      "Button-Replace": "Αντικαθιστώ",
      "Button-Skip": "Πήδημα",
      "ApplyAll-Label": "Κάντε αυτό για όλα τα τρέχοντα στοιχεία",
      "KB": "KB",
      "Access-Message": "{0} δεν είναι προσβάσιμη. Χρειάζεστε άδεια για να εκτελέσετε την ενέργεια {1}.",
      "Network-Error": "NetworkError: απέτυχε η αποστολή στο XMLHTTPRequest: απέτυχε η φόρτωση",
      "Server-Error": "ServerError: Μη έγκυρη απόκριση από"
    },
    "calendar": {
      "today": "Σήμερα"
    },
    "datepicker": {
      "today": "Σήμερα",
      "placeholder": "Επιλέξτε ημερομηνία"
    },
    "daterangepicker": {
      "placeholder": "Επιλέξτε ένα εύρος ημερομηνιών",
      "startLabel": "Ημερομηνία έναρξης",
      "endLabel": "Ημερομηνία λήξης",
      "applyText": "Εφαρμόζω",
      "cancelText": "Ακυρώνω",
      "selectedDays": "Επιλεγμένες Ημέρες",
      "days": "Ημέρες",
      "customRange": "Προσαρμοσμένο εύρος"
    },
    "timepicker": {
      "placeholder": "Επιλέξτε ώρα"
    },
    "datetimepicker": {
      "today": "Σήμερα",
      "placeholder": "Επιλέξτε ημερομηνία και ώρα"
    },
    "dialog": {
      "close": "Κλείνω"
    },
    "inplaceeditor": {
      "save": "Σώζω",
      "cancel": "Ακυρώνω",
      "loadingText": "Φόρτωση...",
      "editIcon": "Κάντε κλικ για επεξεργασία",
      "editAreaClick": "Κάντε κλικ για επεξεργασία",
      "editAreaDoubleClick": "Κάντε διπλό κλικ για επεξεργασία"
    },
    "toast": {
      "close": "Κλείνω"
    },
    "tab": {
      "closeButtonTitle": "Κλείνω"
    },
    "schedule": {
      "day": "Μέρα",
      "week": "Εβδομάδα",
      "workWeek": "Εργάσιμη εβδομάδα",
      "month": "Μήνας",
      "year": "Έτος",
      "agenda": "Ημερήσια διάταξη",
      "weekAgenda": "Ατζέντα Εβδομάδας",
      "workWeekAgenda": "Ατζέντα εβδομάδας εργασίας",
      "monthAgenda": "Ημερήσια διάταξη μήνα",
      "today": "Σήμερα",
      "noEvents": "Δεν υπάρχουν εκδηλώσεις",
      "emptyContainer": "Δεν υπάρχουν προγραμματισμένες εκδηλώσεις αυτήν την ημέρα.",
      "allDay": "Όλη μέρα",
      "start": "Εκκίνηση",
      "end": "Τέλος",
      "more": "περισσότερο",
      "close": "Κλείνω",
      "cancel": "Ακυρώνω",
      "noTitle": "(Χωρίς τίτλο)",
      "delete": "Διαγράφω",
      "deleteEvent": "Αυτή η εκδήλωση",
      "deleteMultipleEvent": "Διαγραφή πολλών συμβάντων",
      "selectedItems": "Επιλεγμένα στοιχεία",
      "deleteSeries": "Ολόκληρη η σειρά",
      "edit": "Επεξεργασία",
      "editSeries": "Ολόκληρη η σειρά",
      "editEvent": "Αυτή η εκδήλωση",
      "createEvent": "Δημιουργώ",
      "subject": "Θέμα",
      "addTitle": "Προσθήκη τίτλου",
      "moreDetails": "Δείτε περισσότερα",
      "save": "Σώζω",
      "editContent": "Πώς θα θέλατε να αλλάξετε το ραντεβού στη σειρά;",
      "deleteContent": "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το συμβάν;",
      "deleteMultipleContent": "Είστε βέβαιοι ότι θέλετε να διαγράψετε τα επιλεγμένα συμβάντα;",
      "newEvent": "Νέα Εκδήλωση",
      "title": "Τίτλος",
      "location": "Τοποθεσία",
      "description": "Περιγραφή: __________",
      "timezone": "Ζώνη ώρας",
      "startTimezone": "Έναρξη ζώνης ώρας",
      "endTimezone": "Λήξη ζώνης ώρας",
      "repeat": "Επαναλαμβάνω",
      "saveButton": "Σώζω",
      "cancelButton": "Ακυρώνω",
      "deleteButton": "Διαγράφω",
      "recurrence": "Επανάληψη",
      "wrongPattern": "Το μοτίβο υποτροπής δεν είναι έγκυρο.",
      "seriesChangeAlert": "Θέλετε να ακυρώσετε τις αλλαγές που έγιναν σε συγκεκριμένες παρουσίες αυτής της σειράς και να τις αντιστοιχίσετε ξανά με ολόκληρη τη σειρά;",
      "createError": "Η διάρκεια του συμβάντος πρέπει να είναι μικρότερη από τη συχνότητα που συμβαίνει. Συντομεύστε τη διάρκεια ή αλλάξτε το μοτίβο περιοδικότητας στο πρόγραμμα επεξεργασίας συμβάντων περιοδικότητας.",
      "sameDayAlert": "Δύο εμφανίσεις του ίδιου συμβάντος δεν μπορούν να συμβούν την ίδια ημέρα.",
      "occurenceAlert": "Δεν είναι δυνατός ο επαναπρογραμματισμός μιας εμφάνισης της περιοδικής συνάντησης, εάν παραλείψει μια μεταγενέστερη εμφάνιση της ίδιας συνάντησης.",
      "editRecurrence": "Επεξεργασία περιοδικότητας",
      "repeats": "Επαναλαμβάνει",
      "alert": "Ξύπνιος",
      "startEndError": "Η επιλεγμένη ημερομηνία λήξης εμφανίζεται πριν από την ημερομηνία έναρξης.",
      "invalidDateError": "Η τιμή ημερομηνίας που εισαγάγατε δεν είναι έγκυρη.",
      "blockAlert": "Τα συμβάντα δεν μπορούν να προγραμματιστούν εντός του αποκλεισμένου χρονικού εύρους.",
      "ok": "Ok",
      "yes": "Ναι",
      "no": "Όχι",
      "occurrence": "Γεγονός",
      "series": "Σειρά",
      "previous": "Προηγούμενος",
      "next": "Επόμενος",
      "timelineDay": "Ημέρα χρονολογίου",
      "timelineWeek": "Εβδομάδα Χρονολογίου",
      "timelineWorkWeek": "Εβδομάδα εργασίας χρονοδιαγράμματος",
      "timelineMonth": "Μήνας χρονολογίου",
      "timelineYear": "Έτος χρονοδιαγράμματος",
      "editFollowingEvent": "Παρακολούθηση εκδηλώσεων",
      "deleteTitle": "Διαγραφή συμβάντος",
      "editTitle": "Επεξεργασία συμβάντος",
      "beginFrom": "Ξεκινήστε από",
      "endAt": "Τέλος στις",
      "expandAllDaySection": "Ανάπτυξη ολοήμερης ενότητας",
      "collapseAllDaySection": "Σύμπτυξη ολοήμερης ενότητας",
      "searchTimezone": "Αναζήτηση ζώνης ώρας",
      "noRecords": "Δεν βρέθηκαν εγγραφές"
    },
    "recurrenceeditor": {
      "none": "Κανένας",
      "daily": "Καθημερινά",
      "weekly": "Εβδομαδιαία",
      "monthly": "Μηνιαίος",
      "month": "Μήνας",
      "yearly": "Ετήσια",
      "never": "Ποτέ",
      "until": "Μέχρι",
      "count": "Μετρώ",
      "first": "Πρώτος",
      "second": "Δευτερόλεπτο",
      "third": "Τρίτο",
      "fourth": "Τέταρτος",
      "last": "Τελευταίος",
      "repeat": "Επαναλαμβάνω",
      "repeatEvery": "Επαναλάβετε κάθε",
      "on": "Επαναλάβετε στις",
      "end": "Τέλος",
      "onDay": "Μέρα",
      "days": "Ημέρα(ες)",
      "weeks": "Εβδομάδα(ες)",
      "months": "Μήνας(ες)",
      "years": "Έτος/έτη",
      "every": "κάθε",
      "summaryTimes": "ώρα(ες)",
      "summaryOn": "επί",
      "summaryUntil": "μέχρι",
      "summaryRepeat": "Επαναλαμβάνει",
      "summaryDay": "ημέρα(ες)",
      "summaryWeek": "εβδομάδα(ες)",
      "summaryMonth": "μήνας(ες)",
      "summaryYear": "έτος/έτη",
      "monthWeek": "Μήνας Εβδομάδα",
      "monthPosition": "Θέση μήνα",
      "monthExpander": "Επέκταση μήνα",
      "yearExpander": "Επέκταση έτους",
      "repeatInterval": "Διάστημα επανάληψης"
    },
    "gantt": {
      "emptyRecord": "Δεν υπάρχουν εγγραφές για εμφάνιση",
      "id": "ΑΝΑΓΝΩΡΙΣΤΙΚΌ",
      "name": "Όνομα",
      "startDate": "Ημερομηνία έναρξης",
      "endDate": "Ημερομηνία λήξης",
      "duration": "Διάρκεια",
      "progress": "Πρόοδος",
      "dependency": "Εξάρτηση",
      "notes": "Σημειώσεις",
      "baselineStartDate": "Ημερομηνία έναρξης γραμμής βάσης",
      "baselineEndDate": "Ημερομηνία λήξης γραμμής βάσης",
      "taskMode": "Λειτουργία εργασιών",
      "changeScheduleMode": "Αλλαγή λειτουργίας χρονοδιαγράμματος",
      "subTasksStartDate": "Ημερομηνία έναρξης δευτερευουσών εργασιών",
      "subTasksEndDate": "Ημερομηνία λήξης δευτερευουσών εργασιών",
      "scheduleStartDate": "Προγραμματισμός ημερομηνίας έναρξης",
      "scheduleEndDate": "Ημερομηνία λήξης χρονοδιαγράμματος",
      "auto": "Αυτοκίνητο",
      "manual": "Εγχειρίδιο",
      "type": "Δακτυλογραφώ",
      "offset": "Αντισταθμίζω",
      "resourceName": "Πόροι",
      "resourceID": "Αναγνωριστικό πόρου",
      "day": "μέρα",
      "hour": "ώρα",
      "minute": "λεπτό",
      "days": "Ημέρες",
      "hours": "Ώρες",
      "minutes": "πρακτικά",
      "generalTab": "Γενικά",
      "customTab": "Προσαρμοσμένες στήλες",
      "writeNotes": "Γράψτε σημειώσεις",
      "addDialogTitle": "Νέα εργασία",
      "editDialogTitle": "Πληροφορίες εργασίας",
      "saveButton": "Σώζω",
      "add": "Προσθέτω",
      "edit": "Επεξεργασία",
      "update": "Ενημερώνω",
      "delete": "Διαγράφω",
      "cancel": "Ακυρώνω",
      "search": "Αναζήτηση",
      "task": " αγγαρεία",
      "tasks": " Εργασίες",
      "zoomIn": "Μεγέθυνση",
      "zoomOut": "Σμίκρυνση",
      "zoomToFit": "Ζουμ για προσαρμογή",
      "excelExport": "Εξαγωγή Excel",
      "csvExport": "Εξαγωγή CSV",
      "expandAll": "Ανάπτυξη όλων",
      "collapseAll": "Σύμπτυξη όλων",
      "nextTimeSpan": "Επόμενο χρονικό διάστημα",
      "prevTimeSpan": "Προηγούμενο χρονικό διάστημα",
      "okText": "Ok",
      "confirmDelete": "Είστε βέβαιοι ότι θέλετε να διαγράψετε την εγγραφή;",
      "from": "Από",
      "to": "Προς",
      "taskLink": "Σύνδεση εργασίας",
      "lag": "Ήταν",
      "start": "Εκκίνηση",
      "finish": "Τελειώνω",
      "enterValue": "Εισαγάγετε την τιμή",
      "taskBeforePredecessor_FS": "Μετακινήσατε το \"{0}\" για να ξεκινήσετε πριν ολοκληρωθεί το \"{1}\" και συνδεθούν οι δύο εργασίες. Ως αποτέλεσμα, οι σύνδεσμοι δεν μπορούν να τηρηθούν. Επιλέξτε μία ενέργεια παρακάτω για εκτέλεση",
      "taskAfterPredecessor_FS": "Μετακινήσατε το \"{0}\" μακριά από το \"{1}\" και οι δύο εργασίες συνδέονται. Ως αποτέλεσμα, οι σύνδεσμοι δεν μπορούν να τηρηθούν. Επιλέξτε μία ενέργεια παρακάτω για εκτέλεση",
      "taskBeforePredecessor_SS": "Μετακινήσατε το \"{0}\" για να ξεκινήσετε πριν ξεκινήσει το \"{1}\" και συνδεθούν οι δύο εργασίες. Ως αποτέλεσμα, οι σύνδεσμοι δεν μπορούν να τηρηθούν. Επιλέξτε μία ενέργεια παρακάτω για εκτέλεση",
      "taskAfterPredecessor_SS": "Μετακινήσατε το \"{0}\" για να ξεκινήσετε μετά την εκκίνηση του \"{1}\" και οι δύο εργασίες συνδέονται. Ως αποτέλεσμα, οι σύνδεσμοι δεν μπορούν να τηρηθούν. Επιλέξτε μία ενέργεια παρακάτω για εκτέλεση",
      "taskBeforePredecessor_FF": "Μετακινήσατε το \"{0}\" για να ολοκληρώσετε πριν ολοκληρωθεί το \"{1}\" και οι δύο εργασίες συνδεθούν. Ως αποτέλεσμα, οι σύνδεσμοι δεν μπορούν να τηρηθούν. Επιλέξτε μία ενέργεια παρακάτω για εκτέλεση",
      "taskAfterPredecessor_FF": "Μετακινήσατε το \"{0}\" για να ολοκληρώσετε μετά την ολοκλήρωση του \"{1}\" και οι δύο εργασίες συνδέονται. Ως αποτέλεσμα, οι σύνδεσμοι δεν μπορούν να τηρηθούν. Επιλέξτε μία ενέργεια παρακάτω για εκτέλεση",
      "taskBeforePredecessor_SF": "Μετακινήσατε το \"{0}\" από το \"{1}\" στις εκκινήσεις και οι δύο εργασίες συνδέονται. Ως αποτέλεσμα, οι σύνδεσμοι δεν μπορούν να τηρηθούν. Επιλέξτε μία ενέργεια παρακάτω για εκτέλεση",
      "taskAfterPredecessor_SF": "Μετακινήσατε το \"{0}\" για να ολοκληρώσετε μετά την εκκίνηση του \"{1}\" και οι δύο εργασίες συνδέονται. Ως αποτέλεσμα, οι σύνδεσμοι δεν μπορούν να τηρηθούν. Επιλέξτε μία ενέργεια παρακάτω για εκτέλεση",
      "taskInformation": "Πληροφορίες εργασίας",
      "deleteTask": "Διαγραφή εργασίας",
      "deleteDependency": "Διαγραφή εξάρτησης",
      "convert": "Μετατρέπω",
      "save": "Σώζω",
      "above": "Πάνω",
      "below": "Κάτω",
      "child": "Παιδί",
      "milestone": "Ορόσημο",
      "toTask": "Μετάβαση στην εργασία",
      "toMilestone": "Προς Ορόσημο",
      "eventMarkers": "Δείκτες συμβάντων",
      "leftTaskLabel": "Αριστερή ετικέτα εργασίας",
      "rightTaskLabel": "Σωστή ετικέτα εργασίας",
      "timelineCell": "Κελί λωρίδας χρόνου",
      "confirmPredecessorDelete": "Είστε βέβαιοι ότι θέλετε να καταργήσετε τον σύνδεσμο εξάρτησης;",
      "unit": "Μονάδα",
      "work": "Εργασία",
      "taskType": "Τύπος εργασίας",
      "unassignedTask": "Μη εκχωρημένη εργασία",
      "group": "Ομάδα",
      "indent": "Εσοχή",
      "outdent": "Προεξοχή",
      "segments": "Τμήματα",
      "splitTask": "Διαίρεση εργασίας",
      "mergeTask": "Συγχώνευση εργασίας",
      "left": "Αριστερά",
      "right": "Δεξιά"
    },
    "richtexteditor": {
      "alignments": "Ευθυγραμμίσεις",
      "justifyLeft": "Στοίχιση αριστερά",
      "justifyCenter": "Στοίχιση στο κέντρο",
      "justifyRight": "Στοίχιση δεξιά",
      "justifyFull": "Στοίχιση Πλήρης στοίχιση",
      "fontName": "Όνομα γραμματοσειράς",
      "fontSize": "Μέγεθος γραμματοσειράς",
      "fontColor": "Χρώμα γραμματοσειράς",
      "backgroundColor": "Χρώμα φόντου",
      "bold": "Τολμηρός",
      "italic": "Πλάγια γραφή",
      "underline": "Υπογραμμίζω",
      "strikethrough": "Διακριτή διαγραφή",
      "clearFormat": "Απαλοιφή μορφής",
      "clearAll": "Απαλοιφή όλων",
      "cut": "Κόβω",
      "copy": "Αντίγραφο",
      "paste": "Πάστα",
      "unorderedList": "Λίστα με κουκκίδες",
      "orderedList": "Αριθμημένη λίστα",
      "indent": "Αύξηση εσοχής",
      "outdent": "Μείωση εσοχής",
      "undo": "Καταστρέφω",
      "redo": "Ξανακάνω",
      "superscript": "Εκθέτη",
      "subscript": "Δείκτης",
      "createLink": "Εισαγωγή υπερ-σύνδεσης",
      "openLink": "Άνοιγμα συνδέσμου",
      "editLink": "Επεξεργασία συνδέσμου",
      "removeLink": "Κατάργηση συνδέσμου",
      "image": "Εισαγωγή εικόνας",
      "replace": "Αντικαθιστώ",
      "align": "Ευθυγραμμίζω",
      "caption": "Λεζάντα εικόνας",
      "remove": "Αφαιρώ",
      "insertLink": "Εισαγωγή συνδέσμου",
      "display": "Εκθέτω",
      "altText": "Εναλλακτικό κείμενο",
      "dimension": "Αλλαγή μεγέθους",
      "fullscreen": "Μεγιστοποιώ",
      "maximize": "Μεγιστοποιώ",
      "minimize": "Ελαχιστοποιώ",
      "lowerCase": "Πεζά γράμματα",
      "upperCase": "Κεφαλαία",
      "print": "Τυπώνω",
      "formats": "Μορφές",
      "sourcecode": "Προβολή κώδικα",
      "preview": "Προεπισκόπηση",
      "viewside": "ViewSide",
      "insertCode": "Εισαγωγή κώδικα",
      "linkText": "Εμφάνιση κειμένου",
      "linkTooltipLabel": "Τίτλος",
      "linkWebUrl": "Διεύθυνση Web",
      "linkTitle": "Εισαγάγετε έναν τίτλο",
      "linkurl": "http://example.com",
      "linkOpenInNewWindow": "Άνοιγμα συνδέσμου σε νέο παράθυρο",
      "linkHeader": "Εισαγωγή συνδέσμου",
      "dialogInsert": "Ενθέτω",
      "dialogCancel": "Ακυρώνω",
      "dialogUpdate": "Ενημερώνω",
      "imageHeader": "Εισαγωγή εικόνας",
      "imageLinkHeader": "Μπορείτε επίσης να παρέχετε έναν σύνδεσμο από τον ιστό",
      "mdimageLink": "Καταχωρίστε μια διεύθυνση URL για την εικόνα σας",
      "imageUploadMessage": "Αποθέστε εικόνα εδώ ή περιηγηθείτε για μεταφόρτωση",
      "imageDeviceUploadMessage": "Κάντε κλικ εδώ για μεταφόρτωση",
      "imageAlternateText": "Εναλλακτικό κείμενο",
      "alternateHeader": "Εναλλακτικό κείμενο",
      "browse": "Φυλλομετρώ",
      "imageUrl": "http://example.com/image.png",
      "imageCaption": "Λεζάντα",
      "imageSizeHeader": "Μέγεθος εικόνας",
      "imageHeight": "Ύψος",
      "imageWidth": "Πλάτος",
      "textPlaceholder": "Εισαγωγή κειμένου",
      "inserttablebtn": "Εισαγωγή πίνακα",
      "tabledialogHeader": "Εισαγωγή πίνακα",
      "tableWidth": "Πλάτος",
      "cellpadding": "Αναπλήρωση κελιών",
      "cellspacing": "Απόσταση κελιών",
      "columns": "Αριθμός στηλών",
      "rows": "Αριθμός γραμμών",
      "tableRows": "Γραμμές πίνακα",
      "tableColumns": "Στήλες πίνακα",
      "tableCellHorizontalAlign": "Οριζόντια στοίχιση κελιών πίνακα",
      "tableCellVerticalAlign": "Κατακόρυφη στοίχιση κελιών πίνακα",
      "createTable": "Δημιουργία πίνακα",
      "removeTable": "Κατάργηση πίνακα",
      "tableHeader": "Κεφαλίδα πίνακα",
      "tableRemove": "Κατάργηση πίνακα",
      "tableCellBackground": "Φόντο κελιού πίνακα",
      "tableEditProperties": "Ιδιότητες επεξεργασίας πίνακα",
      "styles": "Στυλ",
      "insertColumnLeft": "Εισαγωγή στήλης αριστερά",
      "insertColumnRight": "Εισαγωγή στήλης δεξιά",
      "deleteColumn": "Διαγραφή στήλης",
      "insertRowBefore": "Εισαγωγή γραμμής πριν",
      "insertRowAfter": "Εισαγωγή γραμμής μετά",
      "deleteRow": "Διαγραφή γραμμής",
      "tableEditHeader": "Επεξεργασία πίνακα",
      "TableHeadingText": "Επικεφαλίδα",
      "TableColText": "Λάχανο",
      "imageInsertLinkHeader": "Εισαγωγή συνδέσμου",
      "editImageHeader": "Επεξεργασία εικόνας",
      "alignmentsDropDownLeft": "Στοίχιση αριστερά",
      "alignmentsDropDownCenter": "Στοίχιση στο κέντρο",
      "alignmentsDropDownRight": "Στοίχιση δεξιά",
      "alignmentsDropDownJustify": "Στοίχιση Πλήρης στοίχιση",
      "imageDisplayDropDownInline": "Ενσωματωμένη",
      "imageDisplayDropDownBreak": "Σπάζω",
      "tableInsertRowDropDownBefore": "Εισαγωγή γραμμής πριν",
      "tableInsertRowDropDownAfter": "Εισαγωγή γραμμής μετά",
      "tableInsertRowDropDownDelete": "Διαγραφή γραμμής",
      "tableInsertColumnDropDownLeft": "Εισαγωγή στήλης αριστερά",
      "tableInsertColumnDropDownRight": "Εισαγωγή στήλης δεξιά",
      "tableInsertColumnDropDownDelete": "Διαγραφή στήλης",
      "tableVerticalAlignDropDownTop": "Στοίχιση επάνω",
      "tableVerticalAlignDropDownMiddle": "Στοίχιση μέσης",
      "tableVerticalAlignDropDownBottom": "Στοίχιση κάτω μέρους",
      "tableStylesDropDownDashedBorder": "Διακεκομμένα περιγράμματα",
      "tableStylesDropDownAlternateRows": "Εναλλακτικές γραμμές",
      "pasteFormat": "Μορφή επικόλλησης",
      "pasteFormatContent": "Επιλογή της ενέργειας μορφοποίησης",
      "plainText": "Απλό κείμενο",
      "cleanFormat": "Καθαρός",
      "keepFormat": "Κρατώ",
      "pasteDialogOk": "OK",
      "pasteDialogCancel": "Ακυρώνω",
      "fileManager": "Διαχείριση αρχείων",
      "fileDialogHeader": "Αναζήτηση αρχείων",
      "formatsDropDownParagraph": "Παράγραφος",
      "formatsDropDownCode": "Κώδικας",
      "formatsDropDownQuotation": "Αναφορά",
      "formatsDropDownHeading1": "Τομέας 1",
      "formatsDropDownHeading2": "Τομέας 2",
      "formatsDropDownHeading3": "Τομέας 3",
      "formatsDropDownHeading4": "Τομέας 4",
      "fontNameSegoeUI": "SegoeUI",
      "fontNameArial": "Αριάλ",
      "fontNameGeorgia": "Γεωργία",
      "fontNameImpact": "Αντίκτυπος",
      "fontNameTahoma": "Ταχόμα",
      "fontNameTimesNewRoman": "Times Νέα Ρωμαϊκή",
      "fontNameVerdana": "Βερντάνα",
      "formatsOLListNumber": "Αριθμός",
      "formatsOLListLowerAlpha": "Κάτω Άλφα",
      "formatsOLListUpperAlpha": "Άνω Άλφα",
      "formatsOLListLowerRoman": "LowerRoman",
      "formatsOLListUpperRoman": "Άνω Ρωμαϊκή",
      "formatsOLListLowerGreek": "LowerGreek",
      "formatsULListDisc": "Δίσκος",
      "formatsULListCircle": "Κύκλος",
      "formatsULListSquare": "Πλατεία",
      "formatsOLListNone": "Κανένας",
      "formatsULListNone": "Κανένας"
    },
    "colorpicker": {
      "Apply": "Εφαρμόζω",
      "Cancel": "Ακυρώνω",
      "ModeSwitcher": "Εναλλαγή λειτουργίας"
    },
    "uploader": {
      "Browse": "Φυλλομετρώ...",
      "Clear": "Σαφής",
      "Upload": "Ανέβασμα",
      "dropFilesHint": "Ή αποθέστε αρχεία εδώ",
      "invalidMaxFileSize": "Το μέγεθος του αρχείου είναι πολύ μεγάλο",
      "invalidMinFileSize": "Το μέγεθος του αρχείου είναι πολύ μικρό",
      "invalidFileType": "Ο τύπος αρχείου δεν επιτρέπεται",
      "uploadFailedMessage": "Το αρχείο απέτυχε να αποσταλεί",
      "uploadSuccessMessage": "Το αρχείο ανέβηκε με επιτυχία",
      "removedSuccessMessage": "Το αρχείο καταργήθηκε με επιτυχία",
      "removedFailedMessage": "Δεν είναι δυνατή η κατάργηση του αρχείου",
      "inProgress": "Φόρτωμα",
      "readyToUploadMessage": "Έτοιμο για μεταφόρτωση",
      "abort": "Διακόπτω",
      "remove": "Αφαιρώ",
      "cancel": "Ακυρώνω",
      "delete": "Διαγραφή αρχείου",
      "pauseUpload": "Η μεταφόρτωση αρχείου τέθηκε σε παύση",
      "pause": "Παύση",
      "resume": "Επαναλαμβάνω",
      "retry": "Επανάληψη",
      "fileUploadCancel": "Η μεταφόρτωση αρχείου ακυρώθηκε"
    },
    "numerictextbox": {
      "incrementTitle": "Τιμή προσαύξησης",
      "decrementTitle": "Φθίνουσα αξία"
    },
    "slider": {
      "incrementTitle": "Αύξηση",
      "decrementTitle": "Μείωση"
    },
    "formValidator": {
      "required": "Αυτό το πεδίο είναι υποχρεωτικό.",
      "email": "Εισαγάγετε μια έγκυρη διεύθυνση email.",
      "url": "Εισαγάγετε μια έγκυρη διεύθυνση URL.",
      "date": "Εισαγάγετε μια έγκυρη ημερομηνία.",
      "dateIso": "Εισαγάγετε μια έγκυρη ημερομηνία ( ISO ).",
      "creditcard": "Παρακαλώ εισάγετε έγκυρο αριθμό κάρτας",
      "number": "Παρακαλώ εισάγετε έναν έγκυρο αριθμό.",
      "digits": "Εισαγάγετε μόνο ψηφία.",
      "maxLength": "Εισαγάγετε όχι περισσότερους από {0} χαρακτήρες.",
      "minLength": "Εισαγάγετε τουλάχιστον {0} χαρακτήρες.",
      "rangeLength": "Εισαγάγετε μια τιμή μεταξύ {0} και {1} χαρακτήρων.",
      "range": "Εισαγάγετε μια τιμή μεταξύ {0} και {1}.",
      "max": "Εισαγάγετε μια τιμή μικρότερη ή ίση με {0}.",
      "min": "Εισαγάγετε μια τιμή μεγαλύτερη ή ίση με {0}.",
      "regex": "Εισαγάγετε μια σωστή τιμή.",
      "tel": "Εισαγάγετε έναν έγκυρο αριθμό τηλεφώνου.",
      "pattern": "Εισαγάγετε μια σωστή τιμή μοτίβου.",
      "equalTo": "Παρακαλώ εισάγετε το έγκυρο κείμενο αντιστοίχισης"
    },
    "treegrid": {
      "Above": "Πάνω",
      "Below": "Κάτω",
      "AddRow": "Προσθήκη γραμμής",
      "ExpandAll": "Ανάπτυξη όλων",
      "CollapseAll": "Σύμπτυξη όλων"
    },
    "querybuilder": {
      "StartsWith": "Ξεκινά με",
      "EndsWith": "τελειώνει με",
      "Contains": "Περιέχει",
      "NotLike": "Περιέχει",
      "Like": "Όχι σαν",
      "Equal": "Ίσος",
      "NotEqual": "Δεν είναι ίσος",
      "LessThan": "Λιγότερο από",
      "LessThanOrEqual": "Μικρότερο ή ίσο",
      "GreaterThan": "Μεγαλύτερο από",
      "GreaterThanOrEqual": "Μεγαλύτερο από ή ίσο",
      "Between": "Ανάμεσα",
      "NotBetween": "Όχι μεταξύ",
      "Empty": "Αδειάζω",
      "NotEmpty": "Δεν είναι άδειο",
      "In": "Μέσα",
      "NotIn": "Όχι σε",
      "NotContains": "Δεν περιέχει",
      "Remove": "ΑΦΑΙΡΏ",
      "SelectField": "Επιλογή πεδίου",
      "SelectOperator": "Επιλέξτε τελεστή",
      "DeleteRule": "Καταργήστε αυτήν τη συνθήκη",
      "DeleteGroup": "Διαγραφή ομάδας",
      "AddGroup": "Προσθήκη ομάδας",
      "AddCondition": "Προσθήκη συνθήκης",
      "Edit": "ΕΠΕΞΕΡΓΑΣΊΑ",
      "ValidationMessage": "Αυτό το πεδίο είναι υποχρεωτικό",
      "SummaryViewTitle": "Προβολή σύνοψης",
      "OtherFields": "Άλλα πεδία",
      "AND": "ΚΑΙ",
      "OR": "Ή",
      "SelectValue": "Εισαγωγή τιμής",
      "IsEmpty": "Είναι άδειο",
      "IsNotEmpty": "Δεν είναι άδειο",
      "IsNull": "είναι μηδενικό",
      "IsNotNull": "δεν είναι μηδενική",
      "True": "πιστός",
      "False": "ψεύτικος"
    },
    "barcode": {},
    "datamatrix": {},
    "qrcode": {},
    "pivotview": {
      "grandTotal": "Γενικό σύνολο",
      "total": "Σύνολο",
      "value": "Τιμή",
      "noValue": "Καμία τιμή",
      "row": "Σειρά",
      "column": "Στήλη",
      "collapse": "Κατάρρευση",
      "expand": "Επεκτείνω",
      "rowAxisPrompt": "Ρίξτε σειρά εδώ",
      "columnAxisPrompt": "Ρίξτε στήλη εδώ",
      "valueAxisPrompt": "Ρίξτε την τιμή εδώ",
      "filterAxisPrompt": "Φίλτρο απόθεσης εδώ",
      "filter": "Φίλτρο",
      "filtered": "Φιλτραρισμένο",
      "sort": "Είδος",
      "filters": "Φίλτρα",
      "rows": "Γραμμές",
      "columns": "Στήλες",
      "values": "Αξιεσ",
      "close": "Κλείνω",
      "cancel": "Ακυρώνω",
      "delete": "Διαγράφω",
      "CalculatedField": "Πεδίο υπολογισμού",
      "createCalculatedField": "Δημιουργία πεδίου υπολογισμού",
      "fieldName": "Εισαγάγετε το όνομα του πεδίου",
      "error": "Λάθος",
      "invalidFormula": "Μη έγκυρος τύπος.",
      "dropText": "Παράδειγμα: ('Sum(Order_Count)' + 'Sum(In_Stock)') * 250",
      "dropTextMobile": "Προσθέστε πεδία και επεξεργαστείτε τον τύπο εδώ.",
      "dropAction": "Το πεδίο υπολογισμού δεν μπορεί να τοποθετηθεί σε οποιαδήποτε άλλη περιοχή εκτός από τον άξονα τιμών.",
      "alert": "Ξύπνιος",
      "warning": "Προειδοποίηση",
      "ok": "OK",
      "search": "Αναζήτηση",
      "drag": "Σέρνω",
      "remove": "Αφαιρώ",
      "allFields": "Όλα τα πεδία",
      "formula": "Τύπος",
      "addToRow": "Προσθήκη στη γραμμή",
      "addToColumn": "Προσθήκη στη στήλη",
      "addToValue": "Προσθήκη στην αξία",
      "addToFilter": "Προσθήκη στο φίλτρο",
      "emptyData": "Δεν υπάρχουν εγγραφές για εμφάνιση",
      "fieldExist": "Υπάρχει ήδη ένα πεδίο σε αυτό το όνομα. Εισαγάγετε διαφορετικό όνομα.",
      "confirmText": "Υπάρχει ήδη ένα πεδίο υπολογισμού σε αυτό το όνομα. Θέλετε να το αντικαταστήσετε;",
      "noMatches": "Δεν υπάρχουν αγώνες",
      "format": "Συνόψεις τιμές κατά",
      "edit": "Επεξεργασία",
      "clear": "Σαφής",
      "formulaField": "Μεταφορά και απόθεση πεδίων σε τύπο",
      "dragField": "Μεταφορά πεδίου σε τύπο",
      "clearFilter": "Σαφής",
      "by": "διά",
      "all": "Όλοι",
      "multipleItems": "Πολλαπλά στοιχεία",
      "member": "Μέλος",
      "label": "Ετικέτα",
      "date": "Ημερομηνία",
      "enterValue": "Εισαγωγή τιμής",
      "chooseDate": "Εισαγωγή ημερομηνίας",
      "Before": "Πριν",
      "BeforeOrEqualTo": "Πριν ή ίσο με",
      "After": "Μετά",
      "AfterOrEqualTo": "Μετά ή ίσο με",
      "labelTextContent": "Εμφάνιση των στοιχείων για τα οποία η ετικέτα",
      "dateTextContent": "Εμφάνιση των στοιχείων για τα οποία η ημερομηνία",
      "valueTextContent": "Εμφάνιση των στοιχείων για τα οποία",
      "Equals": "Ίσον",
      "DoesNotEquals": "Δεν ισούται με",
      "BeginWith": "Ξεκινά με",
      "DoesNotBeginWith": "Δεν αρχίζει με",
      "EndsWith": "τελειώνει με",
      "DoesNotEndsWith": "Δεν τελειώνει με",
      "Contains": "Περιέχει",
      "DoesNotContains": "Δεν περιέχει",
      "GreaterThan": "Μεγαλύτερο από",
      "GreaterThanOrEqualTo": "Μεγαλύτερο ή ίσο με",
      "LessThan": "Λιγότερο από",
      "LessThanOrEqualTo": "Μικρότερο ή ίσο με",
      "Between": "Ανάμεσα",
      "NotBetween": "Όχι μεταξύ",
      "And": "και",
      "Sum": "Άθροισμα",
      "Count": "Μετρώ",
      "DistinctCount": "Διακριτός αριθμός",
      "Product": "Προϊόν",
      "Avg": "Μέσος όρος",
      "Min": "Λεπτά",
      "SampleVar": "Δείγμα Var",
      "PopulationVar": "Πληθυσμός Var",
      "RunningTotals": "Τρέχοντα σύνολα",
      "Max": "Μέγιστο",
      "Index": "Ευρετήριο",
      "SampleStDev": "Δείγμα StDev",
      "PopulationStDev": "Πληθυσμός StDev",
      "PercentageOfRowTotal": "% του συνόλου γραμμής",
      "PercentageOfParentTotal": "% του μητρικού συνόλου",
      "PercentageOfParentColumnTotal": "% του συνόλου της γονικής στήλης",
      "PercentageOfParentRowTotal": "% του συνόλου γονικής γραμμής",
      "DifferenceFrom": "Διαφορά από",
      "PercentageOfDifferenceFrom": "% της διαφοράς από",
      "PercentageOfGrandTotal": "% του γενικού συνόλου",
      "PercentageOfColumnTotal": "% του συνόλου της στήλης",
      "NotEquals": "Δεν ισούται με",
      "AllValues": "Όλες οι αξίες",
      "conditionalFormating": "Μορφοποίηση",
      "apply": "ΕΦΑΡΜΌΖΩ",
      "condition": "Προσθήκη συνθήκης",
      "formatLabel": "Μορφή",
      "valueFieldSettings": "Ρυθμίσεις πεδίου τιμής",
      "baseField": "Πεδίο βάσης :",
      "baseItem": "Βασικό στοιχείο :",
      "summarizeValuesBy": "Συνοψίστε τις τιμές κατά:",
      "sourceName": "Όνομα πεδίου :",
      "sourceCaption": "Λεζάντα πεδίου :",
      "example": "Π.χ.:",
      "editorDataLimitMsg": " περισσότερα στοιχεία. Αναζήτηση για περαιτέρω βελτίωση.",
      "details": "Λεπτομέρειες",
      "manageRecords": "Διαχείριση καρτελών",
      "Years": "Χρόνια",
      "Quarters": "Τέταρτα",
      "Months": "Μήνες",
      "Days": "Ημέρες",
      "Hours": "Ώρες",
      "Minutes": "Πρακτικά",
      "Seconds": "Δευτερόλεπτα",
      "save": "Αποθήκευση αναφοράς",
      "new": "Δημιουργία νέας αναφοράς",
      "load": "Φορτίο",
      "saveAs": "Αποθήκευση ως τρέχουσα αναφορά",
      "rename": "Μετονομασία τρέχουσας αναφοράς",
      "deleteReport": "Διαγραφή τρέχουσας αναφοράς",
      "export": "Εξαγωγή",
      "subTotals": "Μερικά σύνολα",
      "grandTotals": "Γενικά σύνολα",
      "reportName": "Όνομα αναφοράς :",
      "pdf": ".PDF",
      "excel": "Αριστεύω",
      "csv": ".CSV",
      "png": ".PNG",
      "jpeg": ".JPEG",
      "svg": ".SVG",
      "mdxQuery": "Ερώτημα MDX",
      "showSubTotals": "Εμφάνιση μερικών αθροισμάτων",
      "doNotShowSubTotals": "Να μην εμφανίζονται μερικά αθροίσματα",
      "showSubTotalsRowsOnly": "Εμφάνιση μόνο γραμμών μερικών αθροισμάτων",
      "showSubTotalsColumnsOnly": "Εμφάνιση μόνο στηλών μερικών αθροισμάτων",
      "showGrandTotals": "Εμφάνιση γενικών συνόλων",
      "doNotShowGrandTotals": "Να μην εμφανίζονται γενικά σύνολα",
      "showGrandTotalsRowsOnly": "Εμφάνιση γραμμών γενικών αθροισμάτων μόνο",
      "showGrandTotalsColumnsOnly": "Εμφάνιση μόνο στηλών γενικών αθροισμάτων",
      "fieldList": "Εμφάνιση λίστας πεδίων",
      "grid": "Εμφάνιση πίνακα",
      "toolbarFormatting": "Μορφοποίηση",
      "chart": "Χάρτης",
      "reportMsg": "Εισαγάγετε το όνομα της αναφοράς vaild!!!",
      "reportList": "Λίστα αναφορών",
      "removeConfirm": "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την αναφορά;",
      "emptyReport": "Δεν βρέθηκαν αναφορές!!",
      "bar": "Μπαρ",
      "line": "Γραμμή",
      "area": "Περιοχή",
      "scatter": "Διασποράς",
      "polar": "Πολικός",
      "of": "από",
      "emptyFormat": "Δεν βρέθηκε μορφή!!!",
      "emptyInput": "Εισαγάγετε μια τιμή",
      "newReportConfirm": "Θέλετε να αποθηκεύσετε τις αλλαγές στην αναφορά;",
      "emptyReportName": "Εισαγάγετε ένα όνομα αναφοράς",
      "qtr": "Qtr",
      "null": "άκυρος",
      "undefined": "απροσδιόριστος",
      "groupOutOfRange": "Εκτός εμβέλειας",
      "fieldDropErrorAction": "Το πεδίο που μετακινείτε δεν μπορεί να τοποθετηθεί σε αυτήν την περιοχή της έκθεσης",
      "MoreOption": "Περισσότερο...",
      "aggregate": "Σύνολο",
      "drillThrough": "Διερεύνηση",
      "ascending": "Αύξουσα",
      "descending": "Φθίνουσα",
      "number": "Αριθμός",
      "currency": "Νόμισμα",
      "percentage": "Ποσοστό",
      "formatType": "Τύπος μορφής",
      "customText": "Σύμβολο νομίσματος",
      "symbolPosition": "Θέση συμβόλου",
      "left": "Αριστερά",
      "right": "Δεξιά",
      "grouping": "Ομαδοποίηση",
      "true": "Πιστός",
      "false": "Ψεύτικος",
      "decimalPlaces": "Δεκαδικά",
      "numberFormat": "Μορφοποίηση αριθμών",
      "memberType": "Τύπος πεδίου",
      "formatString": "Μορφοποίηση συμβολοσειράς",
      "expressionField": "Έκφραση",
      "customFormat": "Εισαγωγή συμβολοσειράς προσαρμοσμένης μορφής",
      "selectedHierarchy": "Γονική ιεραρχία",
      "olapDropText": "Παράδειγμα: [Μέτρα]. [Ποσότητα παραγγελίας] + ([Μέτρα].[ Ποσότητα παραγγελίας] * 0.10)",
      "Percent": "Τοις εκατό",
      "Custom": "Συνήθεια",
      "Measure": "Μετρώ",
      "Dimension": "Διάσταση",
      "Standard": "Πρότυπο",
      "blank": "(Κενό)",
      "fieldTooltip": "Σύρετε και αποθέστε πεδία για να δημιουργήσετε μια έκφραση. Και, αν θέλετε να επεξεργαστείτε τα υπάρχοντα υπολογιζόμενα πεδία! Στη συνέχεια, μπορείτε να το επιτύχετε επιλέγοντας απλώς το πεδίο στην ενότητα «Υπολογισμένα μέλη».",
      "QuarterYear": "Τρίμηνο Έτος",
      "fieldTitle": "Όνομα πεδίου",
      "drillError": "Δεν είναι δυνατή η εμφάνιση των ακατέργαστων στοιχείων των υπολογιζόμενων πεδίων.",
      "caption": "Λεζάντα πεδίου",
      "copy": "Αντίγραφο",
      "defaultReport": "Προεπιλεγμένη αναφορά",
      "customFormatString": "Προσαρμοσμένη μορφή",
      "invalidFormat": "Μη έγκυρη μορφή.",
      "group": "Ομάδα",
      "unGroup": "Κατάργηση ομαδοποίησης",
      "invalidSelection": "Δεν είναι δυνατή η ομαδοποίηση αυτής της επιλογής.",
      "groupName": "Εισαγάγετε τη λεζάντα που θα εμφανίζεται στην κεφαλίδα",
      "captionName": "Εισαγάγετε τη λεζάντα για το πεδίο ομάδας",
      "selectedItems": "Επιλεγμένα στοιχεία",
      "groupFieldCaption": "Λεζάντα πεδίου",
      "groupTitle": "Όνομα ομάδας",
      "startAt": "Ξεκινώντας από",
      "endAt": "Κατάληξη σε",
      "groupBy": "Διάστημα κατά",
      "selectGroup": "Επιλογή ομάδων",
      "numberFormatString": "Παράδειγμα: C, P, 0000 %, ###0.##0#, κ.λπ.",
      "stackingcolumn": "Σωρευμένη στήλη",
      "stackingbar": "Στοιβαγμένη μπάρα",
      "stackingarea": "Σωρευμένη περιοχή",
      "stepline": "Γραμμή βημάτων",
      "steparea": "Περιοχή βημάτων",
      "splinearea": "Περιοχή Spline",
      "spline": "Σφήνα",
      "stackingcolumn100": "100% σωρευμένη στήλη",
      "stackingbar100": "100% στοιβαγμένη μπάρα",
      "stackingarea100": "100% σωρευμένη περιοχή",
      "bubble": "αφρίζω",
      "pareto": "Παρέτο",
      "radar": "Ραντάρ",
      "chartTypeSettings": "Ρυθμίσεις τύπου γραφήματος",
      "multipleAxes": "Πολλαπλοί άξονες",
      "sortAscending": "Αύξουσα σειρά ταξινόμησης",
      "sortDescending": "Φθίνουσα σειρά ταξινόμησης",
      "sortNone": "Ταξινόμηση σειράς δεδομένων",
      "clearCalculatedField": "Απαλοιφή επεξεργασμένων πληροφοριών πεδίου",
      "editCalculatedField": "Επεξεργασία πεδίου υπολογισμού",
      "ChartType": "Τύπος γραφήματος",
      "yes": "Ναι",
      "no": "Όχι",
      "numberFormatMenu": "Μορφοποίηση αριθμών...",
      "conditionalFormatingMenu": "Μορφοποίηση...",
      "removeCalculatedField": "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το πεδίο υπολογισμού;",
      "replaceConfirmBefore": "Μια αναφορά με όνομα ",
      "replaceConfirmAfter": " υπάρχει ήδη. Θέλετε να το αντικαταστήσετε;",
      "pie": "Πόδι",
      "funnel": "Χωνί",
      "doughnut": "Λουκουμάς",
      "pyramid": "Πυραμίδα",
      "showLegend": "Εμφάνιση υπομνήματος",
      "exit": "Έξοδος",
      "invalidJSON": "Μη έγκυρα δεδομένα JSON",
      "invalidCSV": "Μη έγκυρα δεδομένα CSV",
      "stacked": "Στοιβάζονται",
      "single": "Άγαμος",
      "multipleAxisMode": "Λειτουργία πολλαπλών αξόνων",
      "grandTotalPosition": "Θέση γενικών συνόλων",
      "top": "Κορυφή",
      "bottom": "Πυθμένας",
      "None": "Κανένας",
      "stackingline": "Σωρευμένη γραμμή",
      "stackingline100": "100% στοιβαγμένη γραμμή",
      "rowPage": "Τηλεειδοποίησης γραμμών",
      "rowPerPage": "Γραμμές ανά σελίδα",
      "columnPage": "Τηλεειδοποίησης στηλών",
      "columnPerPage": "Στήλες ανά σελίδα",
      "goToFirstPage": "Μετάβαση στην πρώτη σελίδα",
      "goToPreviousPage": "Μετάβαση στην προηγούμενη σελίδα",
      "goToNextPage": "Μετάβαση στην επόμενη σελίδα",
      "goToLastPage": "Μετάβαση στην τελευταία σελίδα",
      "combined": "Συνδυασμένη",
      "subTotalPosition": "Θέση μερικών αθροισμάτων",
      "auto": "Αυτοκίνητο"
    },
    "pivotfieldlist": {
      "staticFieldList": "Συγκεντρωτική λίστα πεδίων",
      "fieldList": "Λίστα πεδίων",
      "dropFilterPrompt": "Φίλτρο απόθεσης εδώ",
      "dropColPrompt": "Ρίξτε στήλη εδώ",
      "dropRowPrompt": "Ρίξτε σειρά εδώ",
      "dropValPrompt": "Ρίξτε την τιμή εδώ",
      "addPrompt": "Προσθέστε πεδίο εδώ",
      "adaptiveFieldHeader": "Επιλέξτε πεδίο",
      "centerHeader": "Σύρετε πεδία μεταξύ των αξόνων παρακάτω:",
      "add": "προσθέτω",
      "drag": "Σέρνω",
      "filter": "Φίλτρο",
      "filtered": "Φιλτραρισμένο",
      "sort": "Είδος",
      "remove": "Αφαιρώ",
      "filters": "Φίλτρα",
      "rows": "Γραμμές",
      "columns": "Στήλες",
      "values": "Αξιεσ",
      "CalculatedField": "Πεδίο υπολογισμού",
      "createCalculatedField": "Δημιουργία πεδίου υπολογισμού",
      "fieldName": "Εισαγάγετε το όνομα του πεδίου",
      "error": "Λάθος",
      "invalidFormula": "Μη έγκυρος τύπος.",
      "dropText": "Παράδειγμα: ('Sum(Order_Count)' + 'Sum(In_Stock)'') * 250",
      "dropTextMobile": "Προσθέστε πεδία και επεξεργαστείτε τον τύπο εδώ.",
      "dropAction": "Το πεδίο υπολογισμού δεν μπορεί να τοποθετηθεί σε οποιαδήποτε άλλη περιοχή εκτός από τον άξονα τιμών.",
      "search": "Αναζήτηση",
      "close": "Κλείνω",
      "cancel": "Ακυρώνω",
      "delete": "Διαγράφω",
      "alert": "Ξύπνιος",
      "warning": "Προειδοποίηση",
      "ok": "OK",
      "allFields": "Όλα τα πεδία",
      "formula": "Τύπος",
      "fieldExist": "Υπάρχει ήδη ένα πεδίο σε αυτό το όνομα. Εισαγάγετε διαφορετικό όνομα.",
      "confirmText": "Υπάρχει ήδη ένα πεδίο υπολογισμού σε αυτό το όνομα. Θέλετε να το αντικαταστήσετε;",
      "noMatches": "Δεν υπάρχουν αγώνες",
      "format": "Συνόψεις τιμές κατά",
      "edit": "Επεξεργασία",
      "clear": "Σαφής",
      "formulaField": "Μεταφορά και απόθεση πεδίων σε τύπο",
      "dragField": "Μεταφορά πεδίου σε τύπο",
      "clearFilter": "Σαφής",
      "by": "διά",
      "enterValue": "Εισαγωγή τιμής",
      "chooseDate": "Εισαγωγή ημερομηνίας",
      "all": "Όλοι",
      "multipleItems": "Πολλαπλά στοιχεία",
      "Equals": "Ίσον",
      "DoesNotEquals": "Δεν ισούται με",
      "BeginWith": "Ξεκινά με",
      "DoesNotBeginWith": "Δεν αρχίζει με",
      "EndsWith": "τελειώνει με",
      "DoesNotEndsWith": "Δεν τελειώνει με",
      "Contains": "Περιέχει",
      "DoesNotContains": "Δεν περιέχει",
      "GreaterThan": "Μεγαλύτερο από",
      "GreaterThanOrEqualTo": "Μεγαλύτερο ή ίσο με",
      "LessThan": "Λιγότερο από",
      "LessThanOrEqualTo": "Μικρότερο ή ίσο με",
      "Between": "Ανάμεσα",
      "NotBetween": "Όχι μεταξύ",
      "Before": "Πριν",
      "BeforeOrEqualTo": "Πριν ή ίσο με",
      "After": "Μετά",
      "AfterOrEqualTo": "Μετά ή ίσο με",
      "member": "Μέλος",
      "label": "Ετικέτα",
      "date": "Ημερομηνία",
      "value": "Τιμή",
      "labelTextContent": "Εμφάνιση των στοιχείων για τα οποία η ετικέτα",
      "dateTextContent": "Εμφάνιση των στοιχείων για τα οποία η ημερομηνία",
      "valueTextContent": "Εμφάνιση των στοιχείων για τα οποία",
      "And": "και",
      "Sum": "Άθροισμα",
      "Count": "Μετρώ",
      "DistinctCount": "Διακριτός αριθμός",
      "Product": "Προϊόν",
      "Avg": "Μέσος όρος",
      "Min": "Λεπτά",
      "Max": "Μέγιστο",
      "Index": "Ευρετήριο",
      "SampleStDev": "Δείγμα StDev",
      "PopulationStDev": "Πληθυσμός StDev",
      "SampleVar": "Δείγμα Var",
      "PopulationVar": "Πληθυσμός Var",
      "RunningTotals": "Τρέχοντα σύνολα",
      "DifferenceFrom": "Διαφορά από",
      "PercentageOfDifferenceFrom": "% της διαφοράς από",
      "PercentageOfGrandTotal": "% του γενικού συνόλου",
      "PercentageOfColumnTotal": "% του συνόλου της στήλης",
      "PercentageOfRowTotal": "% του συνόλου γραμμής",
      "PercentageOfParentTotal": "% του μητρικού συνόλου",
      "PercentageOfParentColumnTotal": "% του συνόλου της γονικής στήλης",
      "PercentageOfParentRowTotal": "% του συνόλου γονικής γραμμής",
      "Years": "Χρόνια",
      "Quarters": "Τέταρτα",
      "Months": "Μήνες",
      "Days": "Ημέρες",
      "Hours": "Ώρες",
      "Minutes": "Πρακτικά",
      "Seconds": "Δευτερόλεπτα",
      "apply": "ΕΦΑΡΜΌΖΩ",
      "valueFieldSettings": "Ρυθμίσεις πεδίου τιμής",
      "sourceName": "Όνομα πεδίου :",
      "sourceCaption": "Λεζάντα πεδίου :",
      "summarizeValuesBy": "Συνοψίστε τις τιμές κατά:",
      "baseField": "Πεδίο βάσης :",
      "baseItem": "Βασικό στοιχείο :",
      "example": "Π.χ.:",
      "editorDataLimitMsg": " περισσότερα στοιχεία. Αναζήτηση για περαιτέρω βελτίωση.",
      "deferLayoutUpdate": "Αναβολή ενημέρωσης διάταξης",
      "null": "άκυρος",
      "undefined": "απροσδιόριστος",
      "groupOutOfRange": "Εκτός εμβέλειας",
      "fieldDropErrorAction": "Το πεδίο που μετακινείτε δεν μπορεί να τοποθετηθεί σε αυτήν την περιοχή της έκθεσης",
      "MoreOption": "Περισσότερο...",
      "memberType": "Τύπος πεδίου",
      "selectedHierarchy": "Γονική ιεραρχία",
      "formatString": "Μορφοποίηση συμβολοσειράς",
      "expressionField": "Έκφραση",
      "olapDropText": "Παράδειγμα: [Μέτρα]. [Ποσότητα παραγγελίας] + ([Μέτρα].[ Ποσότητα παραγγελίας] * 0.10)",
      "customFormat": "Εισαγωγή συμβολοσειράς προσαρμοσμένης μορφής",
      "Measure": "Μετρώ",
      "Dimension": "Διάσταση",
      "Standard": "Πρότυπο",
      "Currency": "Νόμισμα",
      "Percent": "Τοις εκατό",
      "Custom": "Συνήθεια",
      "blank": "(Κενό)",
      "fieldTooltip": "Σύρετε και αποθέστε πεδία για να δημιουργήσετε μια έκφραση. Και, αν θέλετε να επεξεργαστείτε τα υπάρχοντα υπολογιζόμενα πεδία! Μπορείτε να το επιτύχετε επιλέγοντας απλώς το πεδίο στην ενότητα «Υπολογισμένα μέλη».",
      "fieldTitle": "Όνομα πεδίου",
      "QuarterYear": "Τρίμηνο Έτος",
      "caption": "Λεζάντα πεδίου",
      "copy": "Αντίγραφο",
      "group": "Ομάδα",
      "numberFormatString": "Παράδειγμα: C, P, 0000 %, ###0.##0#, κ.λπ.",
      "sortAscending": "Αύξουσα σειρά ταξινόμησης",
      "sortDescending": "Φθίνουσα σειρά ταξινόμησης",
      "sortNone": "Ταξινόμηση σειράς δεδομένων",
      "clearCalculatedField": "Απαλοιφή επεξεργασμένων πληροφοριών πεδίου",
      "editCalculatedField": "Επεξεργασία πεδίου υπολογισμού",
      "selectGroup": "Επιλογή ομάδων",
      "of": "από",
      "removeCalculatedField": "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το πεδίο υπολογισμού;",
      "yes": "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το πεδίο υπολογισμού;",
      "no": "Ναι",
      "None": "Όχι"
    },
    "pdfviewer": {
      "PdfViewer": "Πρόγραμμα προβολής PDF",
      "Cancel": "Ακυρώνω",
      "Download file": "Λήψη αρχείου",
      "Download": "Καταφόρτωση",
      "Enter Password": "Αυτό το έγγραφο προστατεύεται με κωδικό πρόσβασης. Εισαγάγετε έναν κωδικό πρόσβασης.",
      "File Corrupted": "Κατεστραμμένο αρχείο",
      "File Corrupted Content": "Το αρχείο είναι κατεστραμμένο και δεν είναι δυνατό το άνοιγμά του.",
      "Fit Page": "Προσαρμογή σελίδας",
      "Fit Width": "Πλάτος προσαρμογής",
      "Automatic": "Αυτόματος",
      "Go To First Page": "Εμφάνιση πρώτης σελίδας",
      "Invalid Password": "Λανθασμένος κωδικός πρόσβασης. Παρακαλώ προσπαθήστε ξανά.",
      "Next Page": "Εμφάνιση επόμενης σελίδας",
      "OK": "OK",
      "Open": "Άνοιγμα αρχείου",
      "Page Number": "Τρέχων αριθμός σελίδας",
      "Previous Page": "Εμφάνιση προηγούμενης σελίδας",
      "Go To Last Page": "Εμφάνιση τελευταίας σελίδας",
      "Zoom": "Μεγένθυνση",
      "Zoom In": "Μεγέθυνση",
      "Zoom Out": "Σμίκρυνση",
      "Page Thumbnails": "Μικρογραφίες σελίδων",
      "Bookmarks": "Σελιδοδείκτες",
      "Print": "Εκτύπωση αρχείου",
      "Password Protected": "Απαιτείται κωδικός πρόσβασης",
      "Copy": "Αντίγραφο",
      "Text Selection": "Εργαλείο επιλογής κειμένου",
      "Panning": "Λειτουργία μετατόπισης",
      "Text Search": "Εύρεση κειμένου",
      "Find in document": "Εύρεση στο έγγραφο",
      "Match case": "Περίπτωση αγώνα",
      "Apply": "Εφαρμόζω",
      "GoToPage": "Μετάβαση στη σελίδα",
      "No matches": "Το πρόγραμμα προβολής ολοκλήρωσε την αναζήτηση στο έγγραφο. Δεν βρέθηκαν άλλα σπίρτα",
      "No Text Found": "Δεν βρέθηκε κείμενο",
      "Undo": "Καταστρέφω",
      "Redo": "Ξανακάνω",
      "Annotation": "Προσθήκη ή επεξεργασία σχολιασμών",
      "Highlight": "Επισήμανση κειμένου",
      "Underline": "Υπογράμμιση κειμένου",
      "Strikethrough": "Κείμενο διακριτής διαγραφής",
      "Delete": "Διαγραφή σχολιασμού",
      "Opacity": "Αδιαφάνεια",
      "Color edit": "Αλλαγή χρώματος",
      "Opacity edit": "Αλλαγή αδιαφάνειας",
      "highlight": "Επισημάνετε",
      "underline": "Υπογραμμίζω",
      "strikethrough": "Διαγραφή",
      "Server error": "Η υπηρεσία Web δεν ακούει. Το πρόγραμμα προβολής PDF εξαρτάται από την υπηρεσία web για όλες τις δυνατότητές του. Ξεκινήστε την υπηρεσία web για να συνεχίσετε.",
      "Open text": "Ανοίγω",
      "First text": "Αρχική Σελίδα",
      "Previous text": "Προηγούμενη σελίδα",
      "Next text": "Επόμενη Σελίδα",
      "Last text": "Τελευταία Σελίδα",
      "Zoom in text": "Μεγέθυνση",
      "Zoom out text": "Σμίκρυνση",
      "Selection text": "Επιλογή",
      "Pan text": "Κύριος",
      "Print text": "Τυπώνω",
      "Seach text": "Αναζήτηση",
      "Annotation Edit text": "Επεξεργασία σχολιασμού",
      "FormDesigner": "Προσθήκη και επεξεργασία πεδίων φόρμας",
      "Highlight context": "Επισημάνετε",
      "Underline context": "Υπογραμμίζω",
      "Strikethrough context": "Διακριτή διαγραφή",
      "Client error": "Βρέθηκε σφάλμα από την πλευρά του υπολογιστή-πελάτη. Ελέγξτε τις προσαρμοσμένες κεφαλίδες που παρέχονται στην ιδιότητα AjaxRequestSettings και τις μεθόδους ενέργειας web στην ιδιότητα ServerActionSettings .",
      "Search text": "Αναζήτηση",
      "FormDesigner Edit text": "Προσθήκη και επεξεργασία πεδίων φόρμας",
      "Line Thickness": "Πάχος γραμμής",
      "Line Properties": "Ιδιότητες γραμμής",
      "Start Arrow": "Βέλος έναρξης",
      "End Arrow": "Βέλος τέλους",
      "Line Style": "Στυλ γραμμής",
      "Fill Color": "Χρώμα γεμίσματος",
      "Line Color": "Χρώμα γραμμής",
      "None": "Κανένας",
      "Open Arrow": "Ανοίγω",
      "Closed Arrow": "Κλειστός",
      "Round Arrow": "Στρογγυλός",
      "Square Arrow": "Πλατεία",
      "Diamond Arrow": "Διαμάντι",
      "Butt": "Άκρη",
      "Cut": "Κόβω",
      "Paste": "Πάστα",
      "Delete Context": "Διαγράφω",
      "Properties": "Καταλύματα",
      "Add Stamp": "Προσθήκη σφραγίδας",
      "Add Shapes": "Προσθήκη σχημάτων",
      "Stroke edit": "Αλλαγή χρώματος περιγράμματος",
      "Change thickness": "Αλλαγή πάχους περιγράμματος",
      "Add line": "Προσθήκη γραμμής",
      "Add arrow": "Προσθήκη βέλους",
      "Add rectangle": "Προσθήκη ορθογωνίου",
      "Add circle": "Προσθήκη κύκλου",
      "Add polygon": "Προσθήκη πολυγώνου",
      "Add Comments": "Προσθήκη σχολίων",
      "Comments": "Σχόλια",
      "SubmitForm": "Υποβολή Φόρμας",
      "No Comments Yet": "Δεν υπάρχουν ακόμη σχόλια",
      "Accepted": "Αποδεκτός",
      "Completed": "Ολοκληρωθεί",
      "Cancelled": "Ακυρωμένος",
      "Rejected": "Απορριφθεί",
      "Leader Length": "Μήκος ηγέτη",
      "Scale Ratio": "Αναλογία κλίμακας",
      "Calibrate": "Διαβαθμίζω",
      "Calibrate Distance": "Βαθμονόμηση απόστασης",
      "Calibrate Perimeter": "Βαθμονόμηση περιμέτρου",
      "Calibrate Area": "Βαθμονόμηση περιοχής",
      "Calibrate Radius": "Βαθμονόμηση ακτίνας",
      "Calibrate Volume": "Βαθμονόμηση όγκου",
      "Depth": "Βάθος",
      "Closed": "Κλειστός",
      "Round": "Στρογγυλός",
      "Square": "Πλατεία",
      "Diamond": "Διαμάντι",
      "Edit": "Επεξεργασία",
      "Comment": "Σχόλιο",
      "Comment Panel": "Πίνακας σχολίων",
      "Set Status": "Ορισμός κατάστασης",
      "Post": "Θέση",
      "Page": "Σελίδα",
      "Add a comment": "Προσθέστε ένα σχόλιο",
      "Add a reply": "Προσθέστε μια απάντηση",
      "Import Annotations": "Εισαγωγή σχολιασμών από αρχείο JSON",
      "Export Annotations": "Εξαγωγή σχολιασμού σε αρχείο JSON",
      "Export XFDF": "Εξαγωγή σχολιασμού σε αρχείο XFDF",
      "Import XFDF": "Εισαγωγή σχολιασμών από αρχείο XFDF",
      "Add": "Προσθέτω",
      "Clear": "Σαφής",
      "Bold": "Τολμηρός",
      "Italic": "Πλάγια γραφή",
      "Strikethroughs": "Διακριτή διαγραφή",
      "Underlines": "Υπογραμμίζω",
      "Superscript": "Εκθέτη",
      "Subscript": "Δείκτης",
      "Align left": "Στοίχιση αριστερά",
      "Align right": "Στοίχιση δεξιά",
      "Center": "Κέντρο",
      "Justify": "Δικαιολογώ",
      "Font color": "Χρώμα γραμματοσειράς",
      "Text Align": "Στοίχιση κειμένου",
      "Text Properties": "Στυλ γραμματοσειράς",
      "SignatureFieldDialogHeaderText": "Προσθήκη υπογραφής",
      "HandwrittenSignatureDialogHeaderText": "Προσθήκη υπογραφής",
      "InitialFieldDialogHeaderText": "Προσθήκη αρχικού",
      "HandwrittenInitialDialogHeaderText": "Προσθήκη αρχικού",
      "Draw Ink": "Σχεδίαση μελανιού",
      "Create": "Δημιουργώ",
      "Font family": "Οικογένεια γραμματοσειρών",
      "Font size": "Μέγεθος γραμματοσειράς",
      "Free Text": "Ελεύθερο κείμενο",
      "Import Failed": "Μη έγκυρος τύπος αρχείου JSON ή όνομα αρχείου. επιλέξτε ένα έγκυρο αρχείο JSON",
      "Import PDF Failed": "Μη έγκυρος τύπος αρχείου PDF ή αρχείο PDF δεν βρέθηκε. Επιλέξτε ένα έγκυρο αρχείο PDF",
      "File not found": "Το εισαγόμενο αρχείο JSON δεν βρίσκεται στην επιθυμητή θέση",
      "Export Failed": "Η ενέργεια εξαγωγής σχολιασμών απέτυχε. Βεβαιωθείτε ότι οι σχολιασμοί έχουν προστεθεί σωστά",
      "of": "από ",
      "Dynamic": "Δυναμικός",
      "Standard Business": "Τυπική επιχείρηση",
      "Sign Here": "Υπογράψτε εδώ",
      "Custom Stamp": "Προσαρμοσμένη σφραγίδα",
      "Enter Signature as Name": "Εισάγετε το όνομά σας",
      "Draw-hand Signature": "ΣΧΕΔΙΆΖΩ",
      "Type Signature": "ΔΑΚΤΥΛΟΓΡΑΦΏ",
      "Upload Signature": "ΑΝΈΒΑΣΜΑ",
      "Browse Signature Image": "ΦΥΛΛΟΜΕΤΡΏ",
      "Save Signature": "Αποθήκευση υπογραφής",
      "Save Initial": "Αποθήκευση αρχικού",
      "Textbox": "Πλαίσιο κειμένου",
      "Password": "Κωδικός πρόσβασης",
      "Check Box": "Πλαίσιο ελέγχου",
      "Radio Button": "Κουμπί επιλογής",
      "Dropdown": "Αναπτυσσόμενο",
      "List Box": "Πλαίσιο λίστας",
      "Signature": "Υπογραφή",
      "Delete FormField": "Διαγραφή πεδίου φόρμας",
      "Textbox Properties": "Ιδιότητες πλαισίου κειμένου",
      "Name": "Όνομα",
      "Tooltip": "Συμβουλή εργαλείου",
      "Value": "Τιμή",
      "Form Field Visibility": "Ορατότητα πεδίου φόρμας",
      "Read Only": "Μόνο για ανάγνωση",
      "Required": "Απαιτούμενο",
      "Checked": "Ελέγχεται",
      "Show Printing": "Εμφάνιση εκτύπωσης",
      "Formatting": "Μορφή",
      "Fill": "Γεμίζω",
      "Border": "Σύνορο",
      "Border Color": "Χρώμα περιγράμματος",
      "Thickness": "Πάχος",
      "Max Length": "Μέγιστο μήκος",
      "List Item": "Όνομα στοιχείου",
      "Export Value": "Αξία στοιχείου",
      "Dropdown Item List": "Λίστα αναπτυσσόμενων στοιχείων",
      "List Box Item List": "Λίστα στοιχείων πλαισίου λίστας",
      "General": "ΓΕΝΙΚΆ",
      "Appearance": "ΕΜΦΆΝΙΣΗ",
      "Options": "ΕΠΙΛΟΓΈΣ",
      "Delete Item": "Διαγράφω",
      "Up": "Πάνω",
      "Down": "Κάτω",
      "Multiline": "Πολλαπλών γραμμών",
      "Revised": "Αναθεωρημένη",
      "Reviewed": "Αξιολόγηση",
      "Received": "Λάβει",
      "Confidential": "Εμπιστευτικός",
      "Approved": "Εγκριθεί",
      "Not Approved": "Μη εγκεκριμένο",
      "Witness": "Μάρτυρας",
      "Initial Here": "Αρχική εδώ",
      "Draft": "Προσχέδιο",
      "Final": "Τελικός",
      "For Public Release": "Για δημόσια κυκλοφορία",
      "Not For Public Release": "Όχι για δημόσια κυκλοφορία",
      "For Comment": "Για σχόλιο",
      "Void": "Κενό",
      "Preliminary Results": "Προκαταρκτικά αποτελέσματα",
      "Information Only": "Μόνο πληροφορίες",
      "in": "μέσα",
      "m": "m",
      "ft_in": "ft_in",
      "ft": "Πόδια",
      "p": "p",
      "cm": "Εκατοστόμετρο",
      "mm": "χιλ.",
      "pt": "ΡΤ",
      "cu": "με",
      "sq": "Τετραγωνικά",
      "Initial": "Αρχικός"
    },
    "diagram": {
      "Copy": "Αντίγραφο",
      "Cut": "Κόβω",
      "Paste": "Πάστα",
      "Undo": "Καταστρέφω",
      "Redo": "Ξανακάνω",
      "SelectAll": "Επιλογή όλων",
      "Grouping": "Ομαδοποίηση",
      "Group": "Ομάδα",
      "UnGroup": "Κατάργηση ομαδοποίησης",
      "Order": "Παραγγελία",
      "BringToFront": "Φέρτε μπροστά",
      "MoveForward": "Προχωρήσουμε",
      "SendToBack": "Αποστολή στο πίσω μέρος",
      "SendBackward": "Αποστολή προς τα πίσω"
    },
    "inplace-editor": {
      "editIcon": "Κάντε κλικ για επεξεργασία",
      "save": "Σώζω",
      "cancel": "Ακυρώνω"
    },
    "DocumentEditor": {
      "Table": "Τραπέζι",
      "Row": "Σειρά",
      "Cell": "Κύτταρο",
      "Ok": "Ok",
      "Cancel": "Ακυρώνω",
      "Size": "Μέγεθος",
      "Preferred Width": "Προτιμώμενο πλάτος",
      "Points": "Σημεία",
      "Percent": "Τοις εκατό",
      "Measure in": "Μέτρηση σε",
      "Alignment": "Ευθυγράμμιση",
      "Left": "Αριστερά",
      "Center": "Κέντρο",
      "Right": "Δεξιά",
      "Justify": "Δικαιολογώ",
      "Indent from left": "Εσοχή από αριστερά",
      "Borders and Shading": "Περιγράμματα και σκίαση",
      "Options": "Επιλογές",
      "Specify height": "Καθορισμός ύψους",
      "At least": "Τουλάχιστον",
      "Exactly": "Ακριβώς",
      "Row height is": "Το ύψος της γραμμής είναι",
      "Allow row to break across pages": "Να επιτρέπεται η διάσπαση γραμμών μεταξύ σελίδων",
      "Repeat as header row at the top of each page": "Επαναλάβετε ως γραμμή κεφαλίδας στο επάνω μέρος κάθε σελίδας",
      "Vertical alignment": "Κατακόρυφη ευθυγράμμιση",
      "Top": "Κορυφή",
      "Bottom": "Πυθμένας",
      "Default cell margins": "Προεπιλεγμένα περιθώρια κελιών",
      "Default cell spacing": "Προεπιλεγμένη απόσταση κελιών",
      "Allow spacing between cells": "Να επιτρέπεται η απόσταση μεταξύ των κελιών",
      "Cell margins": "Περιθώρια κελιών",
      "Same as the whole table": "Ίδιο με ολόκληρο τον πίνακα",
      "Borders": "Σύνορο",
      "None": "Κανένας",
      "Single": "Κανένας",
      "Dot": "Τελεία",
      "DashSmallGap": "DashSmallGap",
      "DashLargeGap": "DashLargeGap",
      "DashDot": "DashDot",
      "DashDotDot": "DashDotDot",
      "Double": "Διπλός",
      "Triple": "Τριπλός",
      "ThinThickSmallGap": "ThinThickSmallGap",
      "ThickThinSmallGap": "ThickThinSmallGap",
      "ThinThickThinSmallGap": "ThinThickThinSmallGap",
      "ThinThickMediumGap": "ThinThickMediumGap",
      "ThickThinMediumGap": "ThickThinMediumGap",
      "ThinThickThinMediumGap": "ThinThickThinMediumGap",
      "ThinThickLargeGap": "ThinThickLargeGap",
      "ThickThinLargeGap": "ThickThinLargeGap",
      "ThinThickThinLargeGap": "ThinThickThinLargeGap",
      "SingleWavy": "SingleWavy",
      "DoubleWavy": "Διπλόκυματο",
      "DashDotStroked": "DashDotStroked",
      "Emboss3D": "Ανάγλυφο3D",
      "Engrave3D": "Χαράξη3D",
      "Outset": "Αρχή",
      "Inset": "Ένθετο",
      "Thick": "Πυκνός",
      "Style": "Ύφος",
      "Width": "Πλάτος",
      "Height": "Ύψος",
      "Letter": "Γράμμα",
      "Tabloid": "Εφημερίδα μικρού σχήματος",
      "Legal": "Νομικός",
      "Statement": "Δήλωση",
      "Executive": "Εκτελεστικός",
      "A3": "Α3",
      "A4": "Α4",
      "A5": "Α5",
      "B4": "Β4",
      "B5": "Β5",
      "Custom Size": "Προσαρμοσμένο μέγεθος",
      "Different odd and even": "Διαφορετικές μονές και ζυγές",
      "Different first page": "Διαφορετική πρώτη σελίδα",
      "From edge": "Από άκρη",
      "Header": "Κεφαλίδα",
      "Footer": "Υποσέλιδο",
      "Margin": "Περιθώρια",
      "Paper": "Χαρτί",
      "Layout": "Διάταξη",
      "Orientation": "Προσανατολισμός",
      "Landscape": "Τοπίο",
      "Portrait": "Προσωπογραφία",
      "Table Of Contents": "Πίνακας περιεχομένων",
      "Show page numbers": "Εμφάνιση αριθμών σελίδων",
      "Right align page numbers": "Δεξιά στοίχιση αριθμών σελίδων",
      "Nothing": "Τίποτε",
      "Tab leader": "Οδηγός στηλοθέτη",
      "Show levels": "Εμφάνιση επιπέδων",
      "Use hyperlinks instead of page numbers": "Χρήση υπερ-συνδέσεων αντί για αριθμούς σελίδων",
      "Build table of contents from": "Δημιουργία πίνακα περιεχομένων από",
      "Styles": "Στυλ",
      "Available styles": "Διαθέσιμα στυλ",
      "TOC level": "Επίπεδο πίνακα περιεχομένων",
      "Heading": "Επικεφαλίδα",
      "List Paragraph": "Παράγραφος λίστας",
      "Normal": "Κανονικός",
      "Outline levels": "Επίπεδα διάρθρωσης",
      "Table entry fields": "Πεδία καταχώρησης πίνακα",
      "Modify": "Τροποποιώ",
      "Color": "Χρώμα",
      "Setting": "Ρύθμιση",
      "Box": "Κουτί",
      "All": "Όλοι",
      "Custom": "Συνήθεια",
      "Preview": "Προεπισκόπηση",
      "Shading": "Σκίαση",
      "Fill": "Γεμίζω",
      "Apply To": "Εφαρμογή σε",
      "Table Properties": "Ιδιότητες πίνακα",
      "Cell Options": "Επιλογές κελιών",
      "Table Options": "Επιλογές πίνακα",
      "Insert Table": "Εισαγωγή πίνακα",
      "Number of columns": "Αριθμός στηλών",
      "Number of rows": "Αριθμός γραμμών",
      "Text to display": "Κείμενο προς εμφάνιση",
      "Address": "Διεύθυνση",
      "Insert Hyperlink": "Εισαγωγή υπερ-σύνδεσης",
      "Edit Hyperlink": "Επεξεργασία υπερ-σύνδεσης",
      "Insert": "Ενθέτω",
      "General": "Γενικά",
      "Indentation": "Εσοχή",
      "Before text": "Πριν από το κείμενο",
      "Special": "Ειδικός",
      "First line": "Πρώτη γραμμή",
      "Hanging": "Απαγχονισμός",
      "After text": "Μετά το κείμενο",
      "By": "Διά",
      "Before": "Πριν",
      "Line Spacing": "Διάστιχο",
      "After": "Μετά",
      "At": "Σε",
      "Multiple": "Πολλαπλός",
      "Spacing": "Απόσταση",
      "Define new Multilevel list": "Ορισμός νέας λίστας πολλαπλών επιπέδων",
      "List level": "Επίπεδο λίστας",
      "Choose level to modify": "Επιλέξτε επίπεδο για τροποποίηση",
      "Level": "Επίπεδο",
      "Number format": "Μορφή αριθμού",
      "Number style for this level": "Στυλ αριθμών για αυτό το επίπεδο",
      "Enter formatting for number": "Εισαγωγή μορφοποίησης για αριθμό",
      "Start at": "Ξεκινήστε από",
      "Restart list after": "Επανεκκίνηση λίστας μετά",
      "Position": "Θέση",
      "Text indent at": "Εσοχή κειμένου στο",
      "Aligned at": "Ευθυγράμμιση στο",
      "Follow number with": "Ακολουθήστε τον αριθμό με",
      "Tab character": "Χαρακτήρας στηλοθέτη",
      "Space": "Χώρος",
      "Arabic": "Αραβικά",
      "UpRoman": "UpRoman",
      "LowRoman": "LowRoman",
      "UpLetter": "UpLetter",
      "LowLetter": "Χαμηλή επιστολή",
      "Number": "Αριθμός",
      "Leading zero": "Μηδενικό",
      "Bullet": "Σφαίρα",
      "Ordinal": "Τακτικός",
      "Ordinal Text": "Τακτικό κείμενο",
      "For East": "Για την Ανατολή",
      "No Restart": "Χωρίς επανεκκίνηση",
      "Font": "Κολυμβήθρα",
      "Font style": "Στυλ γραμματοσειράς",
      "Underline style": "Στυλ υπογράμμισης",
      "Font color": "Χρώμα γραμματοσειράς",
      "Effects": "Αποτελέσματα",
      "Strikethrough": "Διακριτή διαγραφή",
      "Superscript": "Εκθέτη",
      "Subscript": "Δείκτης",
      "Double strikethrough": "Διπλή διαγραφή",
      "Regular": "Τακτικός",
      "Bold": "Τολμηρός",
      "Italic": "Πλάγια γραφή",
      "Cut": "Κόβω",
      "Copy": "Αντίγραφο",
      "Paste": "Πάστα",
      "Hyperlink": "Υπερ-σύνδεση",
      "Open Hyperlink": "Άνοιγμα υπερ-σύνδεσης",
      "Copy Hyperlink": "Αντιγραφή υπερ-σύνδεσης",
      "Remove Hyperlink": "Κατάργηση υπερ-σύνδεσης",
      "Paragraph": "Παράγραφος",
      "Merge Cells": "Συγχώνευση κελιών",
      "Insert Above": "Εισαγωγή παραπάνω",
      "Insert Below": "Εισάγετε παρακάτω",
      "Insert Left": "Εισαγωγή αριστερά",
      "Insert Right": "Εισαγωγή δεξιά",
      "Delete": "Διαγράφω",
      "Delete Table": "Διαγραφή πίνακα",
      "Delete Row": "Διαγραφή γραμμής",
      "Delete Column": "Διαγραφή στήλης",
      "File Name": "Όνομα αρχείου",
      "Format Type": "Τύπος μορφής",
      "Save": "Σώζω",
      "Navigation": "Ναυσιπλοΐα",
      "Results": "Αποτελέσματα",
      "Replace": "Αντικαθιστώ",
      "Replace All": "Αντικατάσταση όλων",
      "We replaced all": "Αντικαταστήσαμε όλα",
      "Find": "Βρίσκω",
      "No matches": "Δεν υπάρχουν αγώνες",
      "All Done": "Όλα έτοιμα",
      "Result": "Αποτέλεσμα",
      "of": "από",
      "instances": "Περιπτώσεις",
      "with": "με",
      "Click to follow link": "Κάντε κλικ για να ακολουθήσετε τον σύνδεσμο",
      "Continue Numbering": "Συνέχεια αρίθμησης",
      "Bookmark name": "Όνομα σελιδοδείκτη",
      "Close": "Κλείνω",
      "Restart At": "Επανεκκίνηση στις",
      "Properties": "Καταλύματα",
      "Name": "Όνομα",
      "Style type": "Τύπος στυλ",
      "Style based on": "Στυλ βασισμένο σε",
      "Style for following paragraph": "Στυλ για την επόμενη παράγραφο",
      "Formatting": "Μορφοποίηση",
      "Numbering and Bullets": "Αρίθμηση και κουκκίδες",
      "Numbering": "Αρίθμηση",
      "Update Field": "Πεδίο ενημέρωσης",
      "Edit Field": "Επεξεργασία πεδίου",
      "Bookmark": "Σελιδοδείκτης",
      "Page Setup": "Διαμόρφωση σελίδας",
      "No bookmarks found": "Δεν βρέθηκαν σελιδοδείκτες",
      "Number format tooltip information": "Μορφή αριθμού ενός επιπέδου: </br>[PREFIX]%[LEVELNUMBER][SUFFIX]</br> Για παράδειγμα, Κεφάλαιο %1. θα εμφανίσει αρίθμηση όπως το</br> Κεφάλαιο 1. Σημείο</br>Κεφάλαιο 2. Στοιχείο</br>... </br> Κεφάλαιο N. Στοιχείο Μορφή</br></br>αριθμού πολλαπλών επιπέδων:</br>[ΠΡΟΘΕΜΑ]%[ΑΡΙΘΜΌΣ ΕΠΙΠΈΔΟΥ][ΕΠΊΘΗΜΑ]+[ΠΡΌΘΕΜΑ]%[ΑΡΙΘΜΌΣ ΕΠΙΠΈΔΟΥ][ΕΠΊΘΗΜΑ]Για</br> παράδειγμα, %1.%2. θα εμφανίσει αρίθμηση όπως</br>1.1. Σημείο</br>1.2. Στοιχείο</br>...</br> 1.N. Στοιχείο",
      "Format": "Μορφή",
      "Create New Style": "Δημιουργία νέου στυλ",
      "Modify Style": "Τροποποίηση στυλ",
      "New": "Νέος",
      "Bullets": "Σφαίρες",
      "Use bookmarks": "Χρήση σελιδοδεικτών",
      "Table of Contents": "Πίνακας περιεχομένων"
    },
    "drawing": {},
    "rich-text-editor": {
      "alignments": "Ευθυγραμμίσεις",
      "justifyleft": "justifyLeft",
      "justifycenter": "justifyCenter",
      "justifyright": "justifyRight",
      "justifyfull": "justifyFull",
      "fontname": "fontName",
      "fontsize": "fontSize",
      "fontcolor": "fontColor",
      "backgroundcolor": "φόντοΧρώμα",
      "clearformat": "clearFormat",
      "clearall": "σαφήςΌλα",
      "unorderedlist": "unorderedList",
      "orderedlist": "orderedList",
      "createlink": "δημιουργίαΣύνδεσμος",
      "openlink": "openLink",
      "editlink": "editLink",
      "removelink": "removeLink",
      "openimagelink": "openLink",
      "editimagelink": "editLink",
      "removeimagelink": "removeLink",
      "image": "εικόνα",
      "replace": "αντικαθιστώ",
      "align": "ευθυγραμμίζω",
      "caption": "λεζάντα",
      "remove": "αφαιρώ",
      "insertlink": "insertLink",
      "display": "εκθέτω",
      "alttext": "altText",
      "dimension": "διάσταση",
      "fullscreen": "Πλήρης οθόνη",
      "maximize": "μεγιστοποιώ",
      "minimize": "ελαχιστοποιώ",
      "lowercase": "πεζά",
      "uppercase": "κεφαλαία",
      "print": "τυπώνω",
      "formats": "Μορφές",
      "sourcecode": "Πηγαίος κώδικας",
      "preview": "προεπισκόπηση",
      "viewside": "Θέα",
      "insertcode": "insertCode",
      "justifyLeft": "Στοίχιση αριστερά",
      "justifyCenter": "Στοίχιση στο κέντρο",
      "justifyRight": "Στοίχιση δεξιά",
      "justifyFull": "Στοίχιση Πλήρης στοίχιση",
      "fontName": "Όνομα γραμματοσειράς",
      "fontSize": "Μέγεθος γραμματοσειράς",
      "fontColor": "Χρώμα γραμματοσειράς",
      "backgroundColor": "Χρώμα φόντου",
      "bold": "τολμηρός",
      "italic": "Πλάγια γραφή",
      "underline": "υπογραμμίζω",
      "strikethrough": "Διακριτή διαγραφή",
      "cut": "κόβω",
      "copy": "αντίγραφο",
      "paste": "πάστα",
      "indent": "εσοχή",
      "outdent": "προεξοχή",
      "undo": "καταστρέφω",
      "redo": "ξανακάνω",
      "superscript": "Εκθέτη",
      "subscript": "δείκτης",
      "createLink": "Εισαγωγή υπερ-σύνδεσης",
      "openLink": "Άνοιγμα συνδέσμου",
      "editLink": "Επεξεργασία συνδέσμου",
      "removeLink": "Κατάργηση συνδέσμου",
      "insertLink": "Εισαγωγή συνδέσμου",
      "altText": "Εναλλακτικό κείμενο",
      "lowerCase": "Πεζά γράμματα",
      "upperCase": "Κεφαλαία",
      "insertCode": "Εισαγωγή κώδικα",
      "linkText": "Εμφάνιση κειμένου",
      "linkTooltipLabel": "Συμβουλή εργαλείου",
      "linkWebUrl": "Διεύθυνση Web",
      "linkurl": "http://example.com",
      "linkOpenInNewWindow": "Άνοιγμα συνδέσμου σε νέο παράθυρο",
      "linkHeader": "Εισαγωγή συνδέσμου",
      "dialogInsert": "Ενθέτω",
      "dialogCancel": "Ακυρώνω",
      "dialogUpdate": "Ενημερώνω",
      "imageHeader": "Εισαγωγή εικόνας",
      "imageLinkHeader": "Μπορείτε επίσης να παρέχετε έναν σύνδεσμο από τον ιστό",
      "mdimageLink": "Καταχωρίστε μια διεύθυνση URL για την εικόνα σας",
      "imageUploadMessage": "Αποθέστε εικόνα εδώ ή περιηγηθείτε για μεταφόρτωση",
      "imageDeviceUploadMessage": "Κάντε κλικ εδώ για μεταφόρτωση",
      "imageAlternateText": "Εναλλακτικό κείμενο",
      "alternateHeader": "Εναλλακτικό κείμενο",
      "browse": "Φυλλομετρώ",
      "imageUrl": "http://example.com/image.png",
      "imageCaption": "Λεζάντα",
      "imageSizeHeader": "Μέγεθος εικόνας",
      "imageHeight": "Ύψος",
      "imageWidth": "Πλάτος",
      "textPlaceholder": "Εισαγωγή κειμένου",
      "tblhead": "1Χ1",
      "inserttablebtn": "Εισαγωγή πίνακα",
      "tabledialogHeader": "Εισαγωγή πίνακα",
      "tableWidth": "Πλάτος",
      "cellpadding": "Αναπλήρωση κελιών",
      "cellspacing": "Απόσταση κελιών",
      "columns": "Αριθμός στηλών",
      "rows": "Αριθμός γραμμών",
      "tableRows": "Γραμμές πίνακα",
      "tableColumns": "Στήλες πίνακα",
      "tableCellHorizontalAlign": "Οριζόντια στοίχιση κελιών πίνακα",
      "tableCellVerticalAlign": "Κατακόρυφη στοίχιση κελιών πίνακα",
      "createTable": "Δημιουργία πίνακα",
      "removeTable": "Κατάργηση πίνακα",
      "tableHeader": "Κεφαλίδα πίνακα",
      "tableRemove": "Κατάργηση πίνακα",
      "tableCellBackground": "Φόντο κελιού πίνακα",
      "tableEditProperties": "Ιδιότητες επεξεργασίας πίνακα",
      "styles": "Στυλ",
      "insertColumnLeft": "Εισαγωγή στήλης αριστερά",
      "insertColumnRight": "Εισαγωγή στήλης δεξιά",
      "deleteColumn": "Διαγραφή στήλης",
      "insertRowBefore": "Εισαγωγή γραμμής πριν",
      "insertRowAfter": "Εισαγωγή γραμμής μετά",
      "deleteRow": "Διαγραφή γραμμής",
      "tablerows": "πίνακαςΓραμμές",
      "tablecolumns": "πίνακαςΣτήλες",
      "tablecellhorizontalalign": "tableCellHorizontalAlign",
      "tablecellverticalalign": "tableCellVerticalAlign",
      "createtable": "δημιουργίαΠίνακας",
      "removetable": "αφαίρεσηΠίνακας",
      "tableheader": "πίνακαςΚεφαλίδα",
      "tableremove": "πίνακαςΚατάργηση",
      "tablecellbackground": "πίνακαςCellBackground",
      "tableeditproperties": "πίνακαςΕπεξεργασίαΙδιότητες",
      "insertcolumnleft": "insertColumnLeft",
      "insertcolumnright": "insertColumnRight",
      "deletecolumn": "deleteΣτήλη",
      "aligntop": "Ευθυγράμμιση",
      "alignmiddle": "ΕυθυγράμμισηΜέση",
      "alignbottom": "ΕυθυγράμμισηΚάτω",
      "insertrowbefore": "ένθετοRowBefore",
      "insertrowafter": "insertRowAfter",
      "deleterow": "deleteRow"
    },
    "drop-down-base": {
      "noRecordsTemplate": "Δεν βρέθηκαν εγγραφές",
      "actionFailureTemplate": "Η αίτηση απέτυχε"
    },
    "chart": {
      "Zoom": "Μεγένθυνση",
      "ZoomIn": "Μεγέθυνση",
      "ZoomOut": "Σμίκρυνση",
      "Reset": "Επαναφορά",
      "Pan": "Κύριος",
      "ResetZoom": "Επαναφορά ζουμ"
    },
    "maps": {
      "Zoom": "Μεγένθυνση",
      "ZoomIn": "Μεγέθυνση",
      "ZoomOut": "Σμίκρυνση",
      "Reset": "Επαναφορά",
      "Pan": "Κύριος",
      "ResetZoom": "Επαναφορά ζουμ",
      "ImageNotFound": "Η εικόνα δεν βρέθηκε"
    },
    "drop-down-tree": {
      "noRecordsTemplate": "Δεν βρέθηκαν εγγραφές",
      "actionFailureTemplate": "Η αίτηση απέτυχε",
      "overflowCountTemplate": "+${count} περισσότερα..",
      "totalCountTemplate": "${count} επιλεγμένο"
    },
    "PdfViewer": {
      "PdfViewer": "Πρόγραμμα προβολής PDF",
      "Cancel": "Ακυρώνω",
      "Download file": "Λήψη αρχείου",
      "Download": "Καταφόρτωση",
      "Enter Password": "Αυτό το έγγραφο προστατεύεται με κωδικό πρόσβασης. Εισαγάγετε έναν κωδικό πρόσβασης.",
      "File Corrupted": "Κατεστραμμένο αρχείο",
      "File Corrupted Content": "Το αρχείο είναι κατεστραμμένο και δεν είναι δυνατό το άνοιγμά του.",
      "Fit Page": "Προσαρμογή σελίδας",
      "Fit Width": "Πλάτος προσαρμογής",
      "Automatic": "Αυτόματος",
      "Go To First Page": "Εμφάνιση πρώτης σελίδας",
      "Invalid Password": "Λανθασμένος κωδικός πρόσβασης. Παρακαλώ προσπαθήστε ξανά.",
      "Next Page": "Εμφάνιση επόμενης σελίδας",
      "OK": "OK",
      "Open": "Άνοιγμα αρχείου",
      "Page Number": "Τρέχων αριθμός σελίδας",
      "Previous Page": "Εμφάνιση προηγούμενης σελίδας",
      "Go To Last Page": "Εμφάνιση τελευταίας σελίδας",
      "Zoom": "Μεγένθυνση",
      "Zoom In": "Μεγέθυνση",
      "Zoom Out": "Σμίκρυνση",
      "Page Thumbnails": "Μικρογραφίες σελίδων",
      "Bookmarks": "Σελιδοδείκτες",
      "Print": "Εκτύπωση αρχείου",
      "Password Protected": "Απαιτείται κωδικός πρόσβασης",
      "Copy": "Αντίγραφο",
      "Text Selection": "Εργαλείο επιλογής κειμένου",
      "Panning": "Λειτουργία μετατόπισης",
      "Text Search": "Εύρεση κειμένου",
      "Find in document": "Εύρεση στο έγγραφο",
      "Match case": "Περίπτωση αγώνα",
      "Apply": "Εφαρμόζω",
      "GoToPage": "Μετάβαση στη σελίδα",
      "No matches": "Το πρόγραμμα προβολής ολοκλήρωσε την αναζήτηση στο έγγραφο. Δεν βρέθηκαν άλλα σπίρτα",
      "No Text Found": "Δεν βρέθηκε κείμενο",
      "Undo": "Καταστρέφω",
      "Redo": "Ξανακάνω",
      "Annotation": "Προσθήκη ή επεξεργασία σχολιασμών",
      "Highlight": "Επισήμανση κειμένου",
      "Underline": "Υπογράμμιση κειμένου",
      "Strikethrough": "Κείμενο διακριτής διαγραφής",
      "Delete": "Διαγραφή σχολιασμού",
      "Opacity": "Αδιαφάνεια",
      "Color edit": "Αλλαγή χρώματος",
      "Opacity edit": "Αλλαγή αδιαφάνειας",
      "Highlight context": "Επισημάνετε",
      "Underline context": "Υπογραμμίζω",
      "Strikethrough context": "Διαγραφή",
      "Server error": "Η υπηρεσία Web δεν ακούει. Το πρόγραμμα προβολής PDF εξαρτάται από την υπηρεσία web για όλες τις δυνατότητές του. Ξεκινήστε την υπηρεσία web για να συνεχίσετε.",
      "Open text": "Ανοίγω",
      "First text": "Αρχική Σελίδα",
      "Previous text": "Προηγούμενη σελίδα",
      "Next text": "Επόμενη Σελίδα",
      "Last text": "Τελευταία Σελίδα",
      "Zoom in text": "Μεγέθυνση",
      "Zoom out text": "Σμίκρυνση",
      "Selection text": "Επιλογή",
      "Pan text": "Κύριος",
      "Print text": "Τυπώνω",
      "Search text": "Αναζήτηση",
      "Annotation Edit text": "Επεξεργασία σχολιασμού",
      "Line Thickness": "Πάχος γραμμής",
      "Line Properties": "Ιδιότητες γραμμής",
      "Start Arrow": "Βέλος έναρξης",
      "End Arrow": "Βέλος τέλους",
      "Line Style": "Στυλ γραμμής",
      "Fill Color": "Χρώμα γεμίσματος",
      "Line Color": "Χρώμα γραμμής",
      "None": "Κανένας",
      "Open Arrow": "Ανοίγω",
      "Closed Arrow": "Κλειστός",
      "Round Arrow": "Στρογγυλός",
      "Square Arrow": "Πλατεία",
      "Diamond Arrow": "Διαμάντι",
      "Butt": "Άκρη",
      "Cut": "Κόβω",
      "Paste": "Πάστα",
      "Delete Context": "Διαγράφω",
      "Properties": "Καταλύματα",
      "Add Stamp": "Προσθήκη σφραγίδας",
      "Add Shapes": "Προσθήκη σχημάτων",
      "Stroke edit": "Αλλαγή χρώματος περιγράμματος",
      "Change thickness": "Αλλαγή πάχους περιγράμματος",
      "Add line": "Προσθήκη γραμμής",
      "Add arrow": "Προσθήκη βέλους",
      "Add rectangle": "Προσθήκη ορθογωνίου",
      "Add circle": "Προσθήκη κύκλου",
      "Add polygon": "Προσθήκη πολυγώνου",
      "Add Comments": "Προσθήκη σχολίων",
      "Comments": "Σχόλια",
      "No Comments Yet": "Δεν υπάρχουν ακόμη σχόλια",
      "Accepted": "Αποδεκτός",
      "Completed": "Ολοκληρωθεί",
      "Cancelled": "Ακυρωμένος",
      "Rejected": "Απορριφθεί",
      "Leader Length": "Μήκος ηγέτη",
      "Scale Ratio": "Αναλογία κλίμακας",
      "Calibrate": "Διαβαθμίζω",
      "Calibrate Distance": "Βαθμονόμηση απόστασης",
      "Calibrate Perimeter": "Βαθμονόμηση περιμέτρου",
      "Calibrate Area": "Βαθμονόμηση περιοχής",
      "Calibrate Radius": "Βαθμονόμηση ακτίνας",
      "Calibrate Volume": "Βαθμονόμηση όγκου",
      "Depth": "Βάθος",
      "Closed": "Κλειστός",
      "Round": "Στρογγυλός",
      "Square": "Πλατεία",
      "Diamond": "Διαμάντι",
      "Edit": "Επεξεργασία",
      "Comment": "Σχόλιο",
      "Comment Panel": "Πίνακας σχολίων",
      "Set Status": "Ορισμός κατάστασης",
      "Post": "Θέση",
      "Page": "Σελίδα",
      "Add a comment": "Προσθέστε ένα σχόλιο",
      "Add a reply": "Προσθέστε μια απάντηση",
      "Import Annotations": "Εισαγωγή σχολιασμών από αρχείο JSON",
      "Export Annotations": "Εξαγωγή σχολιασμού σε αρχείο JSON",
      "Export XFDF": "Εξαγωγή σχολιασμού σε αρχείο XFDF",
      "Import XFDF": "Εισαγωγή σχολιασμών από αρχείο XFDF",
      "Add": "Προσθέτω",
      "Clear": "Σαφής",
      "Bold": "Τολμηρός",
      "Italic": "Πλάγια γραφή",
      "Strikethroughs": "Διακριτή διαγραφή",
      "Underlines": "Υπογραμμίζω",
      "Superscript": "Εκθέτη",
      "Subscript": "Δείκτης",
      "Align left": "Στοίχιση αριστερά",
      "Align right": "Στοίχιση δεξιά",
      "Center": "Κέντρο",
      "Justify": "Δικαιολογώ",
      "Font color": "Χρώμα γραμματοσειράς",
      "Text Align": "Στοίχιση κειμένου",
      "Text Properties": "Στυλ γραμματοσειράς",
      "SignatureFieldDialogHeaderText": "Προσθήκη υπογραφής",
      "HandwrittenSignatureDialogHeaderText": "Προσθήκη υπογραφής",
      "InitialFieldDialogHeaderText": "Προσθήκη αρχικού",
      "HandwrittenInitialDialogHeaderText": "Προσθήκη αρχικού",
      "Draw Ink": "Σχεδίαση μελανιού",
      "Create": "Δημιουργώ",
      "Font family": "Οικογένεια γραμματοσειρών",
      "Font size": "Μέγεθος γραμματοσειράς",
      "Free Text": "Ελεύθερο κείμενο",
      "Import Failed": "Μη έγκυρος τύπος αρχείου JSON ή όνομα αρχείου. επιλέξτε ένα έγκυρο αρχείο JSON",
      "Import PDF Failed": "Δεν υπάρχει έγκυρος τύπος αρχείου PDF ή αρχείο PDF. Επιλέξτε ένα έγκυρο αρχείο PDF",
      "File not found": "Το εισαγόμενο αρχείο JSON δεν βρίσκεται στην επιθυμητή θέση",
      "Export Failed": "Η ενέργεια εξαγωγής σχολιασμών απέτυχε. Βεβαιωθείτε ότι οι σχολιασμοί έχουν προστεθεί σωστά",
      "of": "από",
      "Dynamic": "Δυναμικός",
      "Standard Business": "Τυπική επιχείρηση",
      "Sign Here": "Υπογράψτε εδώ",
      "Custom Stamp": "Προσαρμοσμένη σφραγίδα",
      "Enter Signature as Name": "Εισάγετε το όνομά σας",
      "Draw-hand Signature": "ΣΧΕΔΙΆΖΩ",
      "Type Signature": "ΔΑΚΤΥΛΟΓΡΑΦΏ",
      "Upload Signature": "ΑΝΈΒΑΣΜΑ",
      "Browse Signature Image": "ΦΥΛΛΟΜΕΤΡΏ",
      "Save Signature": "Αποθήκευση υπογραφής"
    },
    "documenteditor": {
      "Table": "Τραπέζι",
      "Row": "Σειρά",
      "Cell": "Κύτταρο",
      "Ok": "Ok",
      "Cancel": "Ακυρώνω",
      "Size": "Μέγεθος",
      "Preferred Width": "Προτιμώμενο πλάτος",
      "Points": "Σημεία",
      "Percent": "Τοις εκατό",
      "Measure in": "Μέτρηση σε",
      "Alignment": "Ευθυγράμμιση",
      "Left": "Αριστερά",
      "Center": "Κέντρο",
      "Right": "Δεξιά",
      "Justify": "Δικαιολογώ",
      "Indent from left": "Εσοχή από αριστερά",
      "Borders and Shading": "Περιγράμματα και σκίαση",
      "Options": "Επιλογές",
      "Specify height": "Καθορισμός ύψους",
      "At least": "Τουλάχιστον",
      "Exactly": "Ακριβώς",
      "Row height is": "Το ύψος της γραμμής είναι",
      "Allow row to break across pages": "Να επιτρέπεται η διάσπαση γραμμών μεταξύ σελίδων",
      "Repeat as header row at the top of each page": "Επαναλάβετε ως γραμμή κεφαλίδας στο επάνω μέρος κάθε σελίδας",
      "Vertical alignment": "Κατακόρυφη ευθυγράμμιση",
      "Top": "Κορυφή",
      "Bottom": "Πυθμένας",
      "Default cell margins": "Προεπιλεγμένα περιθώρια κελιών",
      "Default cell spacing": "Προεπιλεγμένη απόσταση κελιών",
      "Allow spacing between cells": "Να επιτρέπεται η απόσταση μεταξύ των κελιών",
      "Cell margins": "Περιθώρια κελιών",
      "Same as the whole table": "Ίδιο με ολόκληρο τον πίνακα",
      "Borders": "Σύνορο",
      "None": "Κανένας",
      "Style": "Ύφος",
      "Width": "Πλάτος",
      "Height": "Ύψος",
      "Letter": "Γράμμα",
      "Tabloid": "Εφημερίδα μικρού σχήματος",
      "Legal": "Νομικός",
      "Statement": "Δήλωση",
      "Executive": "Εκτελεστικός",
      "A3": "Α3",
      "A4": "Α4",
      "A5": "Α5",
      "B4": "Β4",
      "B5": "Β5",
      "Custom Size": "Προσαρμοσμένο μέγεθος",
      "Different odd and even": "Διαφορετικές μονές και ζυγές",
      "Different first page": "Διαφορετική πρώτη σελίδα",
      "From edge": "Από άκρη",
      "Header": "Κεφαλίδα",
      "Footer": "Υποσέλιδο",
      "First Page Header": "Κεφαλίδα πρώτης σελίδας",
      "First Page Footer": "Υποσέλιδο πρώτης σελίδας",
      "Even Page Header": "Ζυγή κεφαλίδα σελίδας",
      "Even Page Footer": "Ζυγό υποσέλιδο σελίδας",
      "Odd Page Header": "Κεφαλίδα μονής σελίδας",
      "Odd Page Footer": "Υποσέλιδο μονής σελίδας",
      "Margin": "Περιθώρια",
      "Paper": "Χαρτί",
      "Layout": "Διάταξη",
      "Orientation": "Προσανατολισμός",
      "Landscape": "Τοπίο",
      "Portrait": "Προσωπογραφία",
      "Show page numbers": "Εμφάνιση αριθμών σελίδων",
      "Right align page numbers": "Δεξιά στοίχιση αριθμών σελίδων",
      "Nothing": "Τίποτε",
      "Tab leader": "Οδηγός στηλοθέτη",
      "Show levels": "Εμφάνιση επιπέδων",
      "Use hyperlinks instead of page numbers": "Χρήση υπερ-συνδέσεων αντί για αριθμούς σελίδων",
      "Build table of contents from": "Δημιουργία πίνακα περιεχομένων από",
      "Styles": "Στυλ",
      "Available styles": "Διαθέσιμα στυλ",
      "TOC level": "Επίπεδο πίνακα περιεχομένων",
      "Heading": "Επικεφαλίδα",
      "Heading 1": "Τομέας 1",
      "Heading 2": "Τομέας 2",
      "Heading 3": "Τομέας 3",
      "Heading 4": "Τομέας 4",
      "Heading 5": "Τομέας 5",
      "Heading 6": "Τομέας 6",
      "List Paragraph": "Παράγραφος λίστας",
      "Normal": "Κανονικός",
      "Outline levels": "Επίπεδα διάρθρωσης",
      "Table entry fields": "Πεδία καταχώρησης πίνακα",
      "Modify": "Τροποποιώ",
      "Color": "Χρώμα",
      "Setting": "Ρύθμιση",
      "Box": "Κουτί",
      "All": "Όλοι",
      "Custom": "Συνήθεια",
      "Preview": "Προεπισκόπηση",
      "Shading": "Σκίαση",
      "Fill": "Γεμίζω",
      "Apply To": "Εφαρμογή σε",
      "Table Properties": "Ιδιότητες πίνακα",
      "Cell Options": "Επιλογές κελιών",
      "Table Options": "Επιλογές πίνακα",
      "Insert Table": "Εισαγωγή πίνακα",
      "Number of columns": "Αριθμός στηλών",
      "Number of rows": "Αριθμός γραμμών",
      "Text to display": "Κείμενο προς εμφάνιση",
      "ScreenTip text": "Κείμενο προς εμφάνιση",
      "Address": "Διεύθυνση",
      "Insert Hyperlink": "Εισαγωγή υπερ-σύνδεσης",
      "Edit Hyperlink": "Επεξεργασία υπερ-σύνδεσης",
      "Insert": "Ενθέτω",
      "General": "Γενικά",
      "Indentation": "Εσοχή",
      "Before text": "Πριν από το κείμενο",
      "Special": "Ειδικός",
      "First line": "Πρώτη γραμμή",
      "Hanging": "Απαγχονισμός",
      "After text": "Μετά το κείμενο",
      "By": "Διά",
      "Before": "Πριν",
      "Line Spacing": "Διάστιχο",
      "After": "Μετά",
      "At": "Σε",
      "Multiple": "Πολλαπλός",
      "Spacing": "Απόσταση",
      "Define new Multilevel list": "Ορισμός νέας λίστας πολλαπλών επιπέδων",
      "List level": "Επίπεδο λίστας",
      "Choose level to modify": "Επιλέξτε επίπεδο για τροποποίηση",
      "Level": "Επίπεδο",
      "Number format": "Μορφή αριθμού",
      "Number style for this level": "Στυλ αριθμών για αυτό το επίπεδο",
      "Enter formatting for number": "Εισαγωγή μορφοποίησης για αριθμό",
      "Start at": "Ξεκινήστε από",
      "Restart list after": "Επανεκκίνηση λίστας μετά",
      "Position": "Θέση",
      "Text indent at": "Εσοχή κειμένου στο",
      "Aligned at": "Ευθυγράμμιση στο",
      "Follow number with": "Ακολουθήστε τον αριθμό με",
      "Tab character": "Χαρακτήρας στηλοθέτη",
      "Space": "Χώρος",
      "Arabic": "Αραβικά",
      "UpRoman": "UpRoman",
      "LowRoman": "LowRoman",
      "UpLetter": "UpLetter",
      "LowLetter": "Χαμηλή επιστολή",
      "Number": "Αριθμός",
      "Leading zero": "Μηδενικό",
      "Bullet": "Σφαίρα",
      "Ordinal": "Τακτικός",
      "Ordinal Text": "Τακτικό κείμενο",
      "For East": "Για την Ανατολή",
      "No Restart": "Χωρίς επανεκκίνηση",
      "Font": "Κολυμβήθρα",
      "Font style": "Στυλ γραμματοσειράς",
      "Underline style": "Στυλ υπογράμμισης",
      "Font color": "Χρώμα γραμματοσειράς",
      "Effects": "Αποτελέσματα",
      "Strikethrough": "Διακριτή διαγραφή",
      "Superscript": "Εκθέτη",
      "Subscript": "Δείκτης",
      "Double strikethrough": "Διπλή διαγραφή",
      "Regular": "Τακτικός",
      "Bold": "Τολμηρός",
      "Italic": "Πλάγια γραφή",
      "Cut": "Κόβω",
      "Copy": "Αντίγραφο",
      "Paste": "Πάστα",
      "Hyperlink": "Υπερ-σύνδεση",
      "Open Hyperlink": "Άνοιγμα υπερ-σύνδεσης",
      "Copy Hyperlink": "Αντιγραφή υπερ-σύνδεσης",
      "Remove Hyperlink": "Κατάργηση υπερ-σύνδεσης",
      "Paragraph": "Παράγραφος",
      "Linked Style": "Linked(Παράγραφος και χαρακτήρας)",
      "Character": "Χαρακτήρας",
      "Merge Cells": "Συγχώνευση κελιών",
      "Insert Above": "Εισαγωγή παραπάνω",
      "Insert Below": "Εισάγετε παρακάτω",
      "Insert Left": "Εισαγωγή αριστερά",
      "Insert Right": "Εισαγωγή δεξιά",
      "Delete": "Διαγράφω",
      "Delete Table": "Διαγραφή πίνακα",
      "Delete Row": "Διαγραφή γραμμής",
      "Delete Column": "Διαγραφή στήλης",
      "File Name": "Όνομα αρχείου",
      "Format Type": "Τύπος μορφής",
      "Save": "Σώζω",
      "Navigation": "Ναυσιπλοΐα",
      "Results": "Αποτελέσματα",
      "Replace": "Αντικαθιστώ",
      "Replace All": "Αντικατάσταση όλων",
      "We replaced all": "Αντικαταστήσαμε όλα",
      "Find": "Βρίσκω",
      "No matches": "Δεν υπάρχουν αγώνες",
      "All Done": "Όλα έτοιμα",
      "Result": "Αποτέλεσμα",
      "of": "από",
      "instances": "Περιπτώσεις",
      "with": "με",
      "Click to follow link": "Κάντε κλικ για να ακολουθήσετε τον σύνδεσμο",
      "Continue Numbering": "Συνέχεια αρίθμησης",
      "Bookmark name": "Όνομα σελιδοδείκτη",
      "Close": "Κλείνω",
      "Restart At": "Επανεκκίνηση στις",
      "Properties": "Καταλύματα",
      "Name": "Όνομα",
      "Style type": "Τύπος στυλ",
      "Style based on": "Στυλ βασισμένο σε",
      "Style for following paragraph": "Στυλ για την επόμενη παράγραφο",
      "Formatting": "Μορφοποίηση",
      "Numbering and Bullets": "Αρίθμηση και κουκκίδες",
      "Numbering": "Αρίθμηση",
      "Update Field": "Πεδίο ενημέρωσης",
      "Edit Field": "Επεξεργασία πεδίου",
      "Bookmark": "Σελιδοδείκτης",
      "Page Setup": "Διαμόρφωση σελίδας",
      "No bookmarks found": "Δεν βρέθηκαν σελιδοδείκτες",
      "Number format tooltip information": "Μορφή αριθμού ενός επιπέδου: </br>[PREFIX]%[LEVELNUMBER][SUFFIX]</br> Για παράδειγμα, το \"Κεφάλαιο %1.\" θα εμφανίσει αρίθμηση όπως το Κεφάλαιο 1</br>. Σημείο</br>Κεφάλαιο 2. Στοιχείο</br>... </br> Κεφάλαιο ΙΔ. Στοιχείο Μορφή</br> </br>αριθμού πολλαπλών επιπέδων:</br>[ΠΡΟΘΕΜΑ]%[ΑΡΙΘΜΌΣ ΕΠΙΠΈΔΟΥ][ΕΠΊΘΗΜΑ]+[ΠΡΌΘΕΜΑ]%[ΑΡΙΘΜΌΣ ΕΠΙΠΈΔΟΥ][ΕΠΊΘΗΜΑ]Για</br> παράδειγμα, το '%1.%2.' θα εμφανίσει αρίθμηση όπως 1.1.</br> Σημείο</br>1.2. Στοιχείο</br>...</br> 1.N. Στοιχείο",
      "Format": "Μορφή",
      "Create New Style": "Δημιουργία νέου στυλ",
      "Modify Style": "Τροποποίηση στυλ",
      "New": "Νέος",
      "Bullets": "Σφαίρες",
      "Use bookmarks": "Χρήση σελιδοδεικτών",
      "Table of Contents": "Πίνακας περιεχομένων",
      "AutoFit": "Αυτόματη Προσαρμογή",
      "AutoFit to Contents": "Αυτόματη Προσαρμογή στα περιεχόμενα",
      "AutoFit to Window": "Αυτόματη Προσαρμογή στο παράθυρο",
      "Fixed Column Width": "Σταθερό πλάτος στήλης",
      "Reset": "Επαναφορά",
      "Match case": "Περίπτωση αγώνα",
      "Whole words": "Ολόκληρες λέξεις",
      "Add": "Προσθέτω",
      "Go To": "Πήγαινε στο",
      "Search for": "Αναζήτηση για",
      "Replace with": "Αντικαταστήστε με",
      "TOC 1": "TOC 1",
      "TOC 2": "TOC 2",
      "TOC 3": "TOC 3",
      "TOC 4": "TOC 4",
      "TOC 5": "TOC 5",
      "TOC 6": "TOC 6",
      "TOC 7": "TOC 7",
      "TOC 8": "TOC 8",
      "TOC 9": "TOC 9",
      "Right-to-left": "Από δεξιά προς τα αριστερά",
      "Left-to-right": "Από αριστερά προς τα δεξιά",
      "Direction": "Κατεύθυνση",
      "Table direction": "Κατεύθυνση πίνακα",
      "Indent from right": "Εσοχή από δεξιά",
      "Contextual Spacing": "Μην προσθέτετε κενό διάστημα μεταξύ των παραγράφων των ίδιων στυλ",
      "Password Mismatch": "Ο κωδικός πρόσβασης δεν ταιριάζει",
      "Restrict Editing": "Περιορισμός επεξεργασίας",
      "Formatting restrictions": "Περιορισμοί μορφοποίησης",
      "Allow formatting": "Να επιτρέπεται η μορφοποίηση",
      "Editing restrictions": "Περιορισμοί επεξεργασίας",
      "Read only": "Μόνο για ανάγνωση",
      "Exceptions Optional": "Εξαιρέσεις (προαιρετικό)",
      "Select Part Of Document And User": "Επιλέξτε τμήματα του εγγράφου και επιλέξτε χρήστες στους οποίους επιτρέπεται να τα επεξεργάζονται ελεύθερα.",
      "Everyone": "Καθένας",
      "More users": "Περισσότεροι χρήστες",
      "Add Users": "Προσθήκη χρηστών",
      "Enforcing Protection": "Ναι, ξεκινήστε να επιβάλλετε προστασία",
      "Start Enforcing Protection": "Ξεκινήστε την επιβολή προστασίας",
      "Enter User": "Εισαγωγή χρήστη",
      "Users": "Χρήστες",
      "Enter new password": "Εισαγάγετε νέο κωδικό πρόσβασης",
      "Reenter new password to confirm": "Εισαγάγετε ξανά νέο κωδικό πρόσβασης για επιβεβαίωση",
      "Your permissions": "Τα δικαιώματά σας",
      "Protected Document": "Αυτό το έγγραφο προστατεύεται από ακούσια επεξεργασία. Μπορείτε να επεξεργαστείτε σε αυτήν την περιοχή.",
      "FormFieldsOnly": "Μπορείτε να συμπληρώσετε φόρμες μόνο σε αυτήν την περιοχή.",
      "CommentsOnly": "Μπορείτε να εισαγάγετε σχόλια μόνο σε αυτήν την περιοχή.",
      "ReadOnlyProtection": "Μπορείτε να επεξεργαστείτε σε αυτήν την περιοχή.",
      "Stop Protection": "Προστασία διακοπής",
      "Password": "Κωδικός πρόσβασης",
      "Spelling Editor": "Ορθογραφικός επεξεργαστής",
      "Spelling": "Ορθογραφία",
      "Spell Check": "Ορθογραφικός έλεγχος",
      "Underline errors": "Υπογράμμιση σφαλμάτων",
      "Ignore": "Αγνοώ",
      "Ignore All": "Παράβλεψη όλων",
      "Add to Dictionary": "Προσθήκη στο λεξικό",
      "Change": "Αλλαγή",
      "Change All": "Αλλαγή όλων",
      "Suggestions": "Προτάσεις",
      "The password is incorrect": "Ο κωδικός πρόσβασης είναι εσφαλμένος",
      "Error in establishing connection with web server": "Σφάλμα κατά τη δημιουργία σύνδεσης με διακομιστή ιστού",
      "Highlight the regions I can edit": "Επισήμανση των περιοχών που μπορώ να επεξεργαστώ",
      "Show All Regions I Can Edit": "Εμφάνιση όλων των περιοχών που μπορώ να επεξεργαστώ",
      "Find Next Region I Can Edit": "Εύρεση επόμενης περιοχής που μπορώ να επεξεργαστώ",
      "Keep source formatting": "Διατήρηση μορφοποίησης προέλευσης",
      "Match destination formatting": "Αντιστοίχιση μορφοποίησης προορισμού",
      "Text only": "Μόνο κείμενο",
      "Comments": "Σχόλια",
      "Type your comment": "Πληκτρολογήστε το σχόλιό σας",
      "Post": "Θέση",
      "Reply": "Απάντηση",
      "New Comment": "Νέο σχόλιο",
      "Edit": "Επεξεργασία",
      "Resolve": "Αποφασίζω",
      "Reopen": "Ανοίξετε ξανά",
      "No comments in this document": "Δεν υπάρχουν σχόλια σε αυτό το έγγραφο",
      "more": "περισσότερο",
      "Type your comment here": "Πληκτρολογήστε το σχόλιό σας εδώ",
      "Next Comment": "Επόμενο σχόλιο",
      "Previous Comment": "Προηγούμενο σχόλιο",
      "Un-posted comments": "Μη αναρτημένα σχόλια",
      "Discard Comment": "Προστέθηκαν σχόλια που δεν δημοσιεύτηκαν. Εάν συνεχίσετε, αυτό το σχόλιο θα απορριφθεί.",
      "No Headings": "Δεν βρέθηκε επικεφαλίδα!",
      "Add Headings": "Αυτό το έγγραφο δεν έχει επικεφαλίδες. Προσθέστε επικεφαλίδες και προσπαθήστε ξανά.",
      "More Options": "Περισσότερες επιλογές",
      "Click to see this comment": "Κάντε κλικ για να δείτε αυτό το σχόλιο",
      "Drop Down Form Field": "Αναπτυσσόμενο πεδίο φόρμας",
      "Drop-down items": "Αναπτυσσόμενα στοιχεία",
      "Items in drop-down list": "Στοιχεία στην αναπτυσσόμενη λίστα",
      "ADD": "ΠΡΟΣΘΈΤΩ",
      "REMOVE": "ΑΦΑΙΡΏ",
      "Field settings": "Ρυθμίσεις πεδίου",
      "Tooltip": "Συμβουλή εργαλείου",
      "Drop-down enabled": "Ενεργοποιημένη αναπτυσσόμενη λίστα",
      "Check Box Form Field": "Πεδίο φόρμας πλαισίου ελέγχου",
      "Check box size": "Μέγεθος πλαισίου ελέγχου",
      "Auto": "Αυτοκίνητο",
      "Default value": "Προεπιλεγμένη τιμή",
      "Not checked": "Δεν έχει ελεγχθεί",
      "Checked": "Ελέγχεται",
      "Check box enabled": "Ενεργοποιημένο πλαίσιο ελέγχου",
      "Text Form Field": "Πεδίο φόρμας κειμένου",
      "Type": "Δακτυλογραφώ",
      "Default text": "Προεπιλεγμένο κείμενο",
      "Maximum length": "Μέγιστο μήκος",
      "Text format": "Μορφή κειμένου",
      "Fill-in enabled": "Ενεργοποιημένη συμπλήρωση",
      "Default number": "Προεπιλεγμένος αριθμός",
      "Default date": "Προεπιλεγμένη ημερομηνία",
      "Date format": "Μορφή ημερομηνίας",
      "Merge Track": "Αυτή η ενέργεια δεν θα επισημανθεί ως αλλαγή. Θέλετε να συνεχίσετε;",
      "UnTrack": "Δεν είναι δυνατή η παρακολούθηση",
      "Accept": "Αποδέχομαι",
      "Reject": "Απορρίπτω",
      "Previous Changes": "Προηγούμενες αλλαγές",
      "Next Changes": "Επόμενες αλλαγές",
      "Inserted": "Εισαχθεί",
      "Deleted": "Διαγραφεί",
      "Changes": "Αλλαγές",
      "Accept all": "Αποδοχή όλων",
      "Reject all": "Απόρριψη όλων",
      "No changes": "Καμία αλλαγή",
      "Accept Changes": "Αποδοχή αλλαγών",
      "Reject Changes": "Απόρριψη αλλαγών",
      "User": "Χρήστης",
      "View": "Άποψη",
      "Insertion": "Καταχώριση",
      "Deletion": "Διαγραφή",
      "All caps": "Όλα τα καπάκια",
      "This region is locked by": "Αυτή η περιοχή είναι κλειδωμένη από",
      "Lock": "Κλειδαριά",
      "Unlock": "Ξεκλειδώνω",
      "Already locked": "Η επιλεγμένη περιοχή ή μέρος της περιοχής είναι ήδη κλειδωμένη από άλλο χρήστη",
      "1, 2, 3, ...": "1, 2, 3, ...",
      "a, b, c, ...": "α, β, γ, ...",
      "A, B, C, ...": "Α, Β, Γ, ...",
      "I, II, III, ...": "I, II, III, ...",
      "i, ii, iii, ...": "Ι, ΙΙ, ΙΙΙ, ...",
      "Text Form": "Φόρμα κειμένου",
      "Check Box": "Πλαίσιο ελέγχου",
      "DropDown": "Αναπτυσσόμενο μενού",
      "Form Fields": "Πεδία φόρμας",
      "Fillin enabled": "Ενεργοποιημένη συμπλήρωση",
      "Multiple Comment": "Παρακαλώ δημοσιεύστε το σχόλιό σας",
      "InsertFootnote": "ΕισαγωγήΥποσημείωση",
      "InsertEndnote": "ΕισαγωγήEndnote",
      "Footnote": "Υποσημείωση",
      "Endnote": "Παραπομπή",
      "Click to View/Edit Footnote": "Κάντε κλικ για προβολή/επεξεργασία υποσημείωσης",
      "Click to View/Edit Endnote": "Κάντε κλικ για προβολή/επεξεργασία σημείωσης τέλους",
      "InsertAsRows": "Εισαγωγή ως νέων γραμμών",
      "InsertAsColumns": "Εισαγωγή ως νέων στηλών",
      "OverwriteCells": "Αντικατάσταση κελιών",
      "NestTable": "Πίνακας φωλιάς",
      "No suggestions": "Δεν υπάρχουν προτάσεις",
      "More Suggestion": "Περισσότερες προτάσεις",
      "Ignore Once": "Παράβλεψη μία φορά",
      "Keep With Next": "Συνεχίστε με το επόμενο",
      "Keep Lines Together": "Κρατήστε τις γραμμές μαζί",
      "WidowControl": "Έλεγχος χήρας/ορφανού",
      "Indents and Spacing": "Εσοχές και διαστήματα",
      "Line and Page Breaks": "Αλλαγές γραμμών και σελίδων",
      "Pagination": "Σελιδοποίηση",
      "Single": "Άγαμος",
      "DashSmallGap": "DashSmallGap",
      "DashDot": "DashDot",
      "Double": "Διπλός",
      "ThinThickSmallGap": "ThinThickSmallGap",
      "ThickThinSmallGap": "ThickThinSmallGap",
      "ThickThinMediumGap": "ThickThinMediumGap",
      "ThickThinLargeGap": "ThickThinLargeGap",
      "SingleWavy": "SingleWavy",
      "DoubleWavy": "Διπλόκυματο",
      "Inset": "Ένθετο",
      "DashLargeGap": "DashLargeGap",
      "Dot": "Τελεία",
      "DashDotDot": "DashDotDot",
      "Triple": "Τριπλός",
      "ThinThickThinSmallGap": "ThinThickThinSmallGap",
      "ThinThickThinMediumGap": "ThinThickThinMediumGap",
      "ThinThickThinLargeGap": "ThinThickThinLargeGap",
      "DashDotStroked": "DashDotStroked",
      "Engrave3D": "Χαράξη3D",
      "Thick": "Πυκνός",
      "Outset": "Αρχή",
      "Emboss3D": "Ανάγλυφο3D",
      "ThinThickLargeGap": "ThinThickLargeGap",
      "ThinThickMediumGap": "ThinThickMediumGap",
      "Number of rows must be between 1 and 32767.": "Ο αριθμός των γραμμών πρέπει να είναι μεταξύ 1 και 32767.",
      "Number of columns must be between 1 and 63.": "Ο αριθμός των στηλών πρέπει να είναι μεταξύ 1 και 63.",
      "Unlimited": "Απεριόριστος",
      "Regular text": "Κανονικό κείμενο",
      "Date": "Ημερομηνία",
      "Uppercase": "Κεφαλαία",
      "Lowercase": "Πεζά",
      "FirstCapital": "ΠρώτηΚεφάλαιο",
      "TitleCase": "Τιτλοθήκη",
      "Filling in forms": "Συμπλήρωση εντύπων",
      "px": "PX",
      "Tracked changes": "Εντοπισμένες αλλαγές",
      "TrackChangesOnly": "Μπορείτε να επεξεργαστείτε σε αυτήν την περιοχή, αλλά όλες οι αλλαγές θα παρακολουθούνται.",
      "RemovedIgnore": "Θέλετε να καταργήσετε τις εξαιρέσεις που αγνοούνται;",
      "RemovedIgnoreExceptions": "Εάν κάνετε αυτήν την αλλαγή στην προστασία εγγράφων, το Word θα αγνοήσει όλες τις εξαιρέσεις σε αυτό το έγγραφο.",
      "Information": "Πληροφορία",
      "Yes": "Ναι",
      "No": "Όχι",
      "Page Break": "Αλλαγή σελίδας",
      "Column Break": "Αλλαγή σελίδας",
      "Section Break Next Page": "Αλλαγή ενότητας (επόμενη σελίδα)",
      "Section Break Continuous": "Αλλαγή ενότητας (επόμενη σελίδα)",
      "Unsupported format": "Η μορφή αρχείου που έχετε επιλέξει δεν υποστηρίζεται. Επιλέξτε έγκυρη μορφή.",
      "One": "Η μορφή αρχείου που έχετε επιλέξει δεν υποστηρίζεται. Επιλέξτε έγκυρη μορφή.",
      "Two": "Ένα",
      "Three": "Δύο",
      "Presets": "Τρεις",
      "Columns": "Προεπιλογές",
      "Split your text into two or more columns": "Στήλες",
      "Line between column": "Χωρίστε το κείμενό σας σε δύο ή περισσότερες στήλες",
      "Width and Spacing": "Γραμμή μεταξύ στηλών",
      "Equal column width": "Πλάτος και απόσταση",
      "Column": "Ίσο πλάτος στήλης",
      "You may format text only with certain styles": "Μπορείτε να μορφοποιήσετε κείμενο μόνο με συγκεκριμένα στυλ.",
      "Ignore all": "Παράβλεψη όλων"
    },
    "documenteditorcontainer": {
      "New": "Νέος",
      "Open": "Ανοίγω",
      "Undo": "Καταστρέφω",
      "Redo": "Ξανακάνω",
      "Image": "Εικόνα",
      "Table": "Τραπέζι",
      "Link": "Σύνδεση",
      "Bookmark": "Σελιδοδείκτης",
      "Table of Contents": "Πίνακας περιεχομένων",
      "HEADING - - - - 1": "ΕΠΙΚΕΦΑΛΊΔΑ - - - - - 1",
      "HEADING - - - - 2": "ΤΟΜΈΑΣ - - - - - 2",
      "HEADING - - - - 3": "ΤΟΜΈΑΣ - - - - - 3",
      "Header": "Κεφαλίδα",
      "Footer": "Υποσέλιδο",
      "Page Setup": "Διαμόρφωση σελίδας",
      "Page Number": "Αριθμός σελίδας",
      "Break": "Σπάζω",
      "Find": "Βρίσκω",
      "Local Clipboard": "Τοπικό πρόχειρο",
      "Restrict Editing": "Περιορισμός επεξεργασίας",
      "Upload from computer": "Μεταφόρτωση από υπολογιστή",
      "By URL": "Ανά διεύθυνση URL",
      "Page Break": "Αλλαγή σελίδας",
      "Section Break": "Αλλαγή ενότητας",
      "Header And Footer": "Κεφαλίδα &; υποσέλιδο",
      "Options": "Επιλογές",
      "Levels": "Επίπεδα",
      "Different First Page": "Διαφορετική πρώτη σελίδα",
      "Different header and footer for odd and even pages": "Διαφορετική κεφαλίδα και υποσέλιδο για μονές και ζυγές σελίδες.",
      "Different Odd And Even Pages": "Διαφορετικές μονές και ζυγές σελίδες",
      "Different header and footer for first page": "Διαφορετική κεφαλίδα και υποσέλιδο για την πρώτη σελίδα.",
      "Position": "Θέση",
      "Header from Top": "Κεφαλίδα από την κορυφή",
      "Footer from Bottom": "Υποσέλιδο από κάτω",
      "Distance from top of the page to top of the header": "Απόσταση από το επάνω μέρος της σελίδας έως την κορυφή της κεφαλίδας.",
      "Distance from bottom of the page to bottom of the footer": "Απόσταση από το κάτω μέρος της σελίδας στο κάτω μέρος του υποσέλιδου.",
      "Aspect ratio": "Αναλογίες",
      "W": "Μέσα",
      "H": "H",
      "Width": "Πλάτος",
      "Height": "Ύψος",
      "Text": "Κείμενο",
      "Paragraph": "Παράγραφος",
      "Fill": "Γεμίζω",
      "Fill color": "Χρώμα γεμίσματος",
      "Border Style": "Στυλ περιγράμματος",
      "Outside borders": "Εξωτερικά σύνορα",
      "All borders": "Όλα τα σύνορα",
      "Inside borders": "Εντός συνόρων",
      "Left border": "Αριστερό περίγραμμα",
      "Inside vertical border": "Εσωτερικό κάθετο περίγραμμα",
      "Right border": "Δεξιό περίγραμμα",
      "Top border": "Επάνω περίγραμμα",
      "Inside horizontal border": "Εσωτερικό οριζόντιο περίγραμμα",
      "Bottom border": "Κάτω περίγραμμα",
      "Border color": "Χρώμα περιγράμματος",
      "Border width": "Πλάτος περιγράμματος",
      "Cell": "Κύτταρο",
      "Merge cells": "Συγχώνευση κελιών",
      "Insert Or Delete": "Εισαγωγή / Διαγραφή",
      "Insert columns to the left": "Εισαγωγή στηλών στα αριστερά",
      "Insert columns to the right": "Εισαγωγή στηλών στα δεξιά",
      "Insert rows above": "Εισαγωγή γραμμών παραπάνω",
      "Insert rows below": "Εισαγωγή γραμμών παρακάτω",
      "Delete rows": "Διαγραφή γραμμών",
      "Delete columns": "Διαγραφή στηλών",
      "Cell Margin": "Περιθώριο κελιού",
      "Top": "Κορυφή",
      "Bottom": "Πυθμένας",
      "Left": "Αριστερά",
      "Right": "Δεξιά",
      "Align Text": "Στοίχιση κειμένου",
      "Align top": "Στοίχιση επάνω",
      "Align bottom": "Στοίχιση κάτω μέρους",
      "Align center": "Στοίχιση στο κέντρο",
      "Number of heading or outline levels to be shown in table of contents": "Αριθμός επιπέδων επικεφαλίδας ή διάρθρωσης που θα εμφανίζονται στον πίνακα περιεχομένων.",
      "Show page numbers": "Εμφάνιση αριθμών σελίδων",
      "Show page numbers in table of contents": "Εμφάνιση αριθμών σελίδων στον πίνακα περιεχομένων.",
      "Right align page numbers": "Δεξιά στοίχιση αριθμών σελίδων",
      "Right align page numbers in table of contents": "Δεξιά στοίχιση αριθμών σελίδων στον πίνακα περιεχομένων.",
      "Use hyperlinks": "Χρήση υπερ-συνδέσεων",
      "Use hyperlinks instead of page numbers": "Χρησιμοποιήστε υπερ-συνδέσεις αντί για αριθμούς σελίδων.",
      "Font": "Κολυμβήθρα",
      "Font Size": "Μέγεθος γραμματοσειράς",
      "Font color": "Χρώμα γραμματοσειράς",
      "Text highlight color": "Χρώμα επισήμανσης κειμένου",
      "Clear all formatting": "Απαλοιφή όλης της μορφοποίησης",
      "Bold Tooltip": "έντονη γραφή (Ctrl+B)",
      "Italic Tooltip": "Πλάγια γραφή (Ctrl+I)",
      "Underline Tooltip": "Υπογράμμιση (Ctrl+U)",
      "Strikethrough": "Διακριτή διαγραφή",
      "Superscript Tooltip": "Εκθέτης (Ctrl+Shift++)",
      "Subscript Tooltip": "Δείκτης (Ctrl+=)",
      "Align left Tooltip": "Στοίχιση αριστερά (Ctrl+L)",
      "Center Tooltip": "Κέντρο (Ctrl+E)",
      "Align right Tooltip": "Στοίχιση δεξιά (Ctrl+R)",
      "Justify Tooltip": "Πλήρης στοίχιση (Ctrl+J)",
      "Decrease indent": "Μείωση εσοχής",
      "Increase indent": "Αύξηση εσοχής",
      "Line spacing": "Διάστιχο",
      "Bullets": "Σφαίρες",
      "Numbering": "Αρίθμηση",
      "Styles": "Στυλ",
      "Manage Styles": "Διαχείριση στυλ",
      "Page": "Σελίδα",
      "of": "από",
      "Fit one page": "Προσαρμογή μίας σελίδας",
      "Spell Check": "Ορθογραφικός έλεγχος",
      "Underline errors": "Υπογράμμιση σφαλμάτων",
      "Fit page width": "Προσαρμογή πλάτους σελίδας",
      "Update": "Ενημερώνω",
      "Cancel": "Ακυρώνω",
      "Insert": "Ενθέτω",
      "No Border": "Χωρίς σύνορα",
      "Create a new document": "Δημιουργήστε ένα νέο έγγραφο.",
      "Open a document": "Ανοίξτε ένα έγγραφο.",
      "Undo Tooltip": "Αναίρεση της τελευταίας λειτουργίας (Ctrl+Z).",
      "Redo Tooltip": "Επαναλάβετε την τελευταία λειτουργία (Ctrl+Y).",
      "Insert inline picture from a file": "Εισαγωγή ενσωματωμένης εικόνας από αρχείο.",
      "Insert a table into the document": "Εισαγωγή πίνακα στο έγγραφο",
      "Create Hyperlink": "Δημιουργήστε μια σύνδεση στο έγγραφό σας για γρήγορη πρόσβαση σε ιστοσελίδες και αρχεία (Ctrl+K).",
      "Insert a bookmark in a specific place in this document": "Εισαγάγετε ένα σελιδοδείκτη σε μια συγκεκριμένη θέση σε αυτό το έγγραφο.",
      "Provide an overview of your document by adding a table of contents": "Δώστε μια επισκόπηση του εγγράφου σας προσθέτοντας έναν πίνακα περιεχομένων.",
      "Add or edit the header": "Προσθέστε ή επεξεργαστείτε την κεφαλίδα.",
      "Add or edit the footer": "Προσθέστε ή επεξεργαστείτε το υποσέλιδο.",
      "Open the page setup dialog": "Ανοίξτε το παράθυρο διαλόγου ρύθμισης σελίδας.",
      "Add page numbers": "Προσθήκη αριθμών σελίδων.",
      "Find Text": "Εύρεση κειμένου στο έγγραφο (Ctrl+F).",
      "Toggle between the internal clipboard and system clipboard": "Εναλλαγή μεταξύ του εσωτερικού προχείρου και του προχείρου συστήματος.</br> Η πρόσβαση στο πρόχειρο του συστήματος μέσω δέσμης ενεργειών δεν επιτρέπεται λόγω της πολιτικής ασφαλείας των προγραμμάτων περιήγησης. Αντ 'αυτού, </br> 1. Μπορείτε να ενεργοποιήσετε το εσωτερικό πρόχειρο για αποκοπή, αντιγραφή και επικόλληση εντός του στοιχείου.</br> 2. Μπορείτε να χρησιμοποιήσετε τις συντομεύσεις πληκτρολογίου (Ctrl + X, Ctrl + C και Ctrl + V) για να κόψετε, να αντιγράψετε και να επικολλήσετε με το πρόχειρο του συστήματος.",
      "Current Page Number": "Ο τρέχων αριθμός σελίδας στο έγγραφο. Κάντε κλικ ή πατήστε για να περιηγηθείτε σε συγκεκριμένη σελίδα.",
      "Read only": "Μόνο για ανάγνωση",
      "Protections": "Προστασία",
      "Error in establishing connection with web server": "Σφάλμα κατά τη δημιουργία σύνδεσης με διακομιστή ιστού",
      "Single": "Άγαμος",
      "Double": "Διπλός",
      "New comment": "Νέο σχόλιο",
      "Comments": "Σχόλια",
      "Print layout": "Διάταξη εκτύπωσης",
      "Web layout": "Διάταξη Web",
      "Text Form": "Φόρμα κειμένου",
      "Check Box": "Πλαίσιο ελέγχου",
      "DropDown": "Αναπτυσσόμενο μενού",
      "Update Fields": "Ενημέρωση πεδίων",
      "Update cross reference fields": "Ενημέρωση πεδίων παραπομπής",
      "Hide properties pane": "Παράθυρο \"Απόκρυψη ιδιοτήτων\"",
      "Show properties pane": "Εμφάνιση παραθύρου ιδιοτήτων",
      "Form Fields": "Πεδία φόρμας",
      "Track Changes": "Παρακολουθώ των αλλαγών που έγιναν στο έγγραφο",
      "TrackChanges": "Παρακολούθηση αλλαγών",
      "AllCaps": "ΌλαΚεφαλαία",
      "Change case Tooltip": "Αλλαγή πεζών-κεφαλαίων",
      "Insert Footnote": "Εισαγωγή υποσημείωσης",
      "Insert Endnote": "Εισαγωγή σημείωσης τέλους",
      "Footnote Tooltip": "Εισαγωγή υποσημείωσης (Alt+Ctrl+F).",
      "Endnote Tooltip": "Εισαγωγή σημείωσης τέλους (Alt+Ctrl+D).",
      "UPPERCASE": "ΚΕΦΑΛΑΊΑ",
      "No color": "Χωρίς χρώμα",
      "Top margin": "Επάνω περιθώριο",
      "Bottom margin": "Κάτω περιθώριο",
      "Left margin": "Αριστερό περιθώριο",
      "Right margin": "Δεξιό περιθώριο",
      "Normal": "Κανονικός",
      "Heading": "Επικεφαλίδα",
      "Heading 1": "Τομέας 1",
      "Heading 2": "Τομέας 2",
      "Heading 3": "Τομέας 3",
      "Heading 4": "Τομέας 4",
      "Heading 5": "Τομέας 5",
      "Heading 6": "Τομέας 6",
      "ZoomLevelTooltip": "Επίπεδο ζουμ. Κάντε κλικ ή πατήστε για να ανοίξετε τις επιλογές ζουμ.",
      "None": "Κανένας",
      "Borders": "Σύνορο",
      "ShowHiddenMarks Tooltip": "Εμφανίστε τους κρυφούς χαρακτήρες, όπως κενά, στηλοθέτες, σημάδια παραγράφου και αλλαγές. (Ctrl + *)",
      "Columns": "Εμφανίστε τους κρυφούς χαρακτήρες, όπως κενά, στηλοθέτες, σημάδια παραγράφου και αλλαγές. (Ctrl + *)",
      "Column Break": "Στήλες"
    },
    "carousel": {
      "nextSlide": "Επόμενη διαφάνεια",
      "of": "από",
      "pauseSlideTransition": "Παύση μετάβασης διαφάνειας",
      "playSlideTransition": "Αναπαραγωγή μετάβασης διαφανειών",
      "previousSlide": "Προηγούμενη διαφάνεια",
      "slide": "Τσουλήθρα",
      "slideShow": "Παρουσίασης"
    },
    "message": {
      "close": "Κλείνω"
    },
    "image-editor": {
      "Crop": "Περικόπτω",
      "ZoomIn": "Μεγέθυνση",
      "ZoomOut": "Σμίκρυνση",
      "Transform": "Μετασχηματίζω",
      "Annotation": "Σχόλιο",
      "Text": "Προσθήκη κειμένου",
      "Pen": "Στυλό",
      "Reset": "Επαναφορά",
      "Save": "Σώζω",
      "Select": "Διαλέγω",
      "RotateLeft": "Περιστροφή προς τα αριστερά",
      "RotateRight": "Περιστροφή προς τα δεξιά",
      "HorizontalFlip": "Οριζόντια αναστροφή",
      "VerticalFlip": "Κάθετη αναστροφή",
      "OK": "OK",
      "Cancel": "Ακυρώνω",
      "FillColor": "Χρώμα γεμίσματος",
      "StrokeColor": "Χρώμα περιγράμματος",
      "StrokeWidth": "Πλάτος περιγράμματος",
      "FontFamily": "Οικογένεια γραμματοσειρών",
      "FontStyle": "Στυλ γραμματοσειράς",
      "FontSize": "Μέγεθος γραμματοσειράς",
      "FontColor": "Χρώμα γραμματοσειράς",
      "Pan": "Κύριος",
      "Move": "Κινώ",
      "Custom": "Συνήθεια",
      "Square": "Πλατεία",
      "Circle": "Κύκλος",
      "Rectangle": "Ορθογώνιο",
      "Line": "Γραμμή",
      "Default": "Προεπιλογή",
      "Bold": "Τολμηρός",
      "Italic": "Πλάγια γραφή",
      "BoldItalic": "Έντονη πλάγια γραφή",
      "XSmall": "X-Μικρό",
      "Small": "Μικρός",
      "Medium": "Μέτριος",
      "Large": "Μεγάλος",
      "XLarge": "X-Μεγάλο",
      "ABC": "ΑΒΓ",
      "Finetune": "Τελειοποίηση",
      "Brightness": "Φωτεινότητα",
      "Contrast": "Αντιπαραβάλλω",
      "Hue": "Απόχρωση",
      "Saturation": "Κορεσμός",
      "Opacity": "Αδιαφάνεια",
      "Blur": "Θάμπωμα",
      "Exposure": "Εκθεση",
      "Filter": "Φίλτρο",
      "Chrome": "Χρώμιο",
      "Cold": "Κρύο",
      "Warm": "Ζεστός",
      "Grayscale": "Κλίμακα του γκρι",
      "Sepia": "Σουπιά",
      "Invert": "Αντιστρέφω"
    },
    "mention": {
      "noRecordsTemplate": "Δεν βρέθηκαν εγγραφές"
    }
  }
}
